var _path, _g, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 735.527,
    height: 468.629,
    viewBox: "0 0 735.527 468.629",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3720",
    "data-name": "Raggruppa 3720",
    transform: "translate(-303.942 -331.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3721",
    "data-name": "Raggruppa 3721"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_956",
    "data-name": "Rettangolo 956",
    width: 685.683,
    height: 423.353,
    rx: 50,
    transform: "translate(328.645 353.659)",
    fill: "#0559a1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rettangolo_966",
    "data-name": "Rettangolo 966",
    d: "M50,3A46.959,46.959,0,0,0,3,50V418.629a46.958,46.958,0,0,0,47,47H685.527a46.959,46.959,0,0,0,47-47V50a46.959,46.959,0,0,0-47-47H50m0-3H685.527a50,50,0,0,1,50,50V418.629a50,50,0,0,1-50,50H50a50,50,0,0,1-50-50V50A50,50,0,0,1,50,0Z",
    transform: "translate(303.942 331.715)",
    fill: "#0760a6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4614",
    "data-name": "Tracciato 4614",
    d: "M39.208,4.344a.752.752,0,0,0-1.5,0V14.36a.7.7,0,0,0,.752.736.681.681,0,0,0,.752-.736ZM41.56,14.376a.637.637,0,0,0,.352.64,1.1,1.1,0,0,0,.384.08.665.665,0,0,0,.736-.72V10.9a5.541,5.541,0,0,1,.08-1.264,2.122,2.122,0,0,1,2.144-1.824,1.448,1.448,0,0,1,1.584,1.6c0,.144.032.336.032,1.184v3.776a.65.65,0,0,0,.352.64,1.1,1.1,0,0,0,.384.08.665.665,0,0,0,.736-.72V9.848a3.637,3.637,0,0,0-.56-2.384,2.727,2.727,0,0,0-2.208-.912A2.93,2.93,0,0,0,43,7.752c0-.64,0-.88-.352-1.056a.976.976,0,0,0-.736,0,.629.629,0,0,0-.352.624Zm14.656,3.008a.637.637,0,0,0,.352.64.949.949,0,0,0,.368.08.671.671,0,0,0,.736-.72V7.336a.608.608,0,0,0-.368-.624.743.743,0,0,0-.368-.1.667.667,0,0,0-.656.368,1.455,1.455,0,0,0-.08.672,3.035,3.035,0,0,0-2.5-1.1c-2.256,0-3.552,1.744-3.552,4.256a5.393,5.393,0,0,0,.832,3.1,3.026,3.026,0,0,0,2.608,1.248,3.1,3.1,0,0,0,2.624-1.216Zm0-6.48c0,1.9-.848,3.04-2.32,3.04-2.176,0-2.24-2.352-2.24-3.136,0-1.776.688-3.072,2.256-3.072a2.045,2.045,0,0,1,1.76.9A4.05,4.05,0,0,1,56.216,10.9ZM66.664,7.352a.744.744,0,0,0-1.488,0v3.5A5.6,5.6,0,0,1,65.1,12.2a2.131,2.131,0,0,1-2.16,1.7,1.429,1.429,0,0,1-1.312-.672,3.925,3.925,0,0,1-.256-1.9V7.336a.744.744,0,0,0-1.488.016V11.8a3.622,3.622,0,0,0,.688,2.544,2.846,2.846,0,0,0,2.128.816,2.766,2.766,0,0,0,2.544-1.216c0,.64,0,.9.336,1.072a.976.976,0,0,0,.736,0,.655.655,0,0,0,.352-.624Zm8.32,2.3a3.254,3.254,0,0,0-.544-2.24,3.165,3.165,0,0,0-2.48-.864A3.226,3.226,0,0,0,69.1,7.816a2.074,2.074,0,0,0-.336.928c0,.288.16.624.752.624.544,0,.624-.288.672-.512.144-.432.384-1.12,1.776-1.12.288,0,1.664,0,1.664,1.36,0,.4-.112.528-.448.624-.144.048-.432.112-.976.224l-1.36.288c-.864.176-2.432.48-2.432,2.384A2.451,2.451,0,0,0,71.1,15.16a3.155,3.155,0,0,0,2.576-1.184,1.919,1.919,0,0,0,.064.768.635.635,0,0,0,.608.352.6.6,0,0,0,.64-.64Zm-2.448,1.36a4.816,4.816,0,0,0,1.088-.3,4.131,4.131,0,0,1-.448,2.4,2.239,2.239,0,0,1-1.76.848,1.338,1.338,0,0,1-1.488-1.328,1.232,1.232,0,0,1,.96-1.216,5.516,5.516,0,0,1,.816-.208ZM84.328,4.328a.637.637,0,0,0-.352-.64.79.79,0,0,0-.368-.08.682.682,0,0,0-.624.352.949.949,0,0,0-.08.368V7.784a3.076,3.076,0,0,0-2.64-1.232c-2.56,0-3.456,2.224-3.456,4.256,0,2.256,1.024,4.352,3.552,4.352a3.312,3.312,0,0,0,1.888-.528,2.9,2.9,0,0,0,.672-.624,1.591,1.591,0,0,0,.048.72.68.68,0,0,0,.64.368.65.65,0,0,0,.72-.7ZM82.92,10.872c0,.384,0,2.176-1.28,2.832a2.222,2.222,0,0,1-1.088.24c-1.872,0-2.224-1.68-2.224-3.072a6.432,6.432,0,0,1,.1-1.1A2.1,2.1,0,0,1,80.536,7.8a2.074,2.074,0,0,1,1.9,1.008A3.878,3.878,0,0,1,82.92,10.872Zm5.008-3.584a.7.7,0,0,0-1.392,0v7.136c0,.224.064.672.72.672.688,0,.736-.416.736-.672V11.24a3.021,3.021,0,0,1,1.056-2.816,3.067,3.067,0,0,1,1.248-.4.67.67,0,0,0,.672-.688c0-.72-.7-.72-.88-.72a2.282,2.282,0,0,0-2.16,1.5Zm10.24,2.368a3.254,3.254,0,0,0-.544-2.24,3.165,3.165,0,0,0-2.48-.864A3.226,3.226,0,0,0,92.28,7.816a2.074,2.074,0,0,0-.336.928c0,.288.16.624.752.624.544,0,.624-.288.672-.512.144-.432.384-1.12,1.776-1.12.288,0,1.664,0,1.664,1.36,0,.4-.112.528-.448.624-.144.048-.432.112-.976.224l-1.36.288c-.864.176-2.432.48-2.432,2.384A2.451,2.451,0,0,0,94.28,15.16a3.155,3.155,0,0,0,2.576-1.184,1.919,1.919,0,0,0,.064.768.635.635,0,0,0,.608.352.6.6,0,0,0,.64-.64Zm-2.448,1.36a4.816,4.816,0,0,0,1.088-.3,4.131,4.131,0,0,1-.448,2.4,2.239,2.239,0,0,1-1.76.848,1.338,1.338,0,0,1-1.488-1.328,1.232,1.232,0,0,1,.96-1.216,5.516,5.516,0,0,1,.816-.208Zm10.8-3.7a.728.728,0,0,0-1.456,0v7.056a.684.684,0,0,0,.736.72.669.669,0,0,0,.64-.368.815.815,0,0,0,.08-.352Zm-1.632-2.8a.9.9,0,0,0,1.792,0,.9.9,0,1,0-1.792,0Zm5.3-.208a.661.661,0,0,0-.736-.7.67.67,0,0,0-.736.7V14.376a.736.736,0,0,0,1.472,0ZM126.36,15.288a.7.7,0,0,0,.464.208.8.8,0,0,0,.736-.736.657.657,0,0,0-.208-.464l-1.072-1.088a5.512,5.512,0,0,0,.992-2.1,7.372,7.372,0,0,0,.192-1.744c0-3.648-2.144-5.84-5.344-5.84a5.072,5.072,0,0,0-4.7,2.848,6.751,6.751,0,0,0-.624,2.992c0,3.552,2.08,5.792,5.328,5.792a4.938,4.938,0,0,0,3.136-.96ZM124.5,11.4a.589.589,0,0,0-.336-.128.935.935,0,0,0-.832.816.488.488,0,0,0,.144.336l.752.768a3.484,3.484,0,0,1-2.1.656c-2.448,0-3.76-1.936-3.76-4.512,0-2.9,1.68-4.512,3.744-4.512,2.176,0,3.76,1.664,3.76,4.4a6.145,6.145,0,0,1-.688,2.9Zm8.4-1.1c2.368,0,2.912.08,3.2,2.112a11.48,11.48,0,0,0,.32,1.792c.176.592.416.912.864.912.368,0,.72-.176.72-.784a3.894,3.894,0,0,0-.1-.7c-.1-.48-.1-.528-.192-1.072l-.1-.64a3.728,3.728,0,0,0-.464-1.536,1.605,1.605,0,0,0-1.312-.736,2.265,2.265,0,0,0,1.008-.432,2.728,2.728,0,0,0,1.072-2.288A3.048,3.048,0,0,0,136.9,4.456a4.876,4.876,0,0,0-3.12-.768H130.3a.69.69,0,0,0-.576.192.73.73,0,0,0-.176.56v9.936a.679.679,0,0,0,.752.72.7.7,0,0,0,.656-.352.949.949,0,0,0,.08-.368V10.3Zm-1.872-5.28h1.7c1.6,0,2.688.016,3.264.7A1.876,1.876,0,0,1,136.376,7a1.77,1.77,0,0,1-1.328,1.9,8.725,8.725,0,0,1-1.76.112h-2.256Zm18.736,8.848A3.326,3.326,0,0,1,146.9,12.5a5.149,5.149,0,0,1-.832-3.072,4.892,4.892,0,0,1,1.344-3.76,3.321,3.321,0,0,1,2.32-.784A3.063,3.063,0,0,1,152.9,6.92c.208.416.32.656.72.656.368,0,.816-.24.816-.656a3.7,3.7,0,0,0-.864-1.872,4.867,4.867,0,0,0-3.856-1.52,5.016,5.016,0,0,0-3.888,1.584,6.45,6.45,0,0,0-1.376,4.32,6.337,6.337,0,0,0,1.248,4.112,4.82,4.82,0,0,0,4.064,1.616,4.881,4.881,0,0,0,4.24-2.032,3.5,3.5,0,0,0,.576-1.36c0-.464-.576-.608-.816-.608-.464,0-.608.3-.784.72A3.331,3.331,0,0,1,149.768,13.864Zm13.824-3.088c0-2.736-1.568-4.24-3.92-4.24a3.912,3.912,0,0,0-3.008,1.2,4.7,4.7,0,0,0-.992,3.152A4.647,4.647,0,0,0,156.7,14.04a3.662,3.662,0,0,0,2.9,1.12,3.744,3.744,0,0,0,2.944-1.168A4.761,4.761,0,0,0,163.592,10.776Zm-3.968,3.2a2.34,2.34,0,0,1-1.856-.816,3.807,3.807,0,0,1-.592-2.272,4.014,4.014,0,0,1,.544-2.208,2.195,2.195,0,0,1,1.888-.912c1.952,0,2.464,1.552,2.464,3.1a3.739,3.739,0,0,1-.592,2.24A2.291,2.291,0,0,1,159.624,13.976Zm12.9-9.648a.637.637,0,0,0-.352-.64.79.79,0,0,0-.368-.08.682.682,0,0,0-.624.352.949.949,0,0,0-.08.368V7.784a3.076,3.076,0,0,0-2.64-1.232c-2.56,0-3.456,2.224-3.456,4.256,0,2.256,1.024,4.352,3.552,4.352a3.312,3.312,0,0,0,1.888-.528,2.9,2.9,0,0,0,.672-.624,1.591,1.591,0,0,0,.048.72.68.68,0,0,0,.64.368.65.65,0,0,0,.72-.7Zm-1.408,6.544c0,.384,0,2.176-1.28,2.832a2.222,2.222,0,0,1-1.088.24c-1.872,0-2.224-1.68-2.224-3.072a6.431,6.431,0,0,1,.1-1.1A2.1,2.1,0,0,1,168.728,7.8a2.074,2.074,0,0,1,1.9,1.008A3.878,3.878,0,0,1,171.112,10.872Zm10.1.384a.651.651,0,0,0,.72-.72,4.8,4.8,0,0,0-.8-2.672,3.089,3.089,0,0,0-1.84-1.2,4.5,4.5,0,0,0-1.04-.112c-2.832,0-3.92,2.352-3.92,4.368a4.726,4.726,0,0,0,1.056,3.12,3.655,3.655,0,0,0,2.912,1.12,3.84,3.84,0,0,0,2.992-1.248,2.154,2.154,0,0,0,.512-.848.493.493,0,0,0,.016-.16c0-.464-.48-.672-.832-.672s-.432.16-.688.592a2.1,2.1,0,0,1-2,1.1,2.148,2.148,0,0,1-1.84-.784,3.076,3.076,0,0,1-.624-1.888Zm-5.36-1.2a2.932,2.932,0,0,1,.864-1.7,2.268,2.268,0,0,1,1.552-.528,2.129,2.129,0,0,1,2.16,2.224Zm12.544,7.312a.661.661,0,0,0,.368.656.949.949,0,0,0,.368.08.681.681,0,0,0,.752-.736V14.024a3.52,3.52,0,0,0,2.64,1.136c2.528,0,3.392-2.336,3.392-4.32,0-2.736-1.52-4.3-3.568-4.3a3.007,3.007,0,0,0-2.464,1.12c0-.48,0-.784-.368-.96a.846.846,0,0,0-.384-.08.665.665,0,0,0-.736.72Zm6-6.5a3.913,3.913,0,0,1-.544,2.256,2.039,2.039,0,0,1-1.7.848c-1.536,0-2.3-1.36-2.3-3.216,0-1.84.816-2.992,2.32-2.992C194.328,7.768,194.392,10.024,194.392,10.872Zm9.808.384a.651.651,0,0,0,.72-.72,4.8,4.8,0,0,0-.8-2.672,3.089,3.089,0,0,0-1.84-1.2,4.5,4.5,0,0,0-1.04-.112c-2.832,0-3.92,2.352-3.92,4.368a4.726,4.726,0,0,0,1.056,3.12,3.655,3.655,0,0,0,2.912,1.12,3.84,3.84,0,0,0,2.992-1.248,2.154,2.154,0,0,0,.512-.848.493.493,0,0,0,.016-.16c0-.464-.48-.672-.832-.672s-.432.16-.688.592a2.1,2.1,0,0,1-2,1.1,2.148,2.148,0,0,1-1.84-.784,3.076,3.076,0,0,1-.624-1.888Zm-5.36-1.2a2.932,2.932,0,0,1,.864-1.7,2.268,2.268,0,0,1,1.552-.528,2.129,2.129,0,0,1,2.16,2.224ZM208.1,7.288a.7.7,0,0,0-1.392,0v7.136c0,.224.064.672.72.672.688,0,.736-.416.736-.672V11.24a3.021,3.021,0,0,1,1.056-2.816,3.067,3.067,0,0,1,1.248-.4.67.67,0,0,0,.672-.688c0-.72-.7-.72-.88-.72a2.282,2.282,0,0,0-2.16,1.5Zm12.432,6.624c-1.936,0-2.352-1.76-2.352-3.136,0-1.552.656-3.008,2.352-3.008A1.908,1.908,0,0,1,222.392,8.9c.176.368.32.672.768.672a.73.73,0,0,0,.784-.7c0-.112,0-.3-.336-.832a3.122,3.122,0,0,0-3.024-1.488,3.573,3.573,0,0,0-3.648,2.432,5.563,5.563,0,0,0-.288,1.856c0,2,.944,4.32,3.856,4.32a3.347,3.347,0,0,0,3.264-1.7,2.015,2.015,0,0,0,.336-.96c0-.56-.576-.672-.768-.672-.432,0-.576.32-.688.624A2.113,2.113,0,0,1,220.536,13.912ZM232.9,10.776c0-2.736-1.568-4.24-3.92-4.24a3.912,3.912,0,0,0-3.008,1.2,4.7,4.7,0,0,0-.992,3.152,4.647,4.647,0,0,0,1.024,3.152,3.662,3.662,0,0,0,2.9,1.12,3.744,3.744,0,0,0,2.944-1.168A4.761,4.761,0,0,0,232.9,10.776Zm-3.968,3.2a2.34,2.34,0,0,1-1.856-.816,3.807,3.807,0,0,1-.592-2.272,4.014,4.014,0,0,1,.544-2.208,2.195,2.195,0,0,1,1.888-.912c1.952,0,2.464,1.552,2.464,3.1a3.739,3.739,0,0,1-.592,2.24A2.291,2.291,0,0,1,228.936,13.976Zm5.776.4a.637.637,0,0,0,.352.64,1.1,1.1,0,0,0,.384.08.665.665,0,0,0,.736-.72V10.9a5.54,5.54,0,0,1,.08-1.264,2.122,2.122,0,0,1,2.144-1.824,1.448,1.448,0,0,1,1.584,1.6c0,.144.032.336.032,1.184v3.776a.65.65,0,0,0,.352.64,1.1,1.1,0,0,0,.384.08.665.665,0,0,0,.736-.72V9.848a3.637,3.637,0,0,0-.56-2.384,2.727,2.727,0,0,0-2.208-.912,2.93,2.93,0,0,0-2.576,1.2c0-.64,0-.88-.352-1.056a.976.976,0,0,0-.736,0,.629.629,0,0,0-.352.624Zm9.1-1.728c0,1.248,0,2.448,2.224,2.448.432,0,.944-.064.944-.624s-.4-.592-.784-.608c-.432-.032-.736-.112-.848-.576a4.914,4.914,0,0,1-.064-1.264V7.96h.992a.568.568,0,0,0,.608-.624.553.553,0,0,0-.608-.624h-.992V4.84c0-.224-.048-.688-.736-.688a.639.639,0,0,0-.72.688V6.712h-.864a.559.559,0,0,0-.608.624.568.568,0,0,0,.608.624h.848Zm5.952-5.36a.7.7,0,0,0-1.392,0v7.136c0,.224.064.672.72.672.688,0,.736-.416.736-.672V11.24a3.021,3.021,0,0,1,1.056-2.816,3.067,3.067,0,0,1,1.248-.4.67.67,0,0,0,.672-.688c0-.72-.7-.72-.88-.72a2.282,2.282,0,0,0-2.16,1.5Zm5.728.032a.728.728,0,0,0-1.456,0v7.056a.684.684,0,0,0,.736.72.669.669,0,0,0,.64-.368.814.814,0,0,0,.08-.352Zm-1.632-2.8a.9.9,0,0,0,1.792,0,.9.9,0,1,0-1.792,0Zm5.28-.192a.637.637,0,0,0-.352-.64.949.949,0,0,0-.368-.08.689.689,0,0,0-.64.352.949.949,0,0,0-.08.368V14.392a.616.616,0,0,0,.352.624.753.753,0,0,0,.384.08.684.684,0,0,0,.624-.336,1.309,1.309,0,0,0,.08-.656,3.2,3.2,0,0,0,2.512,1.072c2.128,0,3.568-1.616,3.568-4.3,0-1.68-.624-4.32-3.472-4.32a3.056,3.056,0,0,0-2.608,1.2Zm4.544,6.56c0,1.776-.528,2.528-1.248,2.88a2.3,2.3,0,0,1-.992.208c-1.9,0-2.32-1.888-2.32-3.152a3.035,3.035,0,0,1,1.264-2.8,2.383,2.383,0,0,1,1.1-.256C263.672,7.768,263.688,10.216,263.688,10.888Zm10.128-3.536a.744.744,0,0,0-1.488,0v3.5a5.6,5.6,0,0,1-.08,1.344,2.131,2.131,0,0,1-2.16,1.7,1.429,1.429,0,0,1-1.312-.672,3.925,3.925,0,0,1-.256-1.9V7.336a.744.744,0,0,0-1.488.016V11.8a3.622,3.622,0,0,0,.688,2.544,2.846,2.846,0,0,0,2.128.816,2.766,2.766,0,0,0,2.544-1.216c0,.64,0,.9.336,1.072a.976.976,0,0,0,.736,0,.655.655,0,0,0,.352-.624Zm3.664-.032a.728.728,0,0,0-1.456,0v7.056a.684.684,0,0,0,.736.72.669.669,0,0,0,.64-.368.814.814,0,0,0,.08-.352Zm-1.632-2.8a.9.9,0,0,0,1.792,0,.9.9,0,1,0-1.792,0Zm5.232,2.768a.7.7,0,0,0-1.392,0v7.136c0,.224.064.672.72.672.688,0,.736-.416.736-.672V11.24A3.021,3.021,0,0,1,282.2,8.424a3.067,3.067,0,0,1,1.248-.4.67.67,0,0,0,.672-.688c0-.72-.7-.72-.88-.72a2.282,2.282,0,0,0-2.16,1.5Zm10.432,3.968a.651.651,0,0,0,.72-.72,4.8,4.8,0,0,0-.8-2.672,3.089,3.089,0,0,0-1.84-1.2,4.5,4.5,0,0,0-1.04-.112c-2.832,0-3.92,2.352-3.92,4.368a4.726,4.726,0,0,0,1.056,3.12,3.655,3.655,0,0,0,2.912,1.12,3.84,3.84,0,0,0,2.992-1.248,2.154,2.154,0,0,0,.512-.848.494.494,0,0,0,.016-.16c0-.464-.48-.672-.832-.672s-.432.16-.688.592a2.1,2.1,0,0,1-2,1.1,2.148,2.148,0,0,1-1.84-.784,3.076,3.076,0,0,1-.624-1.888Zm-5.36-1.2a2.931,2.931,0,0,1,.864-1.7,2.268,2.268,0,0,1,1.552-.528,2.129,2.129,0,0,1,2.16,2.224Zm18.656-.4a3.254,3.254,0,0,0-.544-2.24,3.165,3.165,0,0,0-2.48-.864,3.226,3.226,0,0,0-2.864,1.264,2.074,2.074,0,0,0-.336.928c0,.288.16.624.752.624.544,0,.624-.288.672-.512.144-.432.384-1.12,1.776-1.12.288,0,1.664,0,1.664,1.36,0,.4-.112.528-.448.624-.144.048-.432.112-.976.224l-1.36.288c-.864.176-2.432.48-2.432,2.384a2.451,2.451,0,0,0,2.688,2.544,3.155,3.155,0,0,0,2.576-1.184,1.92,1.92,0,0,0,.064.768.635.635,0,0,0,.608.352.6.6,0,0,0,.64-.64Zm-2.448,1.36a4.816,4.816,0,0,0,1.088-.3,4.13,4.13,0,0,1-.448,2.4,2.239,2.239,0,0,1-1.76.848,1.338,1.338,0,0,1-1.488-1.328,1.232,1.232,0,0,1,.96-1.216,5.516,5.516,0,0,1,.816-.208ZM314.3,9.9c-.736-.224-1.376-.416-1.376-1.152a1.024,1.024,0,0,1,.464-.848,1.734,1.734,0,0,1,.928-.224,1.891,1.891,0,0,1,1.84,1.024c.24.464.336.64.688.64a.635.635,0,0,0,.672-.624c0-.32-.432-2.16-3.136-2.16-2.752,0-2.912,1.968-2.912,2.384,0,1.536,1.36,1.984,2.24,2.272l.928.272c.816.24,1.552.448,1.552,1.28,0,.752-.7,1.248-1.648,1.248a1.978,1.978,0,0,1-1.712-.784,3.946,3.946,0,0,1-.352-.848.524.524,0,0,0-.544-.352c-.24,0-.784.128-.784.672a2.556,2.556,0,0,0,.88,1.728,3.839,3.839,0,0,0,2.416.736,4.006,4.006,0,0,0,2.192-.56,2.282,2.282,0,0,0,1.008-1.968c0-1.744-1.552-2.192-2.416-2.448Zm12.592.88c0-2.736-1.568-4.24-3.92-4.24a3.912,3.912,0,0,0-3.008,1.2,4.7,4.7,0,0,0-.992,3.152,4.647,4.647,0,0,0,1.024,3.152,3.662,3.662,0,0,0,2.9,1.12,3.744,3.744,0,0,0,2.944-1.168A4.761,4.761,0,0,0,326.888,10.776Zm-3.968,3.2a2.34,2.34,0,0,1-1.856-.816,3.807,3.807,0,0,1-.592-2.272,4.014,4.014,0,0,1,.544-2.208,2.195,2.195,0,0,1,1.888-.912c1.952,0,2.464,1.552,2.464,3.1a3.739,3.739,0,0,1-.592,2.24A2.291,2.291,0,0,1,322.92,13.976Zm8.368-4.08c-.736-.224-1.376-.416-1.376-1.152a1.024,1.024,0,0,1,.464-.848,1.734,1.734,0,0,1,.928-.224,1.891,1.891,0,0,1,1.84,1.024c.24.464.336.64.688.64a.635.635,0,0,0,.672-.624c0-.32-.432-2.16-3.136-2.16-2.752,0-2.912,1.968-2.912,2.384,0,1.536,1.36,1.984,2.24,2.272l.928.272c.816.24,1.552.448,1.552,1.28,0,.752-.7,1.248-1.648,1.248a1.978,1.978,0,0,1-1.712-.784,3.946,3.946,0,0,1-.352-.848.524.524,0,0,0-.544-.352c-.24,0-.784.128-.784.672a2.556,2.556,0,0,0,.88,1.728,3.839,3.839,0,0,0,2.416.736,4.006,4.006,0,0,0,2.192-.56,2.282,2.282,0,0,0,1.008-1.968c0-1.744-1.552-2.192-2.416-2.448Zm5.184,2.752c0,1.248,0,2.448,2.224,2.448.432,0,.944-.064.944-.624s-.4-.592-.784-.608c-.432-.032-.736-.112-.848-.576a4.913,4.913,0,0,1-.064-1.264V7.96h.992a.568.568,0,0,0,.608-.624.553.553,0,0,0-.608-.624h-.992V4.84c0-.224-.048-.688-.736-.688a.639.639,0,0,0-.72.688V6.712h-.864a.559.559,0,0,0-.608.624.568.568,0,0,0,.608.624h.848Zm11.04-1.392a.651.651,0,0,0,.72-.72,4.8,4.8,0,0,0-.8-2.672,3.089,3.089,0,0,0-1.84-1.2,4.5,4.5,0,0,0-1.04-.112c-2.832,0-3.92,2.352-3.92,4.368a4.726,4.726,0,0,0,1.056,3.12,3.655,3.655,0,0,0,2.912,1.12,3.84,3.84,0,0,0,2.992-1.248,2.154,2.154,0,0,0,.512-.848.494.494,0,0,0,.016-.16c0-.464-.48-.672-.832-.672s-.432.16-.688.592a2.1,2.1,0,0,1-2,1.1,2.148,2.148,0,0,1-1.84-.784,3.076,3.076,0,0,1-.624-1.888Zm-5.36-1.2a2.931,2.931,0,0,1,.864-1.7,2.268,2.268,0,0,1,1.552-.528,2.129,2.129,0,0,1,2.16,2.224Zm7.872,4.32a.637.637,0,0,0,.352.64,1.1,1.1,0,0,0,.384.08.665.665,0,0,0,.736-.72V10.9a5.54,5.54,0,0,1,.08-1.264,2.122,2.122,0,0,1,2.144-1.824,1.448,1.448,0,0,1,1.584,1.6c0,.144.032.336.032,1.184v3.776a.65.65,0,0,0,.352.64,1.1,1.1,0,0,0,.384.08.665.665,0,0,0,.736-.72V9.848a3.637,3.637,0,0,0-.56-2.384,2.727,2.727,0,0,0-2.208-.912,2.93,2.93,0,0,0-2.576,1.2c0-.64,0-.88-.352-1.056a.976.976,0,0,0-.736,0,.629.629,0,0,0-.352.624Zm15.472-3.12a.651.651,0,0,0,.72-.72,4.8,4.8,0,0,0-.8-2.672,3.089,3.089,0,0,0-1.84-1.2,4.5,4.5,0,0,0-1.04-.112c-2.832,0-3.92,2.352-3.92,4.368a4.726,4.726,0,0,0,1.056,3.12,3.655,3.655,0,0,0,2.912,1.12,3.84,3.84,0,0,0,2.992-1.248,2.154,2.154,0,0,0,.512-.848.494.494,0,0,0,.016-.16c0-.464-.48-.672-.832-.672s-.432.16-.688.592a2.1,2.1,0,0,1-2,1.1,2.148,2.148,0,0,1-1.84-.784,3.076,3.076,0,0,1-.624-1.888Zm-5.36-1.2A2.931,2.931,0,0,1,361,8.36a2.268,2.268,0,0,1,1.552-.528,2.129,2.129,0,0,1,2.16,2.224ZM369.4,7.288a.7.7,0,0,0-1.392,0v7.136c0,.224.064.672.72.672.688,0,.736-.416.736-.672V11.24a3.021,3.021,0,0,1,1.056-2.816,3.067,3.067,0,0,1,1.248-.4.67.67,0,0,0,.672-.688c0-.72-.7-.72-.88-.72a2.282,2.282,0,0,0-2.16,1.5Zm10.432,3.968a.651.651,0,0,0,.72-.72,4.8,4.8,0,0,0-.8-2.672,3.089,3.089,0,0,0-1.84-1.2,4.5,4.5,0,0,0-1.04-.112c-2.832,0-3.92,2.352-3.92,4.368a4.726,4.726,0,0,0,1.056,3.12,3.655,3.655,0,0,0,2.912,1.12,3.84,3.84,0,0,0,2.992-1.248,2.154,2.154,0,0,0,.512-.848.494.494,0,0,0,.016-.16c0-.464-.48-.672-.832-.672s-.432.16-.688.592a2.1,2.1,0,0,1-2,1.1,2.148,2.148,0,0,1-1.84-.784,3.076,3.076,0,0,1-.624-1.888Zm-5.36-1.2a2.931,2.931,0,0,1,.864-1.7,2.268,2.268,0,0,1,1.552-.528,2.129,2.129,0,0,1,2.16,2.224Zm14-5.744a.661.661,0,0,0-.736-.7.67.67,0,0,0-.736.7V14.376a.736.736,0,0,0,1.472,0Zm2.64,1.1a1.555,1.555,0,0,1-.368,1.232c-.288.3-.352.384-.352.544a.438.438,0,0,0,.4.448c.464,0,1.424-1.376,1.424-2.784a1.214,1.214,0,0,0-.432-1.056,1.078,1.078,0,0,0-.608-.192.917.917,0,0,0-.912.976.831.831,0,0,0,.3.7A.724.724,0,0,0,391.112,5.416Zm4.352,1.9a.728.728,0,0,0-1.456,0v7.056a.684.684,0,0,0,.736.72.669.669,0,0,0,.64-.368.814.814,0,0,0,.08-.352Zm-1.632-2.8a.9.9,0,0,0,1.792,0,.9.9,0,1,0-1.792,0Zm3.84,9.856a.677.677,0,0,0,.752.72.7.7,0,0,0,.656-.368.936.936,0,0,0,.08-.352V10.712a3.492,3.492,0,0,1,.384-2.032,1.82,1.82,0,0,1,1.632-.848,1.377,1.377,0,0,1,1.456,1.36,8.23,8.23,0,0,1,.032,1.136v4.048a.616.616,0,0,0,.352.624.852.852,0,0,0,.384.1.833.833,0,0,0,.384-.1.616.616,0,0,0,.352-.624V10.408a2.842,2.842,0,0,1,.352-1.728,1.9,1.9,0,0,1,1.632-.848c1.456,0,1.5,1.232,1.5,1.76,0,.256.016.7.016,1.184V14.36a.617.617,0,0,0,.368.64.743.743,0,0,0,.368.1.681.681,0,0,0,.752-.736V9.576a3.148,3.148,0,0,0-.576-2.192,2.685,2.685,0,0,0-2.208-.848,3.156,3.156,0,0,0-2.592,1.3,2.057,2.057,0,0,0-.912-.976,2.726,2.726,0,0,0-1.376-.32,2.767,2.767,0,0,0-2.336,1.12c0-.544,0-.8-.336-.96a.918.918,0,0,0-.768,0,.6.6,0,0,0-.352.608Zm13.664,2.992a.661.661,0,0,0,.368.656.949.949,0,0,0,.368.08.681.681,0,0,0,.752-.736V14.024a3.52,3.52,0,0,0,2.64,1.136c2.528,0,3.392-2.336,3.392-4.32,0-2.736-1.52-4.3-3.568-4.3a3.006,3.006,0,0,0-2.464,1.12c0-.48,0-.784-.368-.96a.846.846,0,0,0-.384-.08.665.665,0,0,0-.736.72Zm6-6.5a3.913,3.913,0,0,1-.544,2.256,2.039,2.039,0,0,1-1.7.848c-1.536,0-2.3-1.36-2.3-3.216,0-1.84.816-2.992,2.32-2.992C417.272,7.768,417.336,10.024,417.336,10.872Zm10.848-.1c0-2.736-1.568-4.24-3.92-4.24a3.912,3.912,0,0,0-3.008,1.2,4.7,4.7,0,0,0-.992,3.152,4.647,4.647,0,0,0,1.024,3.152,3.662,3.662,0,0,0,2.9,1.12,3.744,3.744,0,0,0,2.944-1.168A4.761,4.761,0,0,0,428.184,10.776Zm-3.968,3.2a2.34,2.34,0,0,1-1.856-.816,3.807,3.807,0,0,1-.592-2.272,4.014,4.014,0,0,1,.544-2.208,2.195,2.195,0,0,1,1.888-.912c1.952,0,2.464,1.552,2.464,3.1a3.739,3.739,0,0,1-.592,2.24A2.291,2.291,0,0,1,424.216,13.976Zm7.168-6.688a.7.7,0,0,0-1.392,0v7.136c0,.224.064.672.72.672.688,0,.736-.416.736-.672V11.24A3.021,3.021,0,0,1,432.5,8.424a3.067,3.067,0,0,1,1.248-.4.67.67,0,0,0,.672-.688c0-.72-.7-.72-.88-.72a2.282,2.282,0,0,0-2.16,1.5Zm4.72,5.36c0,1.248,0,2.448,2.224,2.448.432,0,.944-.064.944-.624s-.4-.592-.784-.608c-.432-.032-.736-.112-.848-.576a4.913,4.913,0,0,1-.064-1.264V7.96h.992a.568.568,0,0,0,.608-.624.553.553,0,0,0-.608-.624h-.992V4.84c0-.224-.048-.688-.736-.688a.639.639,0,0,0-.72.688V6.712h-.864a.559.559,0,0,0-.608.624.568.568,0,0,0,.608.624h.848Zm10.672-2.992a3.254,3.254,0,0,0-.544-2.24,3.165,3.165,0,0,0-2.48-.864,3.226,3.226,0,0,0-2.864,1.264,2.074,2.074,0,0,0-.336.928c0,.288.16.624.752.624.544,0,.624-.288.672-.512.144-.432.384-1.12,1.776-1.12.288,0,1.664,0,1.664,1.36,0,.4-.112.528-.448.624-.144.048-.432.112-.976.224l-1.36.288c-.864.176-2.432.48-2.432,2.384a2.451,2.451,0,0,0,2.688,2.544,3.155,3.155,0,0,0,2.576-1.184,1.92,1.92,0,0,0,.064.768.635.635,0,0,0,.608.352.6.6,0,0,0,.64-.64Zm-2.448,1.36a4.816,4.816,0,0,0,1.088-.3,4.13,4.13,0,0,1-.448,2.4,2.239,2.239,0,0,1-1.76.848,1.338,1.338,0,0,1-1.488-1.328,1.232,1.232,0,0,1,.96-1.216,5.516,5.516,0,0,1,.816-.208ZM449,14.376a.637.637,0,0,0,.352.64,1.1,1.1,0,0,0,.384.08.665.665,0,0,0,.736-.72V10.9a5.54,5.54,0,0,1,.08-1.264A2.122,2.122,0,0,1,452.7,7.816a1.448,1.448,0,0,1,1.584,1.6c0,.144.032.336.032,1.184v3.776a.65.65,0,0,0,.352.64,1.1,1.1,0,0,0,.384.08.665.665,0,0,0,.736-.72V9.848a3.637,3.637,0,0,0-.56-2.384,2.727,2.727,0,0,0-2.208-.912,2.93,2.93,0,0,0-2.576,1.2c0-.64,0-.88-.352-1.056a.976.976,0,0,0-.736,0A.629.629,0,0,0,449,7.32Zm14.832-6.368a.755.755,0,0,0,.176-.56c0-.7-.352-.736-.592-.736h-5.088a.565.565,0,0,0-.608.624.553.553,0,0,0,.608.624h3.856a2.3,2.3,0,0,0-.5.528c-.144.176-.3.352-.464.528l-3.76,4.5a.844.844,0,0,0-.208.624c0,.848.512.864.688.864H463.5a.64.64,0,0,0,0-1.28h-4.48a9.891,9.891,0,0,0,1.008-1.12Zm7.936,1.648a3.254,3.254,0,0,0-.544-2.24,3.165,3.165,0,0,0-2.48-.864,3.226,3.226,0,0,0-2.864,1.264,2.074,2.074,0,0,0-.336.928c0,.288.16.624.752.624.544,0,.624-.288.672-.512.144-.432.384-1.12,1.776-1.12.288,0,1.664,0,1.664,1.36,0,.4-.112.528-.448.624-.144.048-.432.112-.976.224l-1.36.288c-.864.176-2.432.48-2.432,2.384a2.451,2.451,0,0,0,2.688,2.544,3.155,3.155,0,0,0,2.576-1.184,1.92,1.92,0,0,0,.064.768.635.635,0,0,0,.608.352.6.6,0,0,0,.64-.64Zm-2.448,1.36a4.816,4.816,0,0,0,1.088-.3,4.13,4.13,0,0,1-.448,2.4,2.239,2.239,0,0,1-1.76.848,1.338,1.338,0,0,1-1.488-1.328,1.232,1.232,0,0,1,.96-1.216,5.516,5.516,0,0,1,.816-.208Zm16.464-6.688a.637.637,0,0,0-.352-.64.79.79,0,0,0-.368-.08.682.682,0,0,0-.624.352.949.949,0,0,0-.08.368V7.784a3.076,3.076,0,0,0-2.64-1.232c-2.56,0-3.456,2.224-3.456,4.256,0,2.256,1.024,4.352,3.552,4.352a3.312,3.312,0,0,0,1.888-.528,2.905,2.905,0,0,0,.672-.624,1.59,1.59,0,0,0,.048.72.68.68,0,0,0,.64.368.65.65,0,0,0,.72-.7Zm-1.408,6.544c0,.384,0,2.176-1.28,2.832a2.222,2.222,0,0,1-1.088.24c-1.872,0-2.224-1.68-2.224-3.072a6.432,6.432,0,0,1,.1-1.1A2.1,2.1,0,0,1,481.992,7.8a2.074,2.074,0,0,1,1.9,1.008A3.878,3.878,0,0,1,484.376,10.872Zm10.1.384a.651.651,0,0,0,.72-.72,4.8,4.8,0,0,0-.8-2.672,3.089,3.089,0,0,0-1.84-1.2,4.5,4.5,0,0,0-1.04-.112c-2.832,0-3.92,2.352-3.92,4.368a4.726,4.726,0,0,0,1.056,3.12,3.655,3.655,0,0,0,2.912,1.12,3.84,3.84,0,0,0,2.992-1.248,2.154,2.154,0,0,0,.512-.848.494.494,0,0,0,.016-.16c0-.464-.48-.672-.832-.672s-.432.16-.688.592a2.1,2.1,0,0,1-2,1.1,2.148,2.148,0,0,1-1.84-.784,3.076,3.076,0,0,1-.624-1.888Zm-5.36-1.2a2.931,2.931,0,0,1,.864-1.7,2.268,2.268,0,0,1,1.552-.528,2.129,2.129,0,0,1,2.16,2.224Zm9.328-5.744a.661.661,0,0,0-.736-.7.67.67,0,0,0-.736.7V14.376a.736.736,0,0,0,1.472,0Zm3.664,0a.661.661,0,0,0-.736-.7.67.67,0,0,0-.736.7V14.376a.736.736,0,0,0,1.472,0Zm8.32,5.344a3.254,3.254,0,0,0-.544-2.24,3.165,3.165,0,0,0-2.48-.864,3.226,3.226,0,0,0-2.864,1.264,2.074,2.074,0,0,0-.336.928c0,.288.16.624.752.624.544,0,.624-.288.672-.512.144-.432.384-1.12,1.776-1.12.288,0,1.664,0,1.664,1.36,0,.4-.112.528-.448.624-.144.048-.432.112-.976.224l-1.36.288c-.864.176-2.432.48-2.432,2.384a2.451,2.451,0,0,0,2.688,2.544,3.155,3.155,0,0,0,2.576-1.184,1.92,1.92,0,0,0,.064.768.635.635,0,0,0,.608.352.6.6,0,0,0,.64-.64Zm-2.448,1.36a4.816,4.816,0,0,0,1.088-.3,4.13,4.13,0,0,1-.448,2.4,2.239,2.239,0,0,1-1.76.848,1.338,1.338,0,0,1-1.488-1.328,1.232,1.232,0,0,1,.96-1.216,5.516,5.516,0,0,1,.816-.208ZM141.632,41.368a.661.661,0,0,0,.368.656.949.949,0,0,0,.368.08.681.681,0,0,0,.752-.736V38.024a3.52,3.52,0,0,0,2.64,1.136c2.528,0,3.392-2.336,3.392-4.32,0-2.736-1.52-4.3-3.568-4.3a3.007,3.007,0,0,0-2.464,1.12c0-.48,0-.784-.368-.96a.846.846,0,0,0-.384-.08.665.665,0,0,0-.736.72Zm6-6.5a3.913,3.913,0,0,1-.544,2.256,2.039,2.039,0,0,1-1.7.848c-1.536,0-2.3-1.36-2.3-3.216,0-1.84.816-2.992,2.32-2.992C147.568,31.768,147.632,34.024,147.632,34.872Zm4.72-3.584a.7.7,0,0,0-1.392,0v7.136c0,.224.064.672.72.672.688,0,.736-.416.736-.672V35.24a3.021,3.021,0,0,1,1.056-2.816,3.067,3.067,0,0,1,1.248-.4.67.67,0,0,0,.672-.688c0-.72-.7-.72-.88-.72a2.282,2.282,0,0,0-2.16,1.5Zm11.472,3.488c0-2.736-1.568-4.24-3.92-4.24a3.912,3.912,0,0,0-3.008,1.2,4.7,4.7,0,0,0-.992,3.152,4.647,4.647,0,0,0,1.024,3.152,3.662,3.662,0,0,0,2.9,1.12,3.744,3.744,0,0,0,2.944-1.168A4.761,4.761,0,0,0,163.824,34.776Zm-3.968,3.2A2.34,2.34,0,0,1,158,37.16a3.807,3.807,0,0,1-.592-2.272,4.014,4.014,0,0,1,.544-2.208,2.195,2.195,0,0,1,1.888-.912c1.952,0,2.464,1.552,2.464,3.1a3.739,3.739,0,0,1-.592,2.24A2.291,2.291,0,0,1,159.856,37.976Zm5.888-1.328c0,1.248,0,2.448,2.224,2.448.432,0,.944-.064.944-.624s-.4-.592-.784-.608c-.432-.032-.736-.112-.848-.576a4.914,4.914,0,0,1-.064-1.264V31.96h.992a.568.568,0,0,0,.608-.624.553.553,0,0,0-.608-.624h-.992V28.84c0-.224-.048-.688-.736-.688a.639.639,0,0,0-.72.688v1.872H164.9a.559.559,0,0,0-.608.624.568.568,0,0,0,.608.624h.848Zm11.04-1.392a.651.651,0,0,0,.72-.72,4.8,4.8,0,0,0-.8-2.672,3.089,3.089,0,0,0-1.84-1.2,4.5,4.5,0,0,0-1.04-.112c-2.832,0-3.92,2.352-3.92,4.368a4.726,4.726,0,0,0,1.056,3.12,3.655,3.655,0,0,0,2.912,1.12,3.84,3.84,0,0,0,2.992-1.248,2.154,2.154,0,0,0,.512-.848.493.493,0,0,0,.016-.16c0-.464-.48-.672-.832-.672s-.432.16-.688.592a2.1,2.1,0,0,1-2,1.1,2.148,2.148,0,0,1-1.84-.784,3.076,3.076,0,0,1-.624-1.888Zm-5.36-1.2a2.932,2.932,0,0,1,.864-1.7,2.268,2.268,0,0,1,1.552-.528A2.129,2.129,0,0,1,176,34.056Zm13.712-2.048a.755.755,0,0,0,.176-.56c0-.7-.352-.736-.592-.736h-5.088a.565.565,0,0,0-.608.624.553.553,0,0,0,.608.624h3.856a2.3,2.3,0,0,0-.5.528c-.144.176-.3.352-.464.528l-3.76,4.5a.844.844,0,0,0-.208.624c0,.848.512.864.688.864H184.8a.64.64,0,0,0,0-1.28h-4.48a9.894,9.894,0,0,0,1.008-1.12Zm3.28-.688a.728.728,0,0,0-1.456,0v7.056a.684.684,0,0,0,.736.72.669.669,0,0,0,.64-.368.814.814,0,0,0,.08-.352Zm-1.632-2.8a.9.9,0,0,0,1.792,0,.9.9,0,1,0-1.792,0Zm11.36,6.256c0-2.736-1.568-4.24-3.92-4.24a3.912,3.912,0,0,0-3.008,1.2,4.7,4.7,0,0,0-.992,3.152,4.647,4.647,0,0,0,1.024,3.152,3.662,3.662,0,0,0,2.9,1.12,3.744,3.744,0,0,0,2.944-1.168A4.761,4.761,0,0,0,198.144,34.776Zm-3.968,3.2a2.34,2.34,0,0,1-1.856-.816,3.807,3.807,0,0,1-.592-2.272,4.014,4.014,0,0,1,.544-2.208,2.195,2.195,0,0,1,1.888-.912c1.952,0,2.464,1.552,2.464,3.1a3.739,3.739,0,0,1-.592,2.24A2.291,2.291,0,0,1,194.176,37.976Zm5.776.4a.637.637,0,0,0,.352.64,1.1,1.1,0,0,0,.384.08.665.665,0,0,0,.736-.72V34.9a5.54,5.54,0,0,1,.08-1.264,2.122,2.122,0,0,1,2.144-1.824,1.448,1.448,0,0,1,1.584,1.6c0,.144.032.336.032,1.184v3.776a.65.65,0,0,0,.352.64,1.1,1.1,0,0,0,.384.08.665.665,0,0,0,.736-.72V33.848a3.637,3.637,0,0,0-.56-2.384,2.727,2.727,0,0,0-2.208-.912,2.93,2.93,0,0,0-2.576,1.2c0-.64,0-.88-.352-1.056a.976.976,0,0,0-.736,0,.629.629,0,0,0-.352.624Zm15.472-3.12a.651.651,0,0,0,.72-.72,4.8,4.8,0,0,0-.8-2.672,3.089,3.089,0,0,0-1.84-1.2,4.5,4.5,0,0,0-1.04-.112c-2.832,0-3.92,2.352-3.92,4.368a4.726,4.726,0,0,0,1.056,3.12,3.655,3.655,0,0,0,2.912,1.12,3.84,3.84,0,0,0,2.992-1.248,2.154,2.154,0,0,0,.512-.848.493.493,0,0,0,.016-.16c0-.464-.48-.672-.832-.672s-.432.16-.688.592a2.1,2.1,0,0,1-2,1.1,2.148,2.148,0,0,1-1.84-.784,3.076,3.076,0,0,1-.624-1.888Zm-5.36-1.2a2.932,2.932,0,0,1,.864-1.7,2.268,2.268,0,0,1,1.552-.528,2.129,2.129,0,0,1,2.16,2.224Zm12.544,7.312a.661.661,0,0,0,.368.656.949.949,0,0,0,.368.08.681.681,0,0,0,.752-.736V38.024a3.52,3.52,0,0,0,2.64,1.136c2.528,0,3.392-2.336,3.392-4.32,0-2.736-1.52-4.3-3.568-4.3a3.007,3.007,0,0,0-2.464,1.12c0-.48,0-.784-.368-.96a.846.846,0,0,0-.384-.08.665.665,0,0,0-.736.72Zm6-6.5a3.913,3.913,0,0,1-.544,2.256,2.039,2.039,0,0,1-1.7.848c-1.536,0-2.3-1.36-2.3-3.216,0-1.84.816-2.992,2.32-2.992C228.544,31.768,228.608,34.024,228.608,34.872Zm9.808.384a.651.651,0,0,0,.72-.72,4.8,4.8,0,0,0-.8-2.672,3.089,3.089,0,0,0-1.84-1.2,4.5,4.5,0,0,0-1.04-.112c-2.832,0-3.92,2.352-3.92,4.368a4.726,4.726,0,0,0,1.056,3.12,3.655,3.655,0,0,0,2.912,1.12,3.84,3.84,0,0,0,2.992-1.248,2.154,2.154,0,0,0,.512-.848.493.493,0,0,0,.016-.16c0-.464-.48-.672-.832-.672s-.432.16-.688.592a2.1,2.1,0,0,1-2,1.1,2.148,2.148,0,0,1-1.84-.784,3.076,3.076,0,0,1-.624-1.888Zm-5.36-1.2a2.932,2.932,0,0,1,.864-1.7,2.268,2.268,0,0,1,1.552-.528,2.129,2.129,0,0,1,2.16,2.224Zm9.264-2.768a.7.7,0,0,0-1.392,0v7.136c0,.224.064.672.72.672.688,0,.736-.416.736-.672V35.24a3.021,3.021,0,0,1,1.056-2.816,3.067,3.067,0,0,1,1.248-.4.67.67,0,0,0,.672-.688c0-.72-.7-.72-.88-.72a2.282,2.282,0,0,0-2.16,1.5Zm16.464,3.488c0-2.736-1.568-4.24-3.92-4.24a3.912,3.912,0,0,0-3.008,1.2,4.7,4.7,0,0,0-.992,3.152,4.647,4.647,0,0,0,1.024,3.152,3.662,3.662,0,0,0,2.9,1.12,3.744,3.744,0,0,0,2.944-1.168A4.761,4.761,0,0,0,258.784,34.776Zm-3.968,3.2a2.34,2.34,0,0,1-1.856-.816,3.807,3.807,0,0,1-.592-2.272,4.014,4.014,0,0,1,.544-2.208,2.195,2.195,0,0,1,1.888-.912c1.952,0,2.464,1.552,2.464,3.1a3.739,3.739,0,0,1-.592,2.24A2.291,2.291,0,0,1,254.816,37.976Zm12.56-6.736c0-.176-.048-.608-.656-.608a.606.606,0,0,0-.56.288c-.064.128-.064.208-.08.736a1.946,1.946,0,0,0-.992-.864,3.545,3.545,0,0,0-4.688,2.32,6.377,6.377,0,0,0-.208,1.648c0,2.112,1.008,3.952,3.408,3.952a2.815,2.815,0,0,0,2.416-1.12l-.016.736c-.032,1.1-.1,2.32-2,2.32a2.225,2.225,0,0,1-1.52-.448,2.408,2.408,0,0,1-.32-.544c-.128-.272-.288-.608-.768-.608a.72.72,0,0,0-.768.7,2.234,2.234,0,0,0,.944,1.52,3.992,3.992,0,0,0,2.336.608,3.951,3.951,0,0,0,2.624-.784c.64-.592.848-1.44.848-3.184Zm-1.344,3.3a3.985,3.985,0,0,1-.464,2.032,2.164,2.164,0,0,1-1.76.88,1.931,1.931,0,0,1-1.6-.784,3.481,3.481,0,0,1-.512-2.016,3.557,3.557,0,0,1,.512-1.968,2.032,2.032,0,0,1,1.728-.864C266.032,31.816,266.032,34.12,266.032,34.536Zm3.552,3.84a.637.637,0,0,0,.352.64,1.1,1.1,0,0,0,.384.08.665.665,0,0,0,.736-.72V34.9a5.54,5.54,0,0,1,.08-1.264,2.122,2.122,0,0,1,2.144-1.824,1.448,1.448,0,0,1,1.584,1.6c0,.144.032.336.032,1.184v3.776a.65.65,0,0,0,.352.64,1.1,1.1,0,0,0,.384.08.665.665,0,0,0,.736-.72V33.848a3.637,3.637,0,0,0-.56-2.384,2.727,2.727,0,0,0-2.208-.912,2.93,2.93,0,0,0-2.576,1.2c0-.64,0-.88-.352-1.056a.976.976,0,0,0-.736,0,.629.629,0,0,0-.352.624Zm10.448-7.056a.728.728,0,0,0-1.456,0v7.056a.684.684,0,0,0,.736.72.669.669,0,0,0,.64-.368.814.814,0,0,0,.08-.352Zm-1.632-2.8a.9.9,0,0,0,1.792,0,.9.9,0,1,0-1.792,0Zm9.952-.192a.637.637,0,0,0-.352-.64.949.949,0,0,0-.368-.08.689.689,0,0,0-.64.352.949.949,0,0,0-.08.368V38.392a.616.616,0,0,0,.352.624.753.753,0,0,0,.384.08.684.684,0,0,0,.624-.336,1.309,1.309,0,0,0,.08-.656,3.2,3.2,0,0,0,2.512,1.072c2.128,0,3.568-1.616,3.568-4.3,0-1.68-.624-4.32-3.472-4.32a3.056,3.056,0,0,0-2.608,1.2Zm4.544,6.56c0,1.776-.528,2.528-1.248,2.88a2.3,2.3,0,0,1-.992.208c-1.9,0-2.32-1.888-2.32-3.152a3.035,3.035,0,0,1,1.264-2.8,2.383,2.383,0,0,1,1.1-.256C292.88,31.768,292.9,34.216,292.9,34.888Zm9.456-1.232a3.254,3.254,0,0,0-.544-2.24,3.165,3.165,0,0,0-2.48-.864,3.226,3.226,0,0,0-2.864,1.264,2.074,2.074,0,0,0-.336.928c0,.288.16.624.752.624.544,0,.624-.288.672-.512.144-.432.384-1.12,1.776-1.12.288,0,1.664,0,1.664,1.36,0,.4-.112.528-.448.624-.144.048-.432.112-.976.224l-1.36.288c-.864.176-2.432.48-2.432,2.384a2.451,2.451,0,0,0,2.688,2.544,3.155,3.155,0,0,0,2.576-1.184,1.92,1.92,0,0,0,.064.768.635.635,0,0,0,.608.352.6.6,0,0,0,.64-.64Zm-2.448,1.36a4.815,4.815,0,0,0,1.088-.3,4.13,4.13,0,0,1-.448,2.4,2.239,2.239,0,0,1-1.76.848,1.338,1.338,0,0,1-1.488-1.328,1.232,1.232,0,0,1,.96-1.216,5.516,5.516,0,0,1,.816-.208Zm4.672,3.36a.677.677,0,0,0,.752.72.7.7,0,0,0,.656-.368.936.936,0,0,0,.08-.352V34.712a3.492,3.492,0,0,1,.384-2.032,1.82,1.82,0,0,1,1.632-.848,1.377,1.377,0,0,1,1.456,1.36,8.23,8.23,0,0,1,.032,1.136v4.048a.616.616,0,0,0,.352.624.852.852,0,0,0,.384.1.833.833,0,0,0,.384-.1.616.616,0,0,0,.352-.624V34.408a2.842,2.842,0,0,1,.352-1.728,1.9,1.9,0,0,1,1.632-.848c1.456,0,1.5,1.232,1.5,1.76,0,.256.016.7.016,1.184V38.36a.617.617,0,0,0,.368.64.743.743,0,0,0,.368.1.681.681,0,0,0,.752-.736V33.576a3.148,3.148,0,0,0-.576-2.192,2.685,2.685,0,0,0-2.208-.848,3.156,3.156,0,0,0-2.592,1.3,2.057,2.057,0,0,0-.912-.976,2.726,2.726,0,0,0-1.376-.32,2.767,2.767,0,0,0-2.336,1.12c0-.544,0-.8-.336-.96a.918.918,0,0,0-.768,0,.6.6,0,0,0-.352.608Zm15.1-10.048a.637.637,0,0,0-.352-.64.949.949,0,0,0-.368-.08.689.689,0,0,0-.64.352.949.949,0,0,0-.08.368V38.392a.616.616,0,0,0,.352.624.753.753,0,0,0,.384.08.684.684,0,0,0,.624-.336,1.309,1.309,0,0,0,.08-.656,3.2,3.2,0,0,0,2.512,1.072c2.128,0,3.568-1.616,3.568-4.3,0-1.68-.624-4.32-3.472-4.32a3.056,3.056,0,0,0-2.608,1.2Zm4.544,6.56c0,1.776-.528,2.528-1.248,2.88a2.3,2.3,0,0,1-.992.208c-1.9,0-2.32-1.888-2.32-3.152a3.035,3.035,0,0,1,1.264-2.8,2.383,2.383,0,0,1,1.1-.256C324.208,31.768,324.224,34.216,324.224,34.888Zm4.8-3.568a.728.728,0,0,0-1.456,0v7.056a.684.684,0,0,0,.736.72.669.669,0,0,0,.64-.368.814.814,0,0,0,.08-.352Zm-1.632-2.8a.9.9,0,0,0,1.792,0,.9.9,0,1,0-1.792,0Zm3.84,9.856a.637.637,0,0,0,.352.64,1.1,1.1,0,0,0,.384.08.665.665,0,0,0,.736-.72V34.9a5.54,5.54,0,0,1,.08-1.264,2.122,2.122,0,0,1,2.144-1.824,1.448,1.448,0,0,1,1.584,1.6c0,.144.032.336.032,1.184v3.776a.65.65,0,0,0,.352.64,1.1,1.1,0,0,0,.384.08.665.665,0,0,0,.736-.72V33.848a3.637,3.637,0,0,0-.56-2.384,2.727,2.727,0,0,0-2.208-.912,2.93,2.93,0,0,0-2.576,1.2c0-.64,0-.88-.352-1.056a.976.976,0,0,0-.736,0,.629.629,0,0,0-.352.624Zm16.512-3.6c0-2.736-1.568-4.24-3.92-4.24a3.912,3.912,0,0,0-3.008,1.2,4.7,4.7,0,0,0-.992,3.152,4.647,4.647,0,0,0,1.024,3.152,3.662,3.662,0,0,0,2.9,1.12,3.744,3.744,0,0,0,2.944-1.168A4.761,4.761,0,0,0,347.744,34.776Zm-3.968,3.2a2.34,2.34,0,0,1-1.856-.816,3.807,3.807,0,0,1-.592-2.272,4.014,4.014,0,0,1,.544-2.208,2.195,2.195,0,0,1,1.888-.912c1.952,0,2.464,1.552,2.464,3.1a3.739,3.739,0,0,1-.592,2.24A2.291,2.291,0,0,1,343.776,37.976Zm17.568-9.648a.637.637,0,0,0-.352-.64.79.79,0,0,0-.368-.08.682.682,0,0,0-.624.352.949.949,0,0,0-.08.368v3.456a3.076,3.076,0,0,0-2.64-1.232c-2.56,0-3.456,2.224-3.456,4.256,0,2.256,1.024,4.352,3.552,4.352a3.312,3.312,0,0,0,1.888-.528,2.905,2.905,0,0,0,.672-.624,1.59,1.59,0,0,0,.048.72.68.68,0,0,0,.64.368.65.65,0,0,0,.72-.7Zm-1.408,6.544c0,.384,0,2.176-1.28,2.832a2.222,2.222,0,0,1-1.088.24c-1.872,0-2.224-1.68-2.224-3.072a6.432,6.432,0,0,1,.1-1.1,2.1,2.1,0,0,1,2.112-1.968,2.074,2.074,0,0,1,1.9,1.008A3.878,3.878,0,0,1,359.936,34.872Zm9.728-1.216a3.254,3.254,0,0,0-.544-2.24,3.165,3.165,0,0,0-2.48-.864,3.226,3.226,0,0,0-2.864,1.264,2.074,2.074,0,0,0-.336.928c0,.288.16.624.752.624.544,0,.624-.288.672-.512.144-.432.384-1.12,1.776-1.12.288,0,1.664,0,1.664,1.36,0,.4-.112.528-.448.624-.144.048-.432.112-.976.224l-1.36.288c-.864.176-2.432.48-2.432,2.384a2.451,2.451,0,0,0,2.688,2.544,3.155,3.155,0,0,0,2.576-1.184,1.92,1.92,0,0,0,.064.768.635.635,0,0,0,.608.352.6.6,0,0,0,.64-.64Zm-2.448,1.36a4.815,4.815,0,0,0,1.088-.3,4.13,4.13,0,0,1-.448,2.4,2.239,2.239,0,0,1-1.76.848,1.338,1.338,0,0,1-1.488-1.328,1.232,1.232,0,0,1,.96-1.216,5.516,5.516,0,0,1,.816-.208Zm12.848-.72c2.368,0,2.912.08,3.2,2.112a11.482,11.482,0,0,0,.32,1.792c.176.592.416.912.864.912.368,0,.72-.176.72-.784a3.894,3.894,0,0,0-.1-.7c-.1-.48-.1-.528-.192-1.072l-.1-.64a3.728,3.728,0,0,0-.464-1.536,1.605,1.605,0,0,0-1.312-.736,2.265,2.265,0,0,0,1.008-.432,2.728,2.728,0,0,0,1.072-2.288,3.048,3.048,0,0,0-1.024-2.464,4.876,4.876,0,0,0-3.12-.768h-3.488a.69.69,0,0,0-.576.192.73.73,0,0,0-.176.56v9.936a.679.679,0,0,0,.752.72.7.7,0,0,0,.656-.352.949.949,0,0,0,.08-.368V34.3Zm-1.872-5.28h1.7c1.6,0,2.688.016,3.264.7a1.876,1.876,0,0,1,.384,1.28,1.77,1.77,0,0,1-1.328,1.9,8.725,8.725,0,0,1-1.76.112h-2.256Zm12.448,3.072a4.971,4.971,0,0,1-1.488-.592,1.179,1.179,0,0,1-.4-.944,1.586,1.586,0,0,1,.672-1.344,2.675,2.675,0,0,1,1.536-.4,2.385,2.385,0,0,1,2.464,1.392c.064.128.224.48.272.544a.545.545,0,0,0,.512.272.731.731,0,0,0,.8-.736,3.123,3.123,0,0,0-1.088-1.888,4.485,4.485,0,0,0-2.9-.864c-2.592,0-3.84,1.344-3.84,3.2a2.388,2.388,0,0,0,1.408,2.368,10.824,10.824,0,0,0,1.28.448l1.2.336a5.688,5.688,0,0,1,2.016.848,1.594,1.594,0,0,1,.592,1.248,1.766,1.766,0,0,1-.688,1.392,3.09,3.09,0,0,1-1.808.464A3.361,3.361,0,0,1,389.2,37.3a2.532,2.532,0,0,1-.96-1.632.556.556,0,0,0-.64-.464c-.272,0-.912.128-.912.752a3.5,3.5,0,0,0,1.28,2.3,5.147,5.147,0,0,0,3.072.9c1.872,0,4.16-.8,4.16-3.328,0-2.384-1.888-2.96-3.1-3.312ZM405.408,28.6a.744.744,0,0,0,.048-.32.731.731,0,0,0-.784-.672.667.667,0,0,0-.672.48l-2.3,6.3c-.56,1.552-.592,1.712-.848,2.592a14,14,0,0,0-.544-1.7L397.648,28.1a.684.684,0,0,0-.688-.5.753.753,0,0,0-.832.672,1.249,1.249,0,0,0,.064.352l3.776,9.984c.08.224.208.48.864.48.64,0,.784-.272.864-.48Zm-.5,9.6a.9.9,0,1,0,.912-.912A.856.856,0,0,0,404.912,38.2ZM192.16,61.864A3.327,3.327,0,0,1,189.3,60.5a5.149,5.149,0,0,1-.832-3.072,4.892,4.892,0,0,1,1.344-3.76,3.321,3.321,0,0,1,2.32-.784A3.063,3.063,0,0,1,195.3,54.92c.208.416.32.656.72.656.368,0,.816-.24.816-.656a3.7,3.7,0,0,0-.864-1.872,4.867,4.867,0,0,0-3.856-1.52,5.016,5.016,0,0,0-3.888,1.584,6.45,6.45,0,0,0-1.376,4.32,6.337,6.337,0,0,0,1.248,4.112,4.82,4.82,0,0,0,4.064,1.616,4.881,4.881,0,0,0,4.24-2.032,3.5,3.5,0,0,0,.576-1.36c0-.464-.576-.608-.816-.608-.464,0-.608.3-.784.72A3.331,3.331,0,0,1,192.16,61.864Zm13.824-3.088c0-2.736-1.568-4.24-3.92-4.24a3.912,3.912,0,0,0-3.008,1.2,4.7,4.7,0,0,0-.992,3.152,4.647,4.647,0,0,0,1.024,3.152,3.662,3.662,0,0,0,2.9,1.12,3.744,3.744,0,0,0,2.944-1.168A4.761,4.761,0,0,0,205.984,58.776Zm-3.968,3.2a2.34,2.34,0,0,1-1.856-.816,3.807,3.807,0,0,1-.592-2.272,4.014,4.014,0,0,1,.544-2.208A2.195,2.195,0,0,1,202,55.768c1.952,0,2.464,1.552,2.464,3.1a3.739,3.739,0,0,1-.592,2.24A2.291,2.291,0,0,1,202.016,61.976Zm5.776.4a.637.637,0,0,0,.352.64,1.1,1.1,0,0,0,.384.08.665.665,0,0,0,.736-.72V58.9a5.54,5.54,0,0,1,.08-1.264,2.122,2.122,0,0,1,2.144-1.824,1.448,1.448,0,0,1,1.584,1.6c0,.144.032.336.032,1.184v3.776a.65.65,0,0,0,.352.64,1.1,1.1,0,0,0,.384.08.665.665,0,0,0,.736-.72V57.848a3.637,3.637,0,0,0-.56-2.384,2.727,2.727,0,0,0-2.208-.912,2.93,2.93,0,0,0-2.576,1.2c0-.64,0-.88-.352-1.056a.976.976,0,0,0-.736,0,.629.629,0,0,0-.352.624ZM223.9,52.328a.637.637,0,0,0-.352-.64.79.79,0,0,0-.368-.08.682.682,0,0,0-.624.352.949.949,0,0,0-.08.368v3.456a3.076,3.076,0,0,0-2.64-1.232c-2.56,0-3.456,2.224-3.456,4.256,0,2.256,1.024,4.352,3.552,4.352a3.312,3.312,0,0,0,1.888-.528,2.9,2.9,0,0,0,.672-.624,1.591,1.591,0,0,0,.048.72.68.68,0,0,0,.64.368.65.65,0,0,0,.72-.7ZM222.5,58.872c0,.384,0,2.176-1.28,2.832a2.222,2.222,0,0,1-1.088.24c-1.872,0-2.224-1.68-2.224-3.072a6.431,6.431,0,0,1,.1-1.1,2.1,2.1,0,0,1,2.112-1.968,2.074,2.074,0,0,1,1.9,1.008A3.878,3.878,0,0,1,222.5,58.872Zm5.072-3.552a.728.728,0,0,0-1.456,0v7.056a.684.684,0,0,0,.736.72.669.669,0,0,0,.64-.368.814.814,0,0,0,.08-.352Zm-1.632-2.8a.9.9,0,0,0,1.792,0,.9.9,0,1,0-1.792,0Zm4.224,2.592a.624.624,0,0,0-.64-.5c-.48,0-.848.272-.848.672a1.137,1.137,0,0,0,.064.32l2.5,7.04c.08.208.208.448.768.448s.688-.24.768-.448L235.3,55.56a.906.906,0,0,0,.048-.288.706.706,0,0,0-.8-.656.627.627,0,0,0-.672.48L232.8,58.408a14.937,14.937,0,0,0-.784,2.848,11.19,11.19,0,0,0-.608-2.384Zm7.744.208a.728.728,0,0,0-1.456,0v7.056a.684.684,0,0,0,.736.72.669.669,0,0,0,.64-.368.814.814,0,0,0,.08-.352Zm-1.632-2.8a.9.9,0,0,0,1.792,0,.9.9,0,1,0-1.792,0Zm10.96-.192a.637.637,0,0,0-.352-.64.79.79,0,0,0-.368-.08.682.682,0,0,0-.624.352.949.949,0,0,0-.08.368v3.456a3.076,3.076,0,0,0-2.64-1.232c-2.56,0-3.456,2.224-3.456,4.256,0,2.256,1.024,4.352,3.552,4.352a3.312,3.312,0,0,0,1.888-.528,2.9,2.9,0,0,0,.672-.624,1.591,1.591,0,0,0,.048.72.68.68,0,0,0,.64.368.65.65,0,0,0,.72-.7Zm-1.408,6.544c0,.384,0,2.176-1.28,2.832a2.222,2.222,0,0,1-1.088.24c-1.872,0-2.224-1.68-2.224-3.072a6.431,6.431,0,0,1,.1-1.1A2.1,2.1,0,0,1,243.44,55.8a2.074,2.074,0,0,1,1.9,1.008A3.878,3.878,0,0,1,245.824,58.872ZM250.9,55.32a.728.728,0,0,0-1.456,0v7.056a.684.684,0,0,0,.736.72.669.669,0,0,0,.64-.368.814.814,0,0,0,.08-.352Zm-1.632-2.8a.9.9,0,0,0,1.792,0,.9.9,0,1,0-1.792,0Zm9.968,2.8a.728.728,0,0,0-1.456,0v7.056a.684.684,0,0,0,.736.72.669.669,0,0,0,.64-.368.814.814,0,0,0,.08-.352Zm-1.632-2.8a.9.9,0,0,0,1.792,0,.9.9,0,1,0-1.792,0Zm5.3-.208a.661.661,0,0,0-.736-.7.67.67,0,0,0-.736.7V62.376a.736.736,0,0,0,1.472,0Zm6.992,8.336c0,1.248,0,2.448,2.224,2.448.432,0,.944-.064.944-.624s-.4-.592-.784-.608c-.432-.032-.736-.112-.848-.576a4.913,4.913,0,0,1-.064-1.264V55.96h.992a.568.568,0,0,0,.608-.624.553.553,0,0,0-.608-.624h-.992V52.84c0-.224-.048-.688-.736-.688a.639.639,0,0,0-.72.688v1.872h-.864a.559.559,0,0,0-.608.624.568.568,0,0,0,.608.624h.848Zm11.344-5.3a.744.744,0,0,0-1.488,0v3.5a5.6,5.6,0,0,1-.08,1.344,2.131,2.131,0,0,1-2.16,1.7,1.429,1.429,0,0,1-1.312-.672,3.925,3.925,0,0,1-.256-1.9V55.336a.744.744,0,0,0-1.488.016V59.8a3.622,3.622,0,0,0,.688,2.544,2.846,2.846,0,0,0,2.128.816,2.766,2.766,0,0,0,2.544-1.216c0,.64,0,.9.336,1.072a.976.976,0,0,0,.736,0,.655.655,0,0,0,.352-.624Zm9.728,3.424c0-2.736-1.568-4.24-3.92-4.24a3.912,3.912,0,0,0-3.008,1.2,4.7,4.7,0,0,0-.992,3.152,4.647,4.647,0,0,0,1.024,3.152,3.662,3.662,0,0,0,2.9,1.12,3.744,3.744,0,0,0,2.944-1.168A4.761,4.761,0,0,0,290.96,58.776Zm-3.968,3.2a2.34,2.34,0,0,1-1.856-.816,3.807,3.807,0,0,1-.592-2.272,4.014,4.014,0,0,1,.544-2.208,2.195,2.195,0,0,1,1.888-.912c1.952,0,2.464,1.552,2.464,3.1a3.739,3.739,0,0,1-.592,2.24A2.291,2.291,0,0,1,286.992,61.976Zm10.448,3.392a.661.661,0,0,0,.368.656.949.949,0,0,0,.368.08.681.681,0,0,0,.752-.736V62.024a3.52,3.52,0,0,0,2.64,1.136c2.528,0,3.392-2.336,3.392-4.32,0-2.736-1.52-4.3-3.568-4.3a3.007,3.007,0,0,0-2.464,1.12c0-.48,0-.784-.368-.96a.846.846,0,0,0-.384-.08.665.665,0,0,0-.736.72Zm6-6.5a3.913,3.913,0,0,1-.544,2.256,2.039,2.039,0,0,1-1.7.848c-1.536,0-2.3-1.36-2.3-3.216,0-1.84.816-2.992,2.32-2.992C303.376,55.768,303.44,58.024,303.44,58.872Zm9.808.384a.651.651,0,0,0,.72-.72,4.8,4.8,0,0,0-.8-2.672,3.089,3.089,0,0,0-1.84-1.2,4.5,4.5,0,0,0-1.04-.112c-2.832,0-3.92,2.352-3.92,4.368a4.726,4.726,0,0,0,1.056,3.12,3.655,3.655,0,0,0,2.912,1.12,3.84,3.84,0,0,0,2.992-1.248,2.154,2.154,0,0,0,.512-.848.494.494,0,0,0,.016-.16c0-.464-.48-.672-.832-.672s-.432.16-.688.592a2.1,2.1,0,0,1-2,1.1,2.148,2.148,0,0,1-1.84-.784,3.076,3.076,0,0,1-.624-1.888Zm-5.36-1.2a2.931,2.931,0,0,1,.864-1.7,2.268,2.268,0,0,1,1.552-.528,2.129,2.129,0,0,1,2.16,2.224Zm7.872,4.32a.637.637,0,0,0,.352.64,1.1,1.1,0,0,0,.384.08.665.665,0,0,0,.736-.72V58.9a5.54,5.54,0,0,1,.08-1.264,2.122,2.122,0,0,1,2.144-1.824,1.448,1.448,0,0,1,1.584,1.6c0,.144.032.336.032,1.184v3.776a.65.65,0,0,0,.352.64,1.1,1.1,0,0,0,.384.08.665.665,0,0,0,.736-.72V57.848a3.637,3.637,0,0,0-.56-2.384,2.727,2.727,0,0,0-2.208-.912,2.93,2.93,0,0,0-2.576,1.2c0-.64,0-.88-.352-1.056a.976.976,0,0,0-.736,0,.629.629,0,0,0-.352.624Zm11.584-4.48c-.736-.224-1.376-.416-1.376-1.152a1.024,1.024,0,0,1,.464-.848,1.734,1.734,0,0,1,.928-.224A1.891,1.891,0,0,1,329.2,56.7c.24.464.336.64.688.64a.635.635,0,0,0,.672-.624c0-.32-.432-2.16-3.136-2.16-2.752,0-2.912,1.968-2.912,2.384,0,1.536,1.36,1.984,2.24,2.272l.928.272c.816.24,1.552.448,1.552,1.28,0,.752-.7,1.248-1.648,1.248a1.978,1.978,0,0,1-1.712-.784,3.946,3.946,0,0,1-.352-.848.524.524,0,0,0-.544-.352c-.24,0-.784.128-.784.672a2.556,2.556,0,0,0,.88,1.728,3.839,3.839,0,0,0,2.416.736,4.006,4.006,0,0,0,2.192-.56,2.282,2.282,0,0,0,1.008-1.968c0-1.744-1.552-2.192-2.416-2.448Zm6.528-2.576a.728.728,0,0,0-1.456,0v7.056a.684.684,0,0,0,.736.72.669.669,0,0,0,.64-.368.814.814,0,0,0,.08-.352Zm-1.632-2.8a.9.9,0,0,0,1.792,0,.9.9,0,1,0-1.792,0Zm10.32,6.736a.651.651,0,0,0,.72-.72,4.8,4.8,0,0,0-.8-2.672,3.089,3.089,0,0,0-1.84-1.2,4.5,4.5,0,0,0-1.04-.112c-2.832,0-3.92,2.352-3.92,4.368a4.726,4.726,0,0,0,1.056,3.12,3.655,3.655,0,0,0,2.912,1.12,3.84,3.84,0,0,0,2.992-1.248,2.154,2.154,0,0,0,.512-.848.494.494,0,0,0,.016-.16c0-.464-.48-.672-.832-.672s-.432.16-.688.592a2.1,2.1,0,0,1-2,1.1,2.148,2.148,0,0,1-1.84-.784,3.076,3.076,0,0,1-.624-1.888Zm-5.36-1.2a2.931,2.931,0,0,1,.864-1.7,2.268,2.268,0,0,1,1.552-.528,2.129,2.129,0,0,1,2.16,2.224Zm9.264-2.768a.7.7,0,0,0-1.392,0v7.136c0,.224.064.672.72.672.688,0,.736-.416.736-.672V59.24a3.021,3.021,0,0,1,1.056-2.816,3.067,3.067,0,0,1,1.248-.4.67.67,0,0,0,.672-.688c0-.72-.7-.72-.88-.72a2.282,2.282,0,0,0-2.16,1.5Zm11.472,3.488c0-2.736-1.568-4.24-3.92-4.24a3.912,3.912,0,0,0-3.008,1.2,4.7,4.7,0,0,0-.992,3.152,4.647,4.647,0,0,0,1.024,3.152,3.662,3.662,0,0,0,2.9,1.12,3.744,3.744,0,0,0,2.944-1.168A4.761,4.761,0,0,0,357.936,58.776Zm-3.968,3.2a2.34,2.34,0,0,1-1.856-.816,3.807,3.807,0,0,1-.592-2.272,4.014,4.014,0,0,1,.544-2.208,2.195,2.195,0,0,1,1.888-.912c1.952,0,2.464,1.552,2.464,3.1a3.739,3.739,0,0,1-.592,2.24A2.291,2.291,0,0,1,353.968,61.976Zm5.44.224a.9.9,0,1,0,.912-.912A.856.856,0,0,0,359.408,62.2Z",
    transform: "translate(397.706 490.5)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "qr-code",
    transform: "translate(612.013 592.819)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1023",
    "data-name": "Rettangolo 1023",
    width: 142,
    height: 142,
    transform: "translate(-0.013 0.18)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3719",
    "data-name": "Raggruppa 3719",
    transform: "translate(7.68 7.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2785",
    "data-name": "Raggruppa 2785",
    transform: "translate(38.394 0.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2784",
    "data-name": "Raggruppa 2784",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1024",
    "data-name": "Rettangolo 1024",
    width: 4,
    height: 4,
    transform: "translate(-0.086 0.325)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2787",
    "data-name": "Raggruppa 2787",
    transform: "translate(42.328 0.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2786",
    "data-name": "Raggruppa 2786",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1025",
    "data-name": "Rettangolo 1025",
    width: 4,
    height: 4,
    transform: "translate(-0.021 0.325)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2789",
    "data-name": "Raggruppa 2789",
    transform: "translate(53.569 0.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2788",
    "data-name": "Raggruppa 2788",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1026",
    "data-name": "Rettangolo 1026",
    width: 4,
    height: 4,
    transform: "translate(-0.261 0.325)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2791",
    "data-name": "Raggruppa 2791",
    transform: "translate(57.503 0.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2790",
    "data-name": "Raggruppa 2790",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1027",
    "data-name": "Rettangolo 1027",
    width: 4,
    height: 4,
    transform: "translate(-0.195 0.325)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2793",
    "data-name": "Raggruppa 2793",
    transform: "translate(69.305 0.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2792",
    "data-name": "Raggruppa 2792",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1028",
    "data-name": "Rettangolo 1028",
    width: 4,
    height: 4,
    transform: "translate(0.002 0.325)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2795",
    "data-name": "Raggruppa 2795",
    transform: "translate(73.239 0.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2794",
    "data-name": "Raggruppa 2794",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1029",
    "data-name": "Rettangolo 1029",
    width: 3,
    height: 4,
    transform: "translate(0.068 0.325)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2797",
    "data-name": "Raggruppa 2797",
    transform: "translate(76.612 0.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2796",
    "data-name": "Raggruppa 2796",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1030",
    "data-name": "Rettangolo 1030",
    width: 4,
    height: 4,
    transform: "translate(-0.304 0.325)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2799",
    "data-name": "Raggruppa 2799",
    transform: "translate(80.546 0.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2798",
    "data-name": "Raggruppa 2798",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1031",
    "data-name": "Rettangolo 1031",
    width: 4,
    height: 4,
    transform: "translate(-0.239 0.325)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2801",
    "data-name": "Raggruppa 2801",
    transform: "translate(84.48 0.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2800",
    "data-name": "Raggruppa 2800",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1032",
    "data-name": "Rettangolo 1032",
    width: 4,
    height: 4,
    transform: "translate(-0.173 0.325)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2803",
    "data-name": "Raggruppa 2803",
    transform: "translate(88.414 0.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2802",
    "data-name": "Raggruppa 2802",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1033",
    "data-name": "Rettangolo 1033",
    width: 4,
    height: 4,
    transform: "translate(-0.107 0.325)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2805",
    "data-name": "Raggruppa 2805",
    transform: "translate(38.394 4.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2804",
    "data-name": "Raggruppa 2804",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1034",
    "data-name": "Rettangolo 1034",
    width: 4,
    height: 3,
    transform: "translate(-0.086 0.39)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2807",
    "data-name": "Raggruppa 2807",
    transform: "translate(42.328 4.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2806",
    "data-name": "Raggruppa 2806",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1035",
    "data-name": "Rettangolo 1035",
    width: 4,
    height: 3,
    transform: "translate(-0.021 0.39)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2809",
    "data-name": "Raggruppa 2809",
    transform: "translate(57.503 4.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2808",
    "data-name": "Raggruppa 2808",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1036",
    "data-name": "Rettangolo 1036",
    width: 4,
    height: 3,
    transform: "translate(-0.195 0.39)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2811",
    "data-name": "Raggruppa 2811",
    transform: "translate(61.437 4.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2810",
    "data-name": "Raggruppa 2810",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1037",
    "data-name": "Rettangolo 1037",
    width: 4,
    height: 3,
    transform: "translate(-0.129 0.39)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2813",
    "data-name": "Raggruppa 2813",
    transform: "translate(65.371 4.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2812",
    "data-name": "Raggruppa 2812",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1038",
    "data-name": "Rettangolo 1038",
    width: 4,
    height: 3,
    transform: "translate(-0.064 0.39)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2815",
    "data-name": "Raggruppa 2815",
    transform: "translate(84.48 4.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2814",
    "data-name": "Raggruppa 2814",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1039",
    "data-name": "Rettangolo 1039",
    width: 4,
    height: 3,
    transform: "translate(-0.173 0.39)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2817",
    "data-name": "Raggruppa 2817",
    transform: "translate(88.414 4.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2816",
    "data-name": "Raggruppa 2816",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1040",
    "data-name": "Rettangolo 1040",
    width: 4,
    height: 3,
    transform: "translate(-0.107 0.39)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2819",
    "data-name": "Raggruppa 2819",
    transform: "translate(38.394 7.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2818",
    "data-name": "Raggruppa 2818",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1041",
    "data-name": "Rettangolo 1041",
    width: 4,
    height: 4,
    transform: "translate(-0.086 0.018)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2821",
    "data-name": "Raggruppa 2821",
    transform: "translate(42.328 7.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2820",
    "data-name": "Raggruppa 2820",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1042",
    "data-name": "Rettangolo 1042",
    width: 4,
    height: 4,
    transform: "translate(-0.021 0.018)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2823",
    "data-name": "Raggruppa 2823",
    transform: "translate(53.569 7.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2822",
    "data-name": "Raggruppa 2822",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1043",
    "data-name": "Rettangolo 1043",
    width: 4,
    height: 4,
    transform: "translate(-0.261 0.018)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2825",
    "data-name": "Raggruppa 2825",
    transform: "translate(65.371 7.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2824",
    "data-name": "Raggruppa 2824",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1044",
    "data-name": "Rettangolo 1044",
    width: 4,
    height: 4,
    transform: "translate(-0.064 0.018)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2827",
    "data-name": "Raggruppa 2827",
    transform: "translate(73.239 7.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2826",
    "data-name": "Raggruppa 2826",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1045",
    "data-name": "Rettangolo 1045",
    width: 3,
    height: 4,
    transform: "translate(0.068 0.018)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2829",
    "data-name": "Raggruppa 2829",
    transform: "translate(34.46 11.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2828",
    "data-name": "Raggruppa 2828",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1046",
    "data-name": "Rettangolo 1046",
    width: 4,
    height: 4,
    transform: "translate(-0.152 0.084)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2831",
    "data-name": "Raggruppa 2831",
    transform: "translate(50.197 11.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2830",
    "data-name": "Raggruppa 2830",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1047",
    "data-name": "Rettangolo 1047",
    width: 3,
    height: 4,
    transform: "translate(0.111 0.084)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2833",
    "data-name": "Raggruppa 2833",
    transform: "translate(57.503 11.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2832",
    "data-name": "Raggruppa 2832",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1048",
    "data-name": "Rettangolo 1048",
    width: 4,
    height: 4,
    transform: "translate(-0.195 0.084)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2835",
    "data-name": "Raggruppa 2835",
    transform: "translate(65.371 11.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2834",
    "data-name": "Raggruppa 2834",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1049",
    "data-name": "Rettangolo 1049",
    width: 4,
    height: 4,
    transform: "translate(-0.064 0.084)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2837",
    "data-name": "Raggruppa 2837",
    transform: "translate(73.239 11.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2836",
    "data-name": "Raggruppa 2836",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1050",
    "data-name": "Rettangolo 1050",
    width: 3,
    height: 4,
    transform: "translate(0.068 0.084)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2839",
    "data-name": "Raggruppa 2839",
    transform: "translate(88.414 11.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2838",
    "data-name": "Raggruppa 2838",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1051",
    "data-name": "Rettangolo 1051",
    width: 4,
    height: 4,
    transform: "translate(-0.107 0.084)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2841",
    "data-name": "Raggruppa 2841",
    transform: "translate(42.328 15.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2840",
    "data-name": "Raggruppa 2840",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1052",
    "data-name": "Rettangolo 1052",
    width: 4,
    height: 4,
    transform: "translate(-0.021 0.15)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2843",
    "data-name": "Raggruppa 2843",
    transform: "translate(46.262 15.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2842",
    "data-name": "Raggruppa 2842",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1053",
    "data-name": "Rettangolo 1053",
    width: 4,
    height: 4,
    transform: "translate(0.045 0.15)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2845",
    "data-name": "Raggruppa 2845",
    transform: "translate(50.197 15.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2844",
    "data-name": "Raggruppa 2844",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1054",
    "data-name": "Rettangolo 1054",
    width: 3,
    height: 4,
    transform: "translate(0.111 0.15)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2847",
    "data-name": "Raggruppa 2847",
    transform: "translate(61.437 15.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2846",
    "data-name": "Raggruppa 2846",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1055",
    "data-name": "Rettangolo 1055",
    width: 4,
    height: 4,
    transform: "translate(-0.129 0.15)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2849",
    "data-name": "Raggruppa 2849",
    transform: "translate(65.371 15.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2848",
    "data-name": "Raggruppa 2848",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1056",
    "data-name": "Rettangolo 1056",
    width: 4,
    height: 4,
    transform: "translate(-0.064 0.15)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2851",
    "data-name": "Raggruppa 2851",
    transform: "translate(73.239 15.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2850",
    "data-name": "Raggruppa 2850",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1057",
    "data-name": "Rettangolo 1057",
    width: 3,
    height: 4,
    transform: "translate(0.068 0.15)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2853",
    "data-name": "Raggruppa 2853",
    transform: "translate(80.546 15.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2852",
    "data-name": "Raggruppa 2852",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1058",
    "data-name": "Rettangolo 1058",
    width: 4,
    height: 4,
    transform: "translate(-0.239 0.15)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2855",
    "data-name": "Raggruppa 2855",
    transform: "translate(88.414 15.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2854",
    "data-name": "Raggruppa 2854",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1059",
    "data-name": "Rettangolo 1059",
    width: 4,
    height: 4,
    transform: "translate(-0.107 0.15)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2857",
    "data-name": "Raggruppa 2857",
    transform: "translate(30.525 19.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2856",
    "data-name": "Raggruppa 2856",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1060",
    "data-name": "Rettangolo 1060",
    width: 4,
    height: 4,
    transform: "translate(-0.218 0.216)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2859",
    "data-name": "Raggruppa 2859",
    transform: "translate(34.46 19.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2858",
    "data-name": "Raggruppa 2858",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1061",
    "data-name": "Rettangolo 1061",
    width: 4,
    height: 4,
    transform: "translate(-0.152 0.216)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2861",
    "data-name": "Raggruppa 2861",
    transform: "translate(38.394 19.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2860",
    "data-name": "Raggruppa 2860",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1062",
    "data-name": "Rettangolo 1062",
    width: 4,
    height: 4,
    transform: "translate(-0.086 0.216)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2863",
    "data-name": "Raggruppa 2863",
    transform: "translate(46.262 19.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2862",
    "data-name": "Raggruppa 2862",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1063",
    "data-name": "Rettangolo 1063",
    width: 4,
    height: 4,
    transform: "translate(0.045 0.216)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2865",
    "data-name": "Raggruppa 2865",
    transform: "translate(50.197 19.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2864",
    "data-name": "Raggruppa 2864",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1064",
    "data-name": "Rettangolo 1064",
    width: 3,
    height: 4,
    transform: "translate(0.111 0.216)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2867",
    "data-name": "Raggruppa 2867",
    transform: "translate(53.569 19.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2866",
    "data-name": "Raggruppa 2866",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1065",
    "data-name": "Rettangolo 1065",
    width: 4,
    height: 4,
    transform: "translate(-0.261 0.216)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2869",
    "data-name": "Raggruppa 2869",
    transform: "translate(65.371 19.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2868",
    "data-name": "Raggruppa 2868",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1066",
    "data-name": "Rettangolo 1066",
    width: 4,
    height: 4,
    transform: "translate(-0.064 0.216)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2871",
    "data-name": "Raggruppa 2871",
    transform: "translate(69.305 19.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2870",
    "data-name": "Raggruppa 2870",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1067",
    "data-name": "Rettangolo 1067",
    width: 4,
    height: 4,
    transform: "translate(0.002 0.216)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2873",
    "data-name": "Raggruppa 2873",
    transform: "translate(76.612 19.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2872",
    "data-name": "Raggruppa 2872",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1068",
    "data-name": "Rettangolo 1068",
    width: 4,
    height: 4,
    transform: "translate(-0.304 0.216)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2875",
    "data-name": "Raggruppa 2875",
    transform: "translate(80.546 19.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2874",
    "data-name": "Raggruppa 2874",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1069",
    "data-name": "Rettangolo 1069",
    width: 4,
    height: 4,
    transform: "translate(-0.239 0.216)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2877",
    "data-name": "Raggruppa 2877",
    transform: "translate(30.525 23.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2876",
    "data-name": "Raggruppa 2876",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1070",
    "data-name": "Rettangolo 1070",
    width: 4,
    height: 4,
    transform: "translate(-0.218 0.282)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2879",
    "data-name": "Raggruppa 2879",
    transform: "translate(38.394 23.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2878",
    "data-name": "Raggruppa 2878",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1071",
    "data-name": "Rettangolo 1071",
    width: 4,
    height: 4,
    transform: "translate(-0.086 0.282)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2881",
    "data-name": "Raggruppa 2881",
    transform: "translate(46.262 23.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2880",
    "data-name": "Raggruppa 2880",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1072",
    "data-name": "Rettangolo 1072",
    width: 4,
    height: 4,
    transform: "translate(0.045 0.282)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2883",
    "data-name": "Raggruppa 2883",
    transform: "translate(53.569 23.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2882",
    "data-name": "Raggruppa 2882",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1073",
    "data-name": "Rettangolo 1073",
    width: 4,
    height: 4,
    transform: "translate(-0.261 0.282)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2885",
    "data-name": "Raggruppa 2885",
    transform: "translate(61.437 23.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2884",
    "data-name": "Raggruppa 2884",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1074",
    "data-name": "Rettangolo 1074",
    width: 4,
    height: 4,
    transform: "translate(-0.129 0.282)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2887",
    "data-name": "Raggruppa 2887",
    transform: "translate(69.305 23.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2886",
    "data-name": "Raggruppa 2886",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1075",
    "data-name": "Rettangolo 1075",
    width: 4,
    height: 4,
    transform: "translate(0.002 0.282)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2889",
    "data-name": "Raggruppa 2889",
    transform: "translate(76.612 23.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2888",
    "data-name": "Raggruppa 2888",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1076",
    "data-name": "Rettangolo 1076",
    width: 4,
    height: 4,
    transform: "translate(-0.304 0.282)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2891",
    "data-name": "Raggruppa 2891",
    transform: "translate(84.48 23.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2890",
    "data-name": "Raggruppa 2890",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1077",
    "data-name": "Rettangolo 1077",
    width: 4,
    height: 4,
    transform: "translate(-0.173 0.282)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2893",
    "data-name": "Raggruppa 2893",
    transform: "translate(92.349 23.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2892",
    "data-name": "Raggruppa 2892",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1078",
    "data-name": "Rettangolo 1078",
    width: 4,
    height: 4,
    transform: "translate(-0.041 0.282)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2895",
    "data-name": "Raggruppa 2895",
    transform: "translate(34.46 27.153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2894",
    "data-name": "Raggruppa 2894",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1079",
    "data-name": "Rettangolo 1079",
    width: 4,
    height: 3,
    transform: "translate(-0.152 0.347)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2897",
    "data-name": "Raggruppa 2897",
    transform: "translate(38.394 27.153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2896",
    "data-name": "Raggruppa 2896",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1080",
    "data-name": "Rettangolo 1080",
    width: 4,
    height: 3,
    transform: "translate(-0.086 0.347)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2899",
    "data-name": "Raggruppa 2899",
    transform: "translate(42.328 27.153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2898",
    "data-name": "Raggruppa 2898",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1081",
    "data-name": "Rettangolo 1081",
    width: 4,
    height: 3,
    transform: "translate(-0.021 0.347)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2901",
    "data-name": "Raggruppa 2901",
    transform: "translate(46.262 27.153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2900",
    "data-name": "Raggruppa 2900",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1082",
    "data-name": "Rettangolo 1082",
    width: 4,
    height: 3,
    transform: "translate(0.045 0.347)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2903",
    "data-name": "Raggruppa 2903",
    transform: "translate(53.569 27.153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2902",
    "data-name": "Raggruppa 2902",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1083",
    "data-name": "Rettangolo 1083",
    width: 4,
    height: 3,
    transform: "translate(-0.261 0.347)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2905",
    "data-name": "Raggruppa 2905",
    transform: "translate(65.371 27.153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2904",
    "data-name": "Raggruppa 2904",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1084",
    "data-name": "Rettangolo 1084",
    width: 4,
    height: 3,
    transform: "translate(-0.064 0.347)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2907",
    "data-name": "Raggruppa 2907",
    transform: "translate(73.239 27.153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2906",
    "data-name": "Raggruppa 2906",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1085",
    "data-name": "Rettangolo 1085",
    width: 3,
    height: 3,
    transform: "translate(0.068 0.347)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2909",
    "data-name": "Raggruppa 2909",
    transform: "translate(76.612 27.153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2908",
    "data-name": "Raggruppa 2908",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1086",
    "data-name": "Rettangolo 1086",
    width: 4,
    height: 3,
    transform: "translate(-0.304 0.347)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2911",
    "data-name": "Raggruppa 2911",
    transform: "translate(80.546 27.153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2910",
    "data-name": "Raggruppa 2910",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1087",
    "data-name": "Rettangolo 1087",
    width: 4,
    height: 3,
    transform: "translate(-0.239 0.347)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2913",
    "data-name": "Raggruppa 2913",
    transform: "translate(92.349 27.153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2912",
    "data-name": "Raggruppa 2912",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1088",
    "data-name": "Rettangolo 1088",
    width: 4,
    height: 3,
    transform: "translate(-0.041 0.347)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2915",
    "data-name": "Raggruppa 2915",
    transform: "translate(0.176 30.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2914",
    "data-name": "Raggruppa 2914",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1089",
    "data-name": "Rettangolo 1089",
    width: 4,
    height: 4,
    transform: "translate(0.132 -0.025)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2917",
    "data-name": "Raggruppa 2917",
    transform: "translate(11.416 30.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2916",
    "data-name": "Raggruppa 2916",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1090",
    "data-name": "Rettangolo 1090",
    width: 4,
    height: 4,
    transform: "translate(-0.109 -0.025)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2919",
    "data-name": "Raggruppa 2919",
    transform: "translate(19.285 30.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2918",
    "data-name": "Raggruppa 2918",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1091",
    "data-name": "Rettangolo 1091",
    width: 4,
    height: 4,
    transform: "translate(0.023 -0.025)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2921",
    "data-name": "Raggruppa 2921",
    transform: "translate(23.219 30.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2920",
    "data-name": "Raggruppa 2920",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1092",
    "data-name": "Rettangolo 1092",
    width: 4,
    height: 4,
    transform: "translate(0.088 -0.025)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2923",
    "data-name": "Raggruppa 2923",
    transform: "translate(30.525 30.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2922",
    "data-name": "Raggruppa 2922",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1093",
    "data-name": "Rettangolo 1093",
    width: 4,
    height: 4,
    transform: "translate(-0.218 -0.025)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2925",
    "data-name": "Raggruppa 2925",
    transform: "translate(34.46 30.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2924",
    "data-name": "Raggruppa 2924",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1094",
    "data-name": "Rettangolo 1094",
    width: 4,
    height: 4,
    transform: "translate(-0.152 -0.025)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2927",
    "data-name": "Raggruppa 2927",
    transform: "translate(38.394 30.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2926",
    "data-name": "Raggruppa 2926",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1095",
    "data-name": "Rettangolo 1095",
    width: 4,
    height: 4,
    transform: "translate(-0.086 -0.025)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2929",
    "data-name": "Raggruppa 2929",
    transform: "translate(42.328 30.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2928",
    "data-name": "Raggruppa 2928",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1096",
    "data-name": "Rettangolo 1096",
    width: 4,
    height: 4,
    transform: "translate(-0.021 -0.025)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2931",
    "data-name": "Raggruppa 2931",
    transform: "translate(50.197 30.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2930",
    "data-name": "Raggruppa 2930",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1097",
    "data-name": "Rettangolo 1097",
    width: 3,
    height: 4,
    transform: "translate(0.111 -0.025)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2933",
    "data-name": "Raggruppa 2933",
    transform: "translate(53.569 30.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2932",
    "data-name": "Raggruppa 2932",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1098",
    "data-name": "Rettangolo 1098",
    width: 4,
    height: 4,
    transform: "translate(-0.261 -0.025)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2935",
    "data-name": "Raggruppa 2935",
    transform: "translate(57.503 30.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2934",
    "data-name": "Raggruppa 2934",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1099",
    "data-name": "Rettangolo 1099",
    width: 4,
    height: 4,
    transform: "translate(-0.195 -0.025)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2937",
    "data-name": "Raggruppa 2937",
    transform: "translate(73.239 30.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2936",
    "data-name": "Raggruppa 2936",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1100",
    "data-name": "Rettangolo 1100",
    width: 3,
    height: 4,
    transform: "translate(0.068 -0.025)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2939",
    "data-name": "Raggruppa 2939",
    transform: "translate(76.612 30.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2938",
    "data-name": "Raggruppa 2938",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1101",
    "data-name": "Rettangolo 1101",
    width: 4,
    height: 4,
    transform: "translate(-0.304 -0.025)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2941",
    "data-name": "Raggruppa 2941",
    transform: "translate(80.546 30.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2940",
    "data-name": "Raggruppa 2940",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1102",
    "data-name": "Rettangolo 1102",
    width: 4,
    height: 4,
    transform: "translate(-0.239 -0.025)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2943",
    "data-name": "Raggruppa 2943",
    transform: "translate(92.349 30.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2942",
    "data-name": "Raggruppa 2942",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1103",
    "data-name": "Rettangolo 1103",
    width: 4,
    height: 4,
    transform: "translate(-0.041 -0.025)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2945",
    "data-name": "Raggruppa 2945",
    transform: "translate(96.283 30.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2944",
    "data-name": "Raggruppa 2944",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1104",
    "data-name": "Rettangolo 1104",
    width: 3,
    height: 4,
    transform: "translate(0.025 -0.025)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2947",
    "data-name": "Raggruppa 2947",
    transform: "translate(103.589 30.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2946",
    "data-name": "Raggruppa 2946",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1105",
    "data-name": "Rettangolo 1105",
    width: 4,
    height: 4,
    transform: "translate(-0.282 -0.025)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2949",
    "data-name": "Raggruppa 2949",
    transform: "translate(4.11 34.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2948",
    "data-name": "Raggruppa 2948",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1106",
    "data-name": "Rettangolo 1106",
    width: 3,
    height: 4,
    transform: "translate(0.198 0.041)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2951",
    "data-name": "Raggruppa 2951",
    transform: "translate(7.482 34.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2950",
    "data-name": "Raggruppa 2950",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1107",
    "data-name": "Rettangolo 1107",
    width: 4,
    height: 4,
    transform: "translate(-0.175 0.041)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2953",
    "data-name": "Raggruppa 2953",
    transform: "translate(11.416 34.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2952",
    "data-name": "Raggruppa 2952",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1108",
    "data-name": "Rettangolo 1108",
    width: 4,
    height: 4,
    transform: "translate(-0.109 0.041)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2955",
    "data-name": "Raggruppa 2955",
    transform: "translate(15.351 34.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2954",
    "data-name": "Raggruppa 2954",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1109",
    "data-name": "Rettangolo 1109",
    width: 4,
    height: 4,
    transform: "translate(-0.043 0.041)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2957",
    "data-name": "Raggruppa 2957",
    transform: "translate(19.285 34.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2956",
    "data-name": "Raggruppa 2956",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1110",
    "data-name": "Rettangolo 1110",
    width: 4,
    height: 4,
    transform: "translate(0.023 0.041)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2959",
    "data-name": "Raggruppa 2959",
    transform: "translate(27.153 34.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2958",
    "data-name": "Raggruppa 2958",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1111",
    "data-name": "Rettangolo 1111",
    width: 3,
    height: 4,
    transform: "translate(0.154 0.041)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2961",
    "data-name": "Raggruppa 2961",
    transform: "translate(38.394 34.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2960",
    "data-name": "Raggruppa 2960",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1112",
    "data-name": "Rettangolo 1112",
    width: 4,
    height: 4,
    transform: "translate(-0.086 0.041)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2963",
    "data-name": "Raggruppa 2963",
    transform: "translate(42.328 34.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2962",
    "data-name": "Raggruppa 2962",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1113",
    "data-name": "Rettangolo 1113",
    width: 4,
    height: 4,
    transform: "translate(-0.021 0.041)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2965",
    "data-name": "Raggruppa 2965",
    transform: "translate(46.262 34.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2964",
    "data-name": "Raggruppa 2964",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1114",
    "data-name": "Rettangolo 1114",
    width: 4,
    height: 4,
    transform: "translate(0.045 0.041)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2967",
    "data-name": "Raggruppa 2967",
    transform: "translate(61.437 34.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2966",
    "data-name": "Raggruppa 2966",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1115",
    "data-name": "Rettangolo 1115",
    width: 4,
    height: 4,
    transform: "translate(-0.129 0.041)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2969",
    "data-name": "Raggruppa 2969",
    transform: "translate(84.48 34.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2968",
    "data-name": "Raggruppa 2968",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1116",
    "data-name": "Rettangolo 1116",
    width: 4,
    height: 4,
    transform: "translate(-0.173 0.041)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2971",
    "data-name": "Raggruppa 2971",
    transform: "translate(92.349 34.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2970",
    "data-name": "Raggruppa 2970",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1117",
    "data-name": "Rettangolo 1117",
    width: 4,
    height: 4,
    transform: "translate(-0.041 0.041)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2973",
    "data-name": "Raggruppa 2973",
    transform: "translate(96.283 34.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2972",
    "data-name": "Raggruppa 2972",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1118",
    "data-name": "Rettangolo 1118",
    width: 3,
    height: 4,
    transform: "translate(0.025 0.041)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2975",
    "data-name": "Raggruppa 2975",
    transform: "translate(99.655 34.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2974",
    "data-name": "Raggruppa 2974",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1119",
    "data-name": "Rettangolo 1119",
    width: 4,
    height: 4,
    transform: "translate(-0.347 0.041)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2977",
    "data-name": "Raggruppa 2977",
    transform: "translate(103.589 34.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2976",
    "data-name": "Raggruppa 2976",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1120",
    "data-name": "Rettangolo 1120",
    width: 4,
    height: 4,
    transform: "translate(-0.282 0.041)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2979",
    "data-name": "Raggruppa 2979",
    transform: "translate(119.326 34.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2978",
    "data-name": "Raggruppa 2978",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1121",
    "data-name": "Rettangolo 1121",
    width: 3,
    height: 4,
    transform: "translate(-0.018 0.041)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2981",
    "data-name": "Raggruppa 2981",
    transform: "translate(122.698 34.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2980",
    "data-name": "Raggruppa 2980",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1122",
    "data-name": "Rettangolo 1122",
    width: 4,
    height: 4,
    transform: "translate(-0.391 0.041)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2983",
    "data-name": "Raggruppa 2983",
    transform: "translate(4.11 38.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2982",
    "data-name": "Raggruppa 2982",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1123",
    "data-name": "Rettangolo 1123",
    width: 3,
    height: 4,
    transform: "translate(0.198 0.107)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2985",
    "data-name": "Raggruppa 2985",
    transform: "translate(11.416 38.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2984",
    "data-name": "Raggruppa 2984",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1124",
    "data-name": "Rettangolo 1124",
    width: 4,
    height: 4,
    transform: "translate(-0.109 0.107)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2987",
    "data-name": "Raggruppa 2987",
    transform: "translate(15.351 38.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2986",
    "data-name": "Raggruppa 2986",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1125",
    "data-name": "Rettangolo 1125",
    width: 4,
    height: 4,
    transform: "translate(-0.043 0.107)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2989",
    "data-name": "Raggruppa 2989",
    transform: "translate(19.285 38.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2988",
    "data-name": "Raggruppa 2988",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1126",
    "data-name": "Rettangolo 1126",
    width: 4,
    height: 4,
    transform: "translate(0.023 0.107)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2991",
    "data-name": "Raggruppa 2991",
    transform: "translate(23.219 38.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2990",
    "data-name": "Raggruppa 2990",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1127",
    "data-name": "Rettangolo 1127",
    width: 4,
    height: 4,
    transform: "translate(0.088 0.107)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2993",
    "data-name": "Raggruppa 2993",
    transform: "translate(27.153 38.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2992",
    "data-name": "Raggruppa 2992",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1128",
    "data-name": "Rettangolo 1128",
    width: 3,
    height: 4,
    transform: "translate(0.154 0.107)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2995",
    "data-name": "Raggruppa 2995",
    transform: "translate(30.525 38.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2994",
    "data-name": "Raggruppa 2994",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1129",
    "data-name": "Rettangolo 1129",
    width: 4,
    height: 4,
    transform: "translate(-0.218 0.107)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2997",
    "data-name": "Raggruppa 2997",
    transform: "translate(34.46 38.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2996",
    "data-name": "Raggruppa 2996",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1130",
    "data-name": "Rettangolo 1130",
    width: 4,
    height: 4,
    transform: "translate(-0.152 0.107)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2999",
    "data-name": "Raggruppa 2999",
    transform: "translate(46.262 38.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2998",
    "data-name": "Raggruppa 2998",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1131",
    "data-name": "Rettangolo 1131",
    width: 4,
    height: 4,
    transform: "translate(0.045 0.107)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3001",
    "data-name": "Raggruppa 3001",
    transform: "translate(65.371 38.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3000",
    "data-name": "Raggruppa 3000",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1132",
    "data-name": "Rettangolo 1132",
    width: 4,
    height: 4,
    transform: "translate(-0.064 0.107)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3003",
    "data-name": "Raggruppa 3003",
    transform: "translate(73.239 38.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3002",
    "data-name": "Raggruppa 3002",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1133",
    "data-name": "Rettangolo 1133",
    width: 3,
    height: 4,
    transform: "translate(0.068 0.107)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3005",
    "data-name": "Raggruppa 3005",
    transform: "translate(76.612 38.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3004",
    "data-name": "Raggruppa 3004",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1134",
    "data-name": "Rettangolo 1134",
    width: 4,
    height: 4,
    transform: "translate(-0.304 0.107)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3007",
    "data-name": "Raggruppa 3007",
    transform: "translate(84.48 38.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3006",
    "data-name": "Raggruppa 3006",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1135",
    "data-name": "Rettangolo 1135",
    width: 4,
    height: 4,
    transform: "translate(-0.173 0.107)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3009",
    "data-name": "Raggruppa 3009",
    transform: "translate(96.283 38.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3008",
    "data-name": "Raggruppa 3008",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1136",
    "data-name": "Rettangolo 1136",
    width: 3,
    height: 4,
    transform: "translate(0.025 0.107)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3011",
    "data-name": "Raggruppa 3011",
    transform: "translate(99.655 38.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3010",
    "data-name": "Raggruppa 3010",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1137",
    "data-name": "Rettangolo 1137",
    width: 4,
    height: 4,
    transform: "translate(-0.347 0.107)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3013",
    "data-name": "Raggruppa 3013",
    transform: "translate(103.589 38.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3012",
    "data-name": "Raggruppa 3012",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1138",
    "data-name": "Rettangolo 1138",
    width: 4,
    height: 4,
    transform: "translate(-0.282 0.107)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3015",
    "data-name": "Raggruppa 3015",
    transform: "translate(107.523 38.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3014",
    "data-name": "Raggruppa 3014",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1139",
    "data-name": "Rettangolo 1139",
    width: 4,
    height: 4,
    transform: "translate(-0.216 0.107)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3017",
    "data-name": "Raggruppa 3017",
    transform: "translate(115.392 38.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3016",
    "data-name": "Raggruppa 3016",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1140",
    "data-name": "Rettangolo 1140",
    width: 4,
    height: 4,
    transform: "translate(-0.084 0.107)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3019",
    "data-name": "Raggruppa 3019",
    transform: "translate(119.326 38.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3018",
    "data-name": "Raggruppa 3018",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1141",
    "data-name": "Rettangolo 1141",
    width: 3,
    height: 4,
    transform: "translate(-0.018 0.107)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3021",
    "data-name": "Raggruppa 3021",
    transform: "translate(122.698 38.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3020",
    "data-name": "Raggruppa 3020",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1142",
    "data-name": "Rettangolo 1142",
    width: 4,
    height: 4,
    transform: "translate(-0.391 0.107)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3023",
    "data-name": "Raggruppa 3023",
    transform: "translate(27.153 42.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3022",
    "data-name": "Raggruppa 3022",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1143",
    "data-name": "Rettangolo 1143",
    width: 3,
    height: 4,
    transform: "translate(0.154 0.173)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3025",
    "data-name": "Raggruppa 3025",
    transform: "translate(30.525 42.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3024",
    "data-name": "Raggruppa 3024",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1144",
    "data-name": "Rettangolo 1144",
    width: 4,
    height: 4,
    transform: "translate(-0.218 0.173)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3027",
    "data-name": "Raggruppa 3027",
    transform: "translate(34.46 42.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3026",
    "data-name": "Raggruppa 3026",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1145",
    "data-name": "Rettangolo 1145",
    width: 4,
    height: 4,
    transform: "translate(-0.152 0.173)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3029",
    "data-name": "Raggruppa 3029",
    transform: "translate(53.569 42.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3028",
    "data-name": "Raggruppa 3028",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1146",
    "data-name": "Rettangolo 1146",
    width: 4,
    height: 4,
    transform: "translate(-0.261 0.173)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3031",
    "data-name": "Raggruppa 3031",
    transform: "translate(61.437 42.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3030",
    "data-name": "Raggruppa 3030",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1147",
    "data-name": "Rettangolo 1147",
    width: 4,
    height: 4,
    transform: "translate(-0.129 0.173)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3033",
    "data-name": "Raggruppa 3033",
    transform: "translate(65.371 42.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3032",
    "data-name": "Raggruppa 3032",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1148",
    "data-name": "Rettangolo 1148",
    width: 4,
    height: 4,
    transform: "translate(-0.064 0.173)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3035",
    "data-name": "Raggruppa 3035",
    transform: "translate(76.612 42.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3034",
    "data-name": "Raggruppa 3034",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1149",
    "data-name": "Rettangolo 1149",
    width: 4,
    height: 4,
    transform: "translate(-0.304 0.173)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3037",
    "data-name": "Raggruppa 3037",
    transform: "translate(80.546 42.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3036",
    "data-name": "Raggruppa 3036",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1150",
    "data-name": "Rettangolo 1150",
    width: 4,
    height: 4,
    transform: "translate(-0.239 0.173)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3039",
    "data-name": "Raggruppa 3039",
    transform: "translate(84.48 42.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3038",
    "data-name": "Raggruppa 3038",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1151",
    "data-name": "Rettangolo 1151",
    width: 4,
    height: 4,
    transform: "translate(-0.173 0.173)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3041",
    "data-name": "Raggruppa 3041",
    transform: "translate(88.414 42.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3040",
    "data-name": "Raggruppa 3040",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1152",
    "data-name": "Rettangolo 1152",
    width: 4,
    height: 4,
    transform: "translate(-0.107 0.173)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3043",
    "data-name": "Raggruppa 3043",
    transform: "translate(92.349 42.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3042",
    "data-name": "Raggruppa 3042",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1153",
    "data-name": "Rettangolo 1153",
    width: 4,
    height: 4,
    transform: "translate(-0.041 0.173)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3045",
    "data-name": "Raggruppa 3045",
    transform: "translate(96.283 42.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3044",
    "data-name": "Raggruppa 3044",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1154",
    "data-name": "Rettangolo 1154",
    width: 3,
    height: 4,
    transform: "translate(0.025 0.173)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3047",
    "data-name": "Raggruppa 3047",
    transform: "translate(107.523 42.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3046",
    "data-name": "Raggruppa 3046",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1155",
    "data-name": "Rettangolo 1155",
    width: 4,
    height: 4,
    transform: "translate(-0.216 0.173)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3049",
    "data-name": "Raggruppa 3049",
    transform: "translate(111.458 42.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3048",
    "data-name": "Raggruppa 3048",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1156",
    "data-name": "Rettangolo 1156",
    width: 4,
    height: 4,
    transform: "translate(-0.15 0.173)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3051",
    "data-name": "Raggruppa 3051",
    transform: "translate(119.326 42.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3050",
    "data-name": "Raggruppa 3050",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1157",
    "data-name": "Rettangolo 1157",
    width: 3,
    height: 4,
    transform: "translate(-0.018 0.173)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3053",
    "data-name": "Raggruppa 3053",
    transform: "translate(4.11 46.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3052",
    "data-name": "Raggruppa 3052",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1158",
    "data-name": "Rettangolo 1158",
    width: 3,
    height: 4,
    transform: "translate(0.198 0.238)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3055",
    "data-name": "Raggruppa 3055",
    transform: "translate(11.416 46.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3054",
    "data-name": "Raggruppa 3054",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1159",
    "data-name": "Rettangolo 1159",
    width: 4,
    height: 4,
    transform: "translate(-0.109 0.238)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3057",
    "data-name": "Raggruppa 3057",
    transform: "translate(23.219 46.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3056",
    "data-name": "Raggruppa 3056",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1160",
    "data-name": "Rettangolo 1160",
    width: 4,
    height: 4,
    transform: "translate(0.088 0.238)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3059",
    "data-name": "Raggruppa 3059",
    transform: "translate(27.153 46.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3058",
    "data-name": "Raggruppa 3058",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1161",
    "data-name": "Rettangolo 1161",
    width: 3,
    height: 4,
    transform: "translate(0.154 0.238)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3061",
    "data-name": "Raggruppa 3061",
    transform: "translate(30.525 46.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3060",
    "data-name": "Raggruppa 3060",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1162",
    "data-name": "Rettangolo 1162",
    width: 4,
    height: 4,
    transform: "translate(-0.218 0.238)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3063",
    "data-name": "Raggruppa 3063",
    transform: "translate(34.46 46.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3062",
    "data-name": "Raggruppa 3062",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1163",
    "data-name": "Rettangolo 1163",
    width: 4,
    height: 4,
    transform: "translate(-0.152 0.238)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3065",
    "data-name": "Raggruppa 3065",
    transform: "translate(42.328 46.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3064",
    "data-name": "Raggruppa 3064",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1164",
    "data-name": "Rettangolo 1164",
    width: 4,
    height: 4,
    transform: "translate(-0.021 0.238)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3067",
    "data-name": "Raggruppa 3067",
    transform: "translate(46.262 46.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3066",
    "data-name": "Raggruppa 3066",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1165",
    "data-name": "Rettangolo 1165",
    width: 4,
    height: 4,
    transform: "translate(0.045 0.238)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3069",
    "data-name": "Raggruppa 3069",
    transform: "translate(57.503 46.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3068",
    "data-name": "Raggruppa 3068",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1166",
    "data-name": "Rettangolo 1166",
    width: 4,
    height: 4,
    transform: "translate(-0.195 0.238)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3071",
    "data-name": "Raggruppa 3071",
    transform: "translate(80.546 46.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3070",
    "data-name": "Raggruppa 3070",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1167",
    "data-name": "Rettangolo 1167",
    width: 4,
    height: 4,
    transform: "translate(-0.239 0.238)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3073",
    "data-name": "Raggruppa 3073",
    transform: "translate(88.414 46.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3072",
    "data-name": "Raggruppa 3072",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1168",
    "data-name": "Rettangolo 1168",
    width: 4,
    height: 4,
    transform: "translate(-0.107 0.238)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3075",
    "data-name": "Raggruppa 3075",
    transform: "translate(92.349 46.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3074",
    "data-name": "Raggruppa 3074",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1169",
    "data-name": "Rettangolo 1169",
    width: 4,
    height: 4,
    transform: "translate(-0.041 0.238)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3077",
    "data-name": "Raggruppa 3077",
    transform: "translate(96.283 46.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3076",
    "data-name": "Raggruppa 3076",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1170",
    "data-name": "Rettangolo 1170",
    width: 3,
    height: 4,
    transform: "translate(0.025 0.238)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3079",
    "data-name": "Raggruppa 3079",
    transform: "translate(99.655 46.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3078",
    "data-name": "Raggruppa 3078",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1171",
    "data-name": "Rettangolo 1171",
    width: 4,
    height: 4,
    transform: "translate(-0.347 0.238)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3081",
    "data-name": "Raggruppa 3081",
    transform: "translate(103.589 46.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3080",
    "data-name": "Raggruppa 3080",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1172",
    "data-name": "Rettangolo 1172",
    width: 4,
    height: 4,
    transform: "translate(-0.282 0.238)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3083",
    "data-name": "Raggruppa 3083",
    transform: "translate(111.458 46.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3082",
    "data-name": "Raggruppa 3082",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1173",
    "data-name": "Rettangolo 1173",
    width: 4,
    height: 4,
    transform: "translate(-0.15 0.238)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3085",
    "data-name": "Raggruppa 3085",
    transform: "translate(119.326 46.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3084",
    "data-name": "Raggruppa 3084",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1174",
    "data-name": "Rettangolo 1174",
    width: 3,
    height: 4,
    transform: "translate(-0.018 0.238)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3087",
    "data-name": "Raggruppa 3087",
    transform: "translate(122.698 46.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3086",
    "data-name": "Raggruppa 3086",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1175",
    "data-name": "Rettangolo 1175",
    width: 4,
    height: 4,
    transform: "translate(-0.391 0.238)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3089",
    "data-name": "Raggruppa 3089",
    transform: "translate(4.11 50.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3088",
    "data-name": "Raggruppa 3088",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1176",
    "data-name": "Rettangolo 1176",
    width: 3,
    height: 3,
    transform: "translate(0.198 0.304)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3091",
    "data-name": "Raggruppa 3091",
    transform: "translate(15.351 50.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3090",
    "data-name": "Raggruppa 3090",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1177",
    "data-name": "Rettangolo 1177",
    width: 4,
    height: 3,
    transform: "translate(-0.043 0.304)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3093",
    "data-name": "Raggruppa 3093",
    transform: "translate(19.285 50.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3092",
    "data-name": "Raggruppa 3092",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1178",
    "data-name": "Rettangolo 1178",
    width: 4,
    height: 3,
    transform: "translate(0.023 0.304)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3095",
    "data-name": "Raggruppa 3095",
    transform: "translate(27.153 50.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3094",
    "data-name": "Raggruppa 3094",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1179",
    "data-name": "Rettangolo 1179",
    width: 3,
    height: 3,
    transform: "translate(0.154 0.304)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3097",
    "data-name": "Raggruppa 3097",
    transform: "translate(38.394 50.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3096",
    "data-name": "Raggruppa 3096",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1180",
    "data-name": "Rettangolo 1180",
    width: 4,
    height: 3,
    transform: "translate(-0.086 0.304)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3099",
    "data-name": "Raggruppa 3099",
    transform: "translate(57.503 50.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3098",
    "data-name": "Raggruppa 3098",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1181",
    "data-name": "Rettangolo 1181",
    width: 4,
    height: 3,
    transform: "translate(-0.195 0.304)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3101",
    "data-name": "Raggruppa 3101",
    transform: "translate(61.437 50.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3100",
    "data-name": "Raggruppa 3100",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1182",
    "data-name": "Rettangolo 1182",
    width: 4,
    height: 3,
    transform: "translate(-0.129 0.304)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3103",
    "data-name": "Raggruppa 3103",
    transform: "translate(80.546 50.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3102",
    "data-name": "Raggruppa 3102",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1183",
    "data-name": "Rettangolo 1183",
    width: 4,
    height: 3,
    transform: "translate(-0.239 0.304)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3105",
    "data-name": "Raggruppa 3105",
    transform: "translate(92.349 50.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3104",
    "data-name": "Raggruppa 3104",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1184",
    "data-name": "Rettangolo 1184",
    width: 4,
    height: 3,
    transform: "translate(-0.041 0.304)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3107",
    "data-name": "Raggruppa 3107",
    transform: "translate(99.655 50.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3106",
    "data-name": "Raggruppa 3106",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1185",
    "data-name": "Rettangolo 1185",
    width: 4,
    height: 3,
    transform: "translate(-0.347 0.304)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3109",
    "data-name": "Raggruppa 3109",
    transform: "translate(107.523 50.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3108",
    "data-name": "Raggruppa 3108",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1186",
    "data-name": "Rettangolo 1186",
    width: 4,
    height: 3,
    transform: "translate(-0.216 0.304)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3111",
    "data-name": "Raggruppa 3111",
    transform: "translate(115.392 50.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3110",
    "data-name": "Raggruppa 3110",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1187",
    "data-name": "Rettangolo 1187",
    width: 4,
    height: 3,
    transform: "translate(-0.084 0.304)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3113",
    "data-name": "Raggruppa 3113",
    transform: "translate(119.326 50.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3112",
    "data-name": "Raggruppa 3112",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1188",
    "data-name": "Rettangolo 1188",
    width: 3,
    height: 3,
    transform: "translate(-0.018 0.304)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3115",
    "data-name": "Raggruppa 3115",
    transform: "translate(122.698 50.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3114",
    "data-name": "Raggruppa 3114",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1189",
    "data-name": "Rettangolo 1189",
    width: 4,
    height: 3,
    transform: "translate(-0.391 0.304)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3117",
    "data-name": "Raggruppa 3117",
    transform: "translate(7.482 53.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3116",
    "data-name": "Raggruppa 3116",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1190",
    "data-name": "Rettangolo 1190",
    width: 4,
    height: 4,
    transform: "translate(-0.175 -0.068)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3119",
    "data-name": "Raggruppa 3119",
    transform: "translate(11.416 53.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3118",
    "data-name": "Raggruppa 3118",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1191",
    "data-name": "Rettangolo 1191",
    width: 4,
    height: 4,
    transform: "translate(-0.109 -0.068)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3121",
    "data-name": "Raggruppa 3121",
    transform: "translate(19.285 53.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3120",
    "data-name": "Raggruppa 3120",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1192",
    "data-name": "Rettangolo 1192",
    width: 4,
    height: 4,
    transform: "translate(0.023 -0.068)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3123",
    "data-name": "Raggruppa 3123",
    transform: "translate(23.219 53.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3122",
    "data-name": "Raggruppa 3122",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1193",
    "data-name": "Rettangolo 1193",
    width: 4,
    height: 4,
    transform: "translate(0.088 -0.068)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3125",
    "data-name": "Raggruppa 3125",
    transform: "translate(30.525 53.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3124",
    "data-name": "Raggruppa 3124",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1194",
    "data-name": "Rettangolo 1194",
    width: 4,
    height: 4,
    transform: "translate(-0.218 -0.068)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3127",
    "data-name": "Raggruppa 3127",
    transform: "translate(34.46 53.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3126",
    "data-name": "Raggruppa 3126",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1195",
    "data-name": "Rettangolo 1195",
    width: 4,
    height: 4,
    transform: "translate(-0.152 -0.068)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3129",
    "data-name": "Raggruppa 3129",
    transform: "translate(42.328 53.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3128",
    "data-name": "Raggruppa 3128",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1196",
    "data-name": "Rettangolo 1196",
    width: 4,
    height: 4,
    transform: "translate(-0.021 -0.068)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3131",
    "data-name": "Raggruppa 3131",
    transform: "translate(46.262 53.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3130",
    "data-name": "Raggruppa 3130",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1197",
    "data-name": "Rettangolo 1197",
    width: 4,
    height: 4,
    transform: "translate(0.045 -0.068)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3133",
    "data-name": "Raggruppa 3133",
    transform: "translate(50.197 53.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3132",
    "data-name": "Raggruppa 3132",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1198",
    "data-name": "Rettangolo 1198",
    width: 3,
    height: 4,
    transform: "translate(0.111 -0.068)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3135",
    "data-name": "Raggruppa 3135",
    transform: "translate(53.569 53.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3134",
    "data-name": "Raggruppa 3134",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1199",
    "data-name": "Rettangolo 1199",
    width: 4,
    height: 4,
    transform: "translate(-0.261 -0.068)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3137",
    "data-name": "Raggruppa 3137",
    transform: "translate(65.371 53.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3136",
    "data-name": "Raggruppa 3136",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1200",
    "data-name": "Rettangolo 1200",
    width: 4,
    height: 4,
    transform: "translate(-0.064 -0.068)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3139",
    "data-name": "Raggruppa 3139",
    transform: "translate(69.305 53.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3138",
    "data-name": "Raggruppa 3138",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1201",
    "data-name": "Rettangolo 1201",
    width: 4,
    height: 4,
    transform: "translate(0.002 -0.068)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3141",
    "data-name": "Raggruppa 3141",
    transform: "translate(76.612 53.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3140",
    "data-name": "Raggruppa 3140",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1202",
    "data-name": "Rettangolo 1202",
    width: 4,
    height: 4,
    transform: "translate(-0.304 -0.068)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3143",
    "data-name": "Raggruppa 3143",
    transform: "translate(80.546 53.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3142",
    "data-name": "Raggruppa 3142",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1203",
    "data-name": "Rettangolo 1203",
    width: 4,
    height: 4,
    transform: "translate(-0.239 -0.068)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3145",
    "data-name": "Raggruppa 3145",
    transform: "translate(84.48 53.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3144",
    "data-name": "Raggruppa 3144",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1204",
    "data-name": "Rettangolo 1204",
    width: 4,
    height: 4,
    transform: "translate(-0.173 -0.068)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3147",
    "data-name": "Raggruppa 3147",
    transform: "translate(88.414 53.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3146",
    "data-name": "Raggruppa 3146",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1205",
    "data-name": "Rettangolo 1205",
    width: 4,
    height: 4,
    transform: "translate(-0.107 -0.068)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3149",
    "data-name": "Raggruppa 3149",
    transform: "translate(96.283 53.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3148",
    "data-name": "Raggruppa 3148",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1206",
    "data-name": "Rettangolo 1206",
    width: 3,
    height: 4,
    transform: "translate(0.025 -0.068)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3151",
    "data-name": "Raggruppa 3151",
    transform: "translate(99.655 53.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3150",
    "data-name": "Raggruppa 3150",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1207",
    "data-name": "Rettangolo 1207",
    width: 4,
    height: 4,
    transform: "translate(-0.347 -0.068)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3153",
    "data-name": "Raggruppa 3153",
    transform: "translate(103.589 53.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3152",
    "data-name": "Raggruppa 3152",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1208",
    "data-name": "Rettangolo 1208",
    width: 4,
    height: 4,
    transform: "translate(-0.282 -0.068)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3155",
    "data-name": "Raggruppa 3155",
    transform: "translate(111.458 53.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3154",
    "data-name": "Raggruppa 3154",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1209",
    "data-name": "Rettangolo 1209",
    width: 4,
    height: 4,
    transform: "translate(-0.15 -0.068)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3157",
    "data-name": "Raggruppa 3157",
    transform: "translate(119.326 53.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3156",
    "data-name": "Raggruppa 3156",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1210",
    "data-name": "Rettangolo 1210",
    width: 3,
    height: 4,
    transform: "translate(-0.018 -0.068)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3159",
    "data-name": "Raggruppa 3159",
    transform: "translate(4.11 57.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3158",
    "data-name": "Raggruppa 3158",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1211",
    "data-name": "Rettangolo 1211",
    width: 3,
    height: 4,
    transform: "translate(0.198 -0.002)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3161",
    "data-name": "Raggruppa 3161",
    transform: "translate(15.351 57.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3160",
    "data-name": "Raggruppa 3160",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1212",
    "data-name": "Rettangolo 1212",
    width: 4,
    height: 4,
    transform: "translate(-0.043 -0.002)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3163",
    "data-name": "Raggruppa 3163",
    transform: "translate(19.285 57.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3162",
    "data-name": "Raggruppa 3162",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1213",
    "data-name": "Rettangolo 1213",
    width: 4,
    height: 4,
    transform: "translate(0.023 -0.002)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3165",
    "data-name": "Raggruppa 3165",
    transform: "translate(34.46 57.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3164",
    "data-name": "Raggruppa 3164",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1214",
    "data-name": "Rettangolo 1214",
    width: 4,
    height: 4,
    transform: "translate(-0.152 -0.002)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3167",
    "data-name": "Raggruppa 3167",
    transform: "translate(38.394 57.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3166",
    "data-name": "Raggruppa 3166",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1215",
    "data-name": "Rettangolo 1215",
    width: 4,
    height: 4,
    transform: "translate(-0.086 -0.002)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3169",
    "data-name": "Raggruppa 3169",
    transform: "translate(46.262 57.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3168",
    "data-name": "Raggruppa 3168",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1216",
    "data-name": "Rettangolo 1216",
    width: 4,
    height: 4,
    transform: "translate(0.045 -0.002)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3171",
    "data-name": "Raggruppa 3171",
    transform: "translate(53.569 57.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3170",
    "data-name": "Raggruppa 3170",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1217",
    "data-name": "Rettangolo 1217",
    width: 4,
    height: 4,
    transform: "translate(-0.261 -0.002)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3173",
    "data-name": "Raggruppa 3173",
    transform: "translate(57.503 57.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3172",
    "data-name": "Raggruppa 3172",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1218",
    "data-name": "Rettangolo 1218",
    width: 4,
    height: 4,
    transform: "translate(-0.195 -0.002)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3175",
    "data-name": "Raggruppa 3175",
    transform: "translate(65.371 57.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3174",
    "data-name": "Raggruppa 3174",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1219",
    "data-name": "Rettangolo 1219",
    width: 4,
    height: 4,
    transform: "translate(-0.064 -0.002)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3177",
    "data-name": "Raggruppa 3177",
    transform: "translate(69.305 57.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3176",
    "data-name": "Raggruppa 3176",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1220",
    "data-name": "Rettangolo 1220",
    width: 4,
    height: 4,
    transform: "translate(0.002 -0.002)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3179",
    "data-name": "Raggruppa 3179",
    transform: "translate(73.239 57.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3178",
    "data-name": "Raggruppa 3178",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1221",
    "data-name": "Rettangolo 1221",
    width: 3,
    height: 4,
    transform: "translate(0.068 -0.002)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3181",
    "data-name": "Raggruppa 3181",
    transform: "translate(80.546 57.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3180",
    "data-name": "Raggruppa 3180",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1222",
    "data-name": "Rettangolo 1222",
    width: 4,
    height: 4,
    transform: "translate(-0.239 -0.002)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3183",
    "data-name": "Raggruppa 3183",
    transform: "translate(84.48 57.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3182",
    "data-name": "Raggruppa 3182",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1223",
    "data-name": "Rettangolo 1223",
    width: 4,
    height: 4,
    transform: "translate(-0.173 -0.002)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3185",
    "data-name": "Raggruppa 3185",
    transform: "translate(88.414 57.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3184",
    "data-name": "Raggruppa 3184",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1224",
    "data-name": "Rettangolo 1224",
    width: 4,
    height: 4,
    transform: "translate(-0.107 -0.002)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3187",
    "data-name": "Raggruppa 3187",
    transform: "translate(99.655 57.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3186",
    "data-name": "Raggruppa 3186",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1225",
    "data-name": "Rettangolo 1225",
    width: 4,
    height: 4,
    transform: "translate(-0.347 -0.002)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3189",
    "data-name": "Raggruppa 3189",
    transform: "translate(107.523 57.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3188",
    "data-name": "Raggruppa 3188",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1226",
    "data-name": "Rettangolo 1226",
    width: 4,
    height: 4,
    transform: "translate(-0.216 -0.002)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3191",
    "data-name": "Raggruppa 3191",
    transform: "translate(119.326 57.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3190",
    "data-name": "Raggruppa 3190",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1227",
    "data-name": "Rettangolo 1227",
    width: 3,
    height: 4,
    transform: "translate(-0.018 -0.002)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3193",
    "data-name": "Raggruppa 3193",
    transform: "translate(0.176 61.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3192",
    "data-name": "Raggruppa 3192",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1228",
    "data-name": "Rettangolo 1228",
    width: 4,
    height: 4,
    transform: "translate(0.132 0.063)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3195",
    "data-name": "Raggruppa 3195",
    transform: "translate(15.351 61.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3194",
    "data-name": "Raggruppa 3194",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1229",
    "data-name": "Rettangolo 1229",
    width: 4,
    height: 4,
    transform: "translate(-0.043 0.063)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3197",
    "data-name": "Raggruppa 3197",
    transform: "translate(19.285 61.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3196",
    "data-name": "Raggruppa 3196",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1230",
    "data-name": "Rettangolo 1230",
    width: 4,
    height: 4,
    transform: "translate(0.023 0.063)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3199",
    "data-name": "Raggruppa 3199",
    transform: "translate(23.219 61.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3198",
    "data-name": "Raggruppa 3198",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1231",
    "data-name": "Rettangolo 1231",
    width: 4,
    height: 4,
    transform: "translate(0.088 0.063)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3201",
    "data-name": "Raggruppa 3201",
    transform: "translate(27.153 61.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3200",
    "data-name": "Raggruppa 3200",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1232",
    "data-name": "Rettangolo 1232",
    width: 3,
    height: 4,
    transform: "translate(0.154 0.063)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3203",
    "data-name": "Raggruppa 3203",
    transform: "translate(30.525 61.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3202",
    "data-name": "Raggruppa 3202",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1233",
    "data-name": "Rettangolo 1233",
    width: 4,
    height: 4,
    transform: "translate(-0.218 0.063)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3205",
    "data-name": "Raggruppa 3205",
    transform: "translate(42.328 61.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3204",
    "data-name": "Raggruppa 3204",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1234",
    "data-name": "Rettangolo 1234",
    width: 4,
    height: 4,
    transform: "translate(-0.021 0.063)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3207",
    "data-name": "Raggruppa 3207",
    transform: "translate(53.569 61.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3206",
    "data-name": "Raggruppa 3206",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1235",
    "data-name": "Rettangolo 1235",
    width: 4,
    height: 4,
    transform: "translate(-0.261 0.063)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3209",
    "data-name": "Raggruppa 3209",
    transform: "translate(65.371 61.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3208",
    "data-name": "Raggruppa 3208",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1236",
    "data-name": "Rettangolo 1236",
    width: 4,
    height: 4,
    transform: "translate(-0.064 0.063)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3211",
    "data-name": "Raggruppa 3211",
    transform: "translate(73.239 61.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3210",
    "data-name": "Raggruppa 3210",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1237",
    "data-name": "Rettangolo 1237",
    width: 3,
    height: 4,
    transform: "translate(0.068 0.063)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3213",
    "data-name": "Raggruppa 3213",
    transform: "translate(80.546 61.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3212",
    "data-name": "Raggruppa 3212",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1238",
    "data-name": "Rettangolo 1238",
    width: 4,
    height: 4,
    transform: "translate(-0.239 0.063)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3215",
    "data-name": "Raggruppa 3215",
    transform: "translate(84.48 61.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3214",
    "data-name": "Raggruppa 3214",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1239",
    "data-name": "Rettangolo 1239",
    width: 4,
    height: 4,
    transform: "translate(-0.173 0.063)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3217",
    "data-name": "Raggruppa 3217",
    transform: "translate(88.414 61.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3216",
    "data-name": "Raggruppa 3216",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1240",
    "data-name": "Rettangolo 1240",
    width: 4,
    height: 4,
    transform: "translate(-0.107 0.063)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3219",
    "data-name": "Raggruppa 3219",
    transform: "translate(92.349 61.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3218",
    "data-name": "Raggruppa 3218",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1241",
    "data-name": "Rettangolo 1241",
    width: 4,
    height: 4,
    transform: "translate(-0.041 0.063)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3221",
    "data-name": "Raggruppa 3221",
    transform: "translate(99.655 61.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3220",
    "data-name": "Raggruppa 3220",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1242",
    "data-name": "Rettangolo 1242",
    width: 4,
    height: 4,
    transform: "translate(-0.347 0.063)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3223",
    "data-name": "Raggruppa 3223",
    transform: "translate(107.523 61.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3222",
    "data-name": "Raggruppa 3222",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1243",
    "data-name": "Rettangolo 1243",
    width: 4,
    height: 4,
    transform: "translate(-0.216 0.063)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3225",
    "data-name": "Raggruppa 3225",
    transform: "translate(119.326 61.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3224",
    "data-name": "Raggruppa 3224",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1244",
    "data-name": "Rettangolo 1244",
    width: 3,
    height: 4,
    transform: "translate(-0.018 0.063)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3227",
    "data-name": "Raggruppa 3227",
    transform: "translate(0.176 65.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3226",
    "data-name": "Raggruppa 3226",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1245",
    "data-name": "Rettangolo 1245",
    width: 4,
    height: 4,
    transform: "translate(0.132 0.13)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3229",
    "data-name": "Raggruppa 3229",
    transform: "translate(4.11 65.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3228",
    "data-name": "Raggruppa 3228",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1246",
    "data-name": "Rettangolo 1246",
    width: 3,
    height: 4,
    transform: "translate(0.198 0.13)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3231",
    "data-name": "Raggruppa 3231",
    transform: "translate(15.351 65.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3230",
    "data-name": "Raggruppa 3230",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1247",
    "data-name": "Rettangolo 1247",
    width: 4,
    height: 4,
    transform: "translate(-0.043 0.13)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3233",
    "data-name": "Raggruppa 3233",
    transform: "translate(19.285 65.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3232",
    "data-name": "Raggruppa 3232",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1248",
    "data-name": "Rettangolo 1248",
    width: 4,
    height: 4,
    transform: "translate(0.023 0.13)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3235",
    "data-name": "Raggruppa 3235",
    transform: "translate(27.153 65.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3234",
    "data-name": "Raggruppa 3234",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1249",
    "data-name": "Rettangolo 1249",
    width: 3,
    height: 4,
    transform: "translate(0.154 0.13)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3237",
    "data-name": "Raggruppa 3237",
    transform: "translate(34.46 65.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3236",
    "data-name": "Raggruppa 3236",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1250",
    "data-name": "Rettangolo 1250",
    width: 4,
    height: 4,
    transform: "translate(-0.152 0.13)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3239",
    "data-name": "Raggruppa 3239",
    transform: "translate(42.328 65.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3238",
    "data-name": "Raggruppa 3238",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1251",
    "data-name": "Rettangolo 1251",
    width: 4,
    height: 4,
    transform: "translate(-0.021 0.13)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3241",
    "data-name": "Raggruppa 3241",
    transform: "translate(53.569 65.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3240",
    "data-name": "Raggruppa 3240",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1252",
    "data-name": "Rettangolo 1252",
    width: 4,
    height: 4,
    transform: "translate(-0.261 0.13)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3243",
    "data-name": "Raggruppa 3243",
    transform: "translate(61.437 65.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3242",
    "data-name": "Raggruppa 3242",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1253",
    "data-name": "Rettangolo 1253",
    width: 4,
    height: 4,
    transform: "translate(-0.129 0.13)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3245",
    "data-name": "Raggruppa 3245",
    transform: "translate(76.612 65.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3244",
    "data-name": "Raggruppa 3244",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1254",
    "data-name": "Rettangolo 1254",
    width: 4,
    height: 4,
    transform: "translate(-0.304 0.13)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3247",
    "data-name": "Raggruppa 3247",
    transform: "translate(80.546 65.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3246",
    "data-name": "Raggruppa 3246",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1255",
    "data-name": "Rettangolo 1255",
    width: 4,
    height: 4,
    transform: "translate(-0.239 0.13)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3249",
    "data-name": "Raggruppa 3249",
    transform: "translate(88.414 65.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3248",
    "data-name": "Raggruppa 3248",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1256",
    "data-name": "Rettangolo 1256",
    width: 4,
    height: 4,
    transform: "translate(-0.107 0.13)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3251",
    "data-name": "Raggruppa 3251",
    transform: "translate(92.349 65.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3250",
    "data-name": "Raggruppa 3250",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1257",
    "data-name": "Rettangolo 1257",
    width: 4,
    height: 4,
    transform: "translate(-0.041 0.13)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3253",
    "data-name": "Raggruppa 3253",
    transform: "translate(103.589 65.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3252",
    "data-name": "Raggruppa 3252",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1258",
    "data-name": "Rettangolo 1258",
    width: 4,
    height: 4,
    transform: "translate(-0.282 0.13)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3255",
    "data-name": "Raggruppa 3255",
    transform: "translate(111.458 65.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3254",
    "data-name": "Raggruppa 3254",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1259",
    "data-name": "Rettangolo 1259",
    width: 4,
    height: 4,
    transform: "translate(-0.15 0.13)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3257",
    "data-name": "Raggruppa 3257",
    transform: "translate(0.176 69.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3256",
    "data-name": "Raggruppa 3256",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1260",
    "data-name": "Rettangolo 1260",
    width: 4,
    height: 4,
    transform: "translate(0.132 0.195)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3259",
    "data-name": "Raggruppa 3259",
    transform: "translate(4.11 69.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3258",
    "data-name": "Raggruppa 3258",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1261",
    "data-name": "Rettangolo 1261",
    width: 3,
    height: 4,
    transform: "translate(0.198 0.195)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3261",
    "data-name": "Raggruppa 3261",
    transform: "translate(7.482 69.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3260",
    "data-name": "Raggruppa 3260",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1262",
    "data-name": "Rettangolo 1262",
    width: 4,
    height: 4,
    transform: "translate(-0.175 0.195)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3263",
    "data-name": "Raggruppa 3263",
    transform: "translate(11.416 69.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3262",
    "data-name": "Raggruppa 3262",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1263",
    "data-name": "Rettangolo 1263",
    width: 4,
    height: 4,
    transform: "translate(-0.109 0.195)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3265",
    "data-name": "Raggruppa 3265",
    transform: "translate(15.351 69.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3264",
    "data-name": "Raggruppa 3264",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1264",
    "data-name": "Rettangolo 1264",
    width: 4,
    height: 4,
    transform: "translate(-0.043 0.195)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3267",
    "data-name": "Raggruppa 3267",
    transform: "translate(23.219 69.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3266",
    "data-name": "Raggruppa 3266",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1265",
    "data-name": "Rettangolo 1265",
    width: 4,
    height: 4,
    transform: "translate(0.088 0.195)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3269",
    "data-name": "Raggruppa 3269",
    transform: "translate(27.153 69.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3268",
    "data-name": "Raggruppa 3268",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1266",
    "data-name": "Rettangolo 1266",
    width: 3,
    height: 4,
    transform: "translate(0.154 0.195)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3271",
    "data-name": "Raggruppa 3271",
    transform: "translate(30.525 69.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3270",
    "data-name": "Raggruppa 3270",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1267",
    "data-name": "Rettangolo 1267",
    width: 4,
    height: 4,
    transform: "translate(-0.218 0.195)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3273",
    "data-name": "Raggruppa 3273",
    transform: "translate(34.46 69.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3272",
    "data-name": "Raggruppa 3272",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1268",
    "data-name": "Rettangolo 1268",
    width: 4,
    height: 4,
    transform: "translate(-0.152 0.195)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3275",
    "data-name": "Raggruppa 3275",
    transform: "translate(38.394 69.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3274",
    "data-name": "Raggruppa 3274",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1269",
    "data-name": "Rettangolo 1269",
    width: 4,
    height: 4,
    transform: "translate(-0.086 0.195)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3277",
    "data-name": "Raggruppa 3277",
    transform: "translate(42.328 69.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3276",
    "data-name": "Raggruppa 3276",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1270",
    "data-name": "Rettangolo 1270",
    width: 4,
    height: 4,
    transform: "translate(-0.021 0.195)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3279",
    "data-name": "Raggruppa 3279",
    transform: "translate(50.197 69.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3278",
    "data-name": "Raggruppa 3278",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1271",
    "data-name": "Rettangolo 1271",
    width: 3,
    height: 4,
    transform: "translate(0.111 0.195)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3281",
    "data-name": "Raggruppa 3281",
    transform: "translate(69.305 69.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3280",
    "data-name": "Raggruppa 3280",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1272",
    "data-name": "Rettangolo 1272",
    width: 4,
    height: 4,
    transform: "translate(0.002 0.195)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3283",
    "data-name": "Raggruppa 3283",
    transform: "translate(76.612 69.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3282",
    "data-name": "Raggruppa 3282",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1273",
    "data-name": "Rettangolo 1273",
    width: 4,
    height: 4,
    transform: "translate(-0.304 0.195)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3285",
    "data-name": "Raggruppa 3285",
    transform: "translate(80.546 69.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3284",
    "data-name": "Raggruppa 3284",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1274",
    "data-name": "Rettangolo 1274",
    width: 4,
    height: 4,
    transform: "translate(-0.239 0.195)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3287",
    "data-name": "Raggruppa 3287",
    transform: "translate(84.48 69.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3286",
    "data-name": "Raggruppa 3286",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1275",
    "data-name": "Rettangolo 1275",
    width: 4,
    height: 4,
    transform: "translate(-0.173 0.195)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3289",
    "data-name": "Raggruppa 3289",
    transform: "translate(92.349 69.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3288",
    "data-name": "Raggruppa 3288",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1276",
    "data-name": "Rettangolo 1276",
    width: 4,
    height: 4,
    transform: "translate(-0.041 0.195)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3291",
    "data-name": "Raggruppa 3291",
    transform: "translate(96.283 69.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3290",
    "data-name": "Raggruppa 3290",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1277",
    "data-name": "Rettangolo 1277",
    width: 3,
    height: 4,
    transform: "translate(0.025 0.195)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3293",
    "data-name": "Raggruppa 3293",
    transform: "translate(99.655 69.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3292",
    "data-name": "Raggruppa 3292",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1278",
    "data-name": "Rettangolo 1278",
    width: 4,
    height: 4,
    transform: "translate(-0.347 0.195)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3295",
    "data-name": "Raggruppa 3295",
    transform: "translate(115.392 69.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3294",
    "data-name": "Raggruppa 3294",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1279",
    "data-name": "Rettangolo 1279",
    width: 4,
    height: 4,
    transform: "translate(-0.084 0.195)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3297",
    "data-name": "Raggruppa 3297",
    transform: "translate(119.326 69.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3296",
    "data-name": "Raggruppa 3296",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1280",
    "data-name": "Rettangolo 1280",
    width: 3,
    height: 4,
    transform: "translate(-0.018 0.195)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3299",
    "data-name": "Raggruppa 3299",
    transform: "translate(122.698 69.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3298",
    "data-name": "Raggruppa 3298",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1281",
    "data-name": "Rettangolo 1281",
    width: 4,
    height: 4,
    transform: "translate(-0.391 0.195)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3301",
    "data-name": "Raggruppa 3301",
    transform: "translate(4.11 73.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3300",
    "data-name": "Raggruppa 3300",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1282",
    "data-name": "Rettangolo 1282",
    width: 3,
    height: 3,
    transform: "translate(0.198 0.261)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3303",
    "data-name": "Raggruppa 3303",
    transform: "translate(11.416 73.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3302",
    "data-name": "Raggruppa 3302",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1283",
    "data-name": "Rettangolo 1283",
    width: 4,
    height: 3,
    transform: "translate(-0.109 0.261)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3305",
    "data-name": "Raggruppa 3305",
    transform: "translate(15.351 73.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3304",
    "data-name": "Raggruppa 3304",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1284",
    "data-name": "Rettangolo 1284",
    width: 4,
    height: 3,
    transform: "translate(-0.043 0.261)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3307",
    "data-name": "Raggruppa 3307",
    transform: "translate(27.153 73.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3306",
    "data-name": "Raggruppa 3306",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1285",
    "data-name": "Rettangolo 1285",
    width: 3,
    height: 3,
    transform: "translate(0.154 0.261)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3309",
    "data-name": "Raggruppa 3309",
    transform: "translate(30.525 73.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3308",
    "data-name": "Raggruppa 3308",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1286",
    "data-name": "Rettangolo 1286",
    width: 4,
    height: 3,
    transform: "translate(-0.218 0.261)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3311",
    "data-name": "Raggruppa 3311",
    transform: "translate(34.46 73.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3310",
    "data-name": "Raggruppa 3310",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1287",
    "data-name": "Rettangolo 1287",
    width: 4,
    height: 3,
    transform: "translate(-0.152 0.261)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3313",
    "data-name": "Raggruppa 3313",
    transform: "translate(38.394 73.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3312",
    "data-name": "Raggruppa 3312",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1288",
    "data-name": "Rettangolo 1288",
    width: 4,
    height: 3,
    transform: "translate(-0.086 0.261)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3315",
    "data-name": "Raggruppa 3315",
    transform: "translate(46.262 73.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3314",
    "data-name": "Raggruppa 3314",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1289",
    "data-name": "Rettangolo 1289",
    width: 4,
    height: 3,
    transform: "translate(0.045 0.261)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3317",
    "data-name": "Raggruppa 3317",
    transform: "translate(65.371 73.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3316",
    "data-name": "Raggruppa 3316",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1290",
    "data-name": "Rettangolo 1290",
    width: 4,
    height: 3,
    transform: "translate(-0.064 0.261)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3319",
    "data-name": "Raggruppa 3319",
    transform: "translate(69.305 73.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3318",
    "data-name": "Raggruppa 3318",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1291",
    "data-name": "Rettangolo 1291",
    width: 4,
    height: 3,
    transform: "translate(0.002 0.261)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3321",
    "data-name": "Raggruppa 3321",
    transform: "translate(80.546 73.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3320",
    "data-name": "Raggruppa 3320",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1292",
    "data-name": "Rettangolo 1292",
    width: 4,
    height: 3,
    transform: "translate(-0.239 0.261)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3323",
    "data-name": "Raggruppa 3323",
    transform: "translate(84.48 73.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3322",
    "data-name": "Raggruppa 3322",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1293",
    "data-name": "Rettangolo 1293",
    width: 4,
    height: 3,
    transform: "translate(-0.173 0.261)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3325",
    "data-name": "Raggruppa 3325",
    transform: "translate(92.349 73.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3324",
    "data-name": "Raggruppa 3324",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1294",
    "data-name": "Rettangolo 1294",
    width: 4,
    height: 3,
    transform: "translate(-0.041 0.261)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3327",
    "data-name": "Raggruppa 3327",
    transform: "translate(96.283 73.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3326",
    "data-name": "Raggruppa 3326",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1295",
    "data-name": "Rettangolo 1295",
    width: 3,
    height: 3,
    transform: "translate(0.025 0.261)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3329",
    "data-name": "Raggruppa 3329",
    transform: "translate(103.589 73.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3328",
    "data-name": "Raggruppa 3328",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1296",
    "data-name": "Rettangolo 1296",
    width: 4,
    height: 3,
    transform: "translate(-0.282 0.261)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3331",
    "data-name": "Raggruppa 3331",
    transform: "translate(19.285 76.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3330",
    "data-name": "Raggruppa 3330",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1297",
    "data-name": "Rettangolo 1297",
    width: 4,
    height: 4,
    transform: "translate(0.023 -0.112)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3333",
    "data-name": "Raggruppa 3333",
    transform: "translate(23.219 76.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3332",
    "data-name": "Raggruppa 3332",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1298",
    "data-name": "Rettangolo 1298",
    width: 4,
    height: 4,
    transform: "translate(0.088 -0.112)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3335",
    "data-name": "Raggruppa 3335",
    transform: "translate(27.153 76.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3334",
    "data-name": "Raggruppa 3334",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1299",
    "data-name": "Rettangolo 1299",
    width: 3,
    height: 4,
    transform: "translate(0.154 -0.112)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3337",
    "data-name": "Raggruppa 3337",
    transform: "translate(34.46 76.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3336",
    "data-name": "Raggruppa 3336",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1300",
    "data-name": "Rettangolo 1300",
    width: 4,
    height: 4,
    transform: "translate(-0.152 -0.112)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3339",
    "data-name": "Raggruppa 3339",
    transform: "translate(46.262 76.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3338",
    "data-name": "Raggruppa 3338",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1301",
    "data-name": "Rettangolo 1301",
    width: 4,
    height: 4,
    transform: "translate(0.045 -0.112)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3341",
    "data-name": "Raggruppa 3341",
    transform: "translate(53.569 76.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3340",
    "data-name": "Raggruppa 3340",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1302",
    "data-name": "Rettangolo 1302",
    width: 4,
    height: 4,
    transform: "translate(-0.261 -0.112)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3343",
    "data-name": "Raggruppa 3343",
    transform: "translate(57.503 76.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3342",
    "data-name": "Raggruppa 3342",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1303",
    "data-name": "Rettangolo 1303",
    width: 4,
    height: 4,
    transform: "translate(-0.195 -0.112)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3345",
    "data-name": "Raggruppa 3345",
    transform: "translate(61.437 76.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3344",
    "data-name": "Raggruppa 3344",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1304",
    "data-name": "Rettangolo 1304",
    width: 4,
    height: 4,
    transform: "translate(-0.129 -0.112)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3347",
    "data-name": "Raggruppa 3347",
    transform: "translate(65.371 76.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3346",
    "data-name": "Raggruppa 3346",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1305",
    "data-name": "Rettangolo 1305",
    width: 4,
    height: 4,
    transform: "translate(-0.064 -0.112)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3349",
    "data-name": "Raggruppa 3349",
    transform: "translate(69.305 76.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3348",
    "data-name": "Raggruppa 3348",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1306",
    "data-name": "Rettangolo 1306",
    width: 4,
    height: 4,
    transform: "translate(0.002 -0.112)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3351",
    "data-name": "Raggruppa 3351",
    transform: "translate(80.546 76.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3350",
    "data-name": "Raggruppa 3350",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1307",
    "data-name": "Rettangolo 1307",
    width: 4,
    height: 4,
    transform: "translate(-0.239 -0.112)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3353",
    "data-name": "Raggruppa 3353",
    transform: "translate(92.349 76.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3352",
    "data-name": "Raggruppa 3352",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1308",
    "data-name": "Rettangolo 1308",
    width: 4,
    height: 4,
    transform: "translate(-0.041 -0.112)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3355",
    "data-name": "Raggruppa 3355",
    transform: "translate(96.283 76.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3354",
    "data-name": "Raggruppa 3354",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1309",
    "data-name": "Rettangolo 1309",
    width: 3,
    height: 4,
    transform: "translate(0.025 -0.112)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3357",
    "data-name": "Raggruppa 3357",
    transform: "translate(119.326 76.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3356",
    "data-name": "Raggruppa 3356",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1310",
    "data-name": "Rettangolo 1310",
    width: 3,
    height: 4,
    transform: "translate(-0.018 -0.112)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3359",
    "data-name": "Raggruppa 3359",
    transform: "translate(4.11 80.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3358",
    "data-name": "Raggruppa 3358",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1311",
    "data-name": "Rettangolo 1311",
    width: 3,
    height: 4,
    transform: "translate(0.198 -0.045)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3361",
    "data-name": "Raggruppa 3361",
    transform: "translate(11.416 80.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3360",
    "data-name": "Raggruppa 3360",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1312",
    "data-name": "Rettangolo 1312",
    width: 4,
    height: 4,
    transform: "translate(-0.109 -0.045)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3363",
    "data-name": "Raggruppa 3363",
    transform: "translate(15.351 80.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3362",
    "data-name": "Raggruppa 3362",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1313",
    "data-name": "Rettangolo 1313",
    width: 4,
    height: 4,
    transform: "translate(-0.043 -0.045)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3365",
    "data-name": "Raggruppa 3365",
    transform: "translate(19.285 80.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3364",
    "data-name": "Raggruppa 3364",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1314",
    "data-name": "Rettangolo 1314",
    width: 4,
    height: 4,
    transform: "translate(0.023 -0.045)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3367",
    "data-name": "Raggruppa 3367",
    transform: "translate(27.153 80.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3366",
    "data-name": "Raggruppa 3366",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1315",
    "data-name": "Rettangolo 1315",
    width: 3,
    height: 4,
    transform: "translate(0.154 -0.045)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3369",
    "data-name": "Raggruppa 3369",
    transform: "translate(34.46 80.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3368",
    "data-name": "Raggruppa 3368",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1316",
    "data-name": "Rettangolo 1316",
    width: 4,
    height: 4,
    transform: "translate(-0.152 -0.045)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3371",
    "data-name": "Raggruppa 3371",
    transform: "translate(38.394 80.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3370",
    "data-name": "Raggruppa 3370",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1317",
    "data-name": "Rettangolo 1317",
    width: 4,
    height: 4,
    transform: "translate(-0.086 -0.045)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3373",
    "data-name": "Raggruppa 3373",
    transform: "translate(46.262 80.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3372",
    "data-name": "Raggruppa 3372",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1318",
    "data-name": "Rettangolo 1318",
    width: 4,
    height: 4,
    transform: "translate(0.045 -0.045)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3375",
    "data-name": "Raggruppa 3375",
    transform: "translate(53.569 80.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3374",
    "data-name": "Raggruppa 3374",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1319",
    "data-name": "Rettangolo 1319",
    width: 4,
    height: 4,
    transform: "translate(-0.261 -0.045)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3377",
    "data-name": "Raggruppa 3377",
    transform: "translate(57.503 80.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3376",
    "data-name": "Raggruppa 3376",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1320",
    "data-name": "Rettangolo 1320",
    width: 4,
    height: 4,
    transform: "translate(-0.195 -0.045)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3379",
    "data-name": "Raggruppa 3379",
    transform: "translate(61.437 80.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3378",
    "data-name": "Raggruppa 3378",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1321",
    "data-name": "Rettangolo 1321",
    width: 4,
    height: 4,
    transform: "translate(-0.129 -0.045)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3381",
    "data-name": "Raggruppa 3381",
    transform: "translate(69.305 80.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3380",
    "data-name": "Raggruppa 3380",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1322",
    "data-name": "Rettangolo 1322",
    width: 4,
    height: 4,
    transform: "translate(0.002 -0.045)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3383",
    "data-name": "Raggruppa 3383",
    transform: "translate(73.239 80.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3382",
    "data-name": "Raggruppa 3382",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1323",
    "data-name": "Rettangolo 1323",
    width: 3,
    height: 4,
    transform: "translate(0.068 -0.045)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3385",
    "data-name": "Raggruppa 3385",
    transform: "translate(76.612 80.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3384",
    "data-name": "Raggruppa 3384",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1324",
    "data-name": "Rettangolo 1324",
    width: 4,
    height: 4,
    transform: "translate(-0.304 -0.045)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3387",
    "data-name": "Raggruppa 3387",
    transform: "translate(84.48 80.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3386",
    "data-name": "Raggruppa 3386",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1325",
    "data-name": "Rettangolo 1325",
    width: 4,
    height: 4,
    transform: "translate(-0.173 -0.045)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3389",
    "data-name": "Raggruppa 3389",
    transform: "translate(92.349 80.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3388",
    "data-name": "Raggruppa 3388",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1326",
    "data-name": "Rettangolo 1326",
    width: 4,
    height: 4,
    transform: "translate(-0.041 -0.045)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3391",
    "data-name": "Raggruppa 3391",
    transform: "translate(99.655 80.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3390",
    "data-name": "Raggruppa 3390",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1327",
    "data-name": "Rettangolo 1327",
    width: 4,
    height: 4,
    transform: "translate(-0.347 -0.045)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3393",
    "data-name": "Raggruppa 3393",
    transform: "translate(103.589 80.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3392",
    "data-name": "Raggruppa 3392",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1328",
    "data-name": "Rettangolo 1328",
    width: 4,
    height: 4,
    transform: "translate(-0.282 -0.045)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3395",
    "data-name": "Raggruppa 3395",
    transform: "translate(111.458 80.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3394",
    "data-name": "Raggruppa 3394",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1329",
    "data-name": "Rettangolo 1329",
    width: 4,
    height: 4,
    transform: "translate(-0.15 -0.045)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3397",
    "data-name": "Raggruppa 3397",
    transform: "translate(119.326 80.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3396",
    "data-name": "Raggruppa 3396",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1330",
    "data-name": "Rettangolo 1330",
    width: 3,
    height: 4,
    transform: "translate(-0.018 -0.045)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3399",
    "data-name": "Raggruppa 3399",
    transform: "translate(122.698 80.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3398",
    "data-name": "Raggruppa 3398",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1331",
    "data-name": "Rettangolo 1331",
    width: 4,
    height: 4,
    transform: "translate(-0.391 -0.045)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3401",
    "data-name": "Raggruppa 3401",
    transform: "translate(0.176 84.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3400",
    "data-name": "Raggruppa 3400",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1332",
    "data-name": "Rettangolo 1332",
    width: 4,
    height: 4,
    transform: "translate(0.132 0.02)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3403",
    "data-name": "Raggruppa 3403",
    transform: "translate(4.11 84.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3402",
    "data-name": "Raggruppa 3402",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1333",
    "data-name": "Rettangolo 1333",
    width: 3,
    height: 4,
    transform: "translate(0.198 0.02)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3405",
    "data-name": "Raggruppa 3405",
    transform: "translate(7.482 84.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3404",
    "data-name": "Raggruppa 3404",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1334",
    "data-name": "Rettangolo 1334",
    width: 4,
    height: 4,
    transform: "translate(-0.175 0.02)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3407",
    "data-name": "Raggruppa 3407",
    transform: "translate(15.351 84.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3406",
    "data-name": "Raggruppa 3406",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1335",
    "data-name": "Rettangolo 1335",
    width: 4,
    height: 4,
    transform: "translate(-0.043 0.02)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3409",
    "data-name": "Raggruppa 3409",
    transform: "translate(19.285 84.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3408",
    "data-name": "Raggruppa 3408",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1336",
    "data-name": "Rettangolo 1336",
    width: 4,
    height: 4,
    transform: "translate(0.023 0.02)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3411",
    "data-name": "Raggruppa 3411",
    transform: "translate(23.219 84.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3410",
    "data-name": "Raggruppa 3410",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1337",
    "data-name": "Rettangolo 1337",
    width: 4,
    height: 4,
    transform: "translate(0.088 0.02)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3413",
    "data-name": "Raggruppa 3413",
    transform: "translate(27.153 84.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3412",
    "data-name": "Raggruppa 3412",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1338",
    "data-name": "Rettangolo 1338",
    width: 3,
    height: 4,
    transform: "translate(0.154 0.02)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3415",
    "data-name": "Raggruppa 3415",
    transform: "translate(34.46 84.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3414",
    "data-name": "Raggruppa 3414",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1339",
    "data-name": "Rettangolo 1339",
    width: 4,
    height: 4,
    transform: "translate(-0.152 0.02)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3417",
    "data-name": "Raggruppa 3417",
    transform: "translate(42.328 84.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3416",
    "data-name": "Raggruppa 3416",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1340",
    "data-name": "Rettangolo 1340",
    width: 4,
    height: 4,
    transform: "translate(-0.021 0.02)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3419",
    "data-name": "Raggruppa 3419",
    transform: "translate(50.197 84.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3418",
    "data-name": "Raggruppa 3418",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1341",
    "data-name": "Rettangolo 1341",
    width: 3,
    height: 4,
    transform: "translate(0.111 0.02)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3421",
    "data-name": "Raggruppa 3421",
    transform: "translate(57.503 84.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3420",
    "data-name": "Raggruppa 3420",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1342",
    "data-name": "Rettangolo 1342",
    width: 4,
    height: 4,
    transform: "translate(-0.195 0.02)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3423",
    "data-name": "Raggruppa 3423",
    transform: "translate(76.612 84.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3422",
    "data-name": "Raggruppa 3422",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1343",
    "data-name": "Rettangolo 1343",
    width: 4,
    height: 4,
    transform: "translate(-0.304 0.02)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3425",
    "data-name": "Raggruppa 3425",
    transform: "translate(92.349 84.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3424",
    "data-name": "Raggruppa 3424",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1344",
    "data-name": "Rettangolo 1344",
    width: 4,
    height: 4,
    transform: "translate(-0.041 0.02)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3427",
    "data-name": "Raggruppa 3427",
    transform: "translate(96.283 84.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3426",
    "data-name": "Raggruppa 3426",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1345",
    "data-name": "Rettangolo 1345",
    width: 3,
    height: 4,
    transform: "translate(0.025 0.02)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3429",
    "data-name": "Raggruppa 3429",
    transform: "translate(99.655 84.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3428",
    "data-name": "Raggruppa 3428",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1346",
    "data-name": "Rettangolo 1346",
    width: 4,
    height: 4,
    transform: "translate(-0.347 0.02)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3431",
    "data-name": "Raggruppa 3431",
    transform: "translate(103.589 84.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3430",
    "data-name": "Raggruppa 3430",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1347",
    "data-name": "Rettangolo 1347",
    width: 4,
    height: 4,
    transform: "translate(-0.282 0.02)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3433",
    "data-name": "Raggruppa 3433",
    transform: "translate(111.458 84.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3432",
    "data-name": "Raggruppa 3432",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1348",
    "data-name": "Rettangolo 1348",
    width: 4,
    height: 4,
    transform: "translate(-0.15 0.02)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3435",
    "data-name": "Raggruppa 3435",
    transform: "translate(122.698 84.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3434",
    "data-name": "Raggruppa 3434",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1349",
    "data-name": "Rettangolo 1349",
    width: 4,
    height: 4,
    transform: "translate(-0.391 0.02)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3437",
    "data-name": "Raggruppa 3437",
    transform: "translate(4.11 88.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3436",
    "data-name": "Raggruppa 3436",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1350",
    "data-name": "Rettangolo 1350",
    width: 3,
    height: 4,
    transform: "translate(0.198 0.087)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3439",
    "data-name": "Raggruppa 3439",
    transform: "translate(11.416 88.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3438",
    "data-name": "Raggruppa 3438",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1351",
    "data-name": "Rettangolo 1351",
    width: 4,
    height: 4,
    transform: "translate(-0.109 0.087)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3441",
    "data-name": "Raggruppa 3441",
    transform: "translate(27.153 88.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3440",
    "data-name": "Raggruppa 3440",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1352",
    "data-name": "Rettangolo 1352",
    width: 3,
    height: 4,
    transform: "translate(0.154 0.087)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3443",
    "data-name": "Raggruppa 3443",
    transform: "translate(30.525 88.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3442",
    "data-name": "Raggruppa 3442",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1353",
    "data-name": "Rettangolo 1353",
    width: 4,
    height: 4,
    transform: "translate(-0.218 0.087)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3445",
    "data-name": "Raggruppa 3445",
    transform: "translate(34.46 88.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3444",
    "data-name": "Raggruppa 3444",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1354",
    "data-name": "Rettangolo 1354",
    width: 4,
    height: 4,
    transform: "translate(-0.152 0.087)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3447",
    "data-name": "Raggruppa 3447",
    transform: "translate(38.394 88.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3446",
    "data-name": "Raggruppa 3446",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1355",
    "data-name": "Rettangolo 1355",
    width: 4,
    height: 4,
    transform: "translate(-0.086 0.087)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3449",
    "data-name": "Raggruppa 3449",
    transform: "translate(42.328 88.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3448",
    "data-name": "Raggruppa 3448",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1356",
    "data-name": "Rettangolo 1356",
    width: 4,
    height: 4,
    transform: "translate(-0.021 0.087)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3451",
    "data-name": "Raggruppa 3451",
    transform: "translate(46.262 88.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3450",
    "data-name": "Raggruppa 3450",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1357",
    "data-name": "Rettangolo 1357",
    width: 4,
    height: 4,
    transform: "translate(0.045 0.087)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3453",
    "data-name": "Raggruppa 3453",
    transform: "translate(50.197 88.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3452",
    "data-name": "Raggruppa 3452",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1358",
    "data-name": "Rettangolo 1358",
    width: 3,
    height: 4,
    transform: "translate(0.111 0.087)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3455",
    "data-name": "Raggruppa 3455",
    transform: "translate(61.437 88.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3454",
    "data-name": "Raggruppa 3454",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1359",
    "data-name": "Rettangolo 1359",
    width: 4,
    height: 4,
    transform: "translate(-0.129 0.087)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3457",
    "data-name": "Raggruppa 3457",
    transform: "translate(69.305 88.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3456",
    "data-name": "Raggruppa 3456",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1360",
    "data-name": "Rettangolo 1360",
    width: 4,
    height: 4,
    transform: "translate(0.002 0.087)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3459",
    "data-name": "Raggruppa 3459",
    transform: "translate(80.546 88.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3458",
    "data-name": "Raggruppa 3458",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1361",
    "data-name": "Rettangolo 1361",
    width: 4,
    height: 4,
    transform: "translate(-0.239 0.087)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3461",
    "data-name": "Raggruppa 3461",
    transform: "translate(84.48 88.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3460",
    "data-name": "Raggruppa 3460",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1362",
    "data-name": "Rettangolo 1362",
    width: 4,
    height: 4,
    transform: "translate(-0.173 0.087)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3463",
    "data-name": "Raggruppa 3463",
    transform: "translate(107.523 88.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3462",
    "data-name": "Raggruppa 3462",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1363",
    "data-name": "Rettangolo 1363",
    width: 4,
    height: 4,
    transform: "translate(-0.216 0.087)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3465",
    "data-name": "Raggruppa 3465",
    transform: "translate(111.458 88.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3464",
    "data-name": "Raggruppa 3464",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1364",
    "data-name": "Rettangolo 1364",
    width: 4,
    height: 4,
    transform: "translate(-0.15 0.087)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3467",
    "data-name": "Raggruppa 3467",
    transform: "translate(122.698 88.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3466",
    "data-name": "Raggruppa 3466",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1365",
    "data-name": "Rettangolo 1365",
    width: 4,
    height: 4,
    transform: "translate(-0.391 0.087)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3469",
    "data-name": "Raggruppa 3469",
    transform: "translate(0.176 92.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3468",
    "data-name": "Raggruppa 3468",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1366",
    "data-name": "Rettangolo 1366",
    width: 4,
    height: 4,
    transform: "translate(0.132 0.152)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3471",
    "data-name": "Raggruppa 3471",
    transform: "translate(7.482 92.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3470",
    "data-name": "Raggruppa 3470",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1367",
    "data-name": "Rettangolo 1367",
    width: 4,
    height: 4,
    transform: "translate(-0.175 0.152)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3473",
    "data-name": "Raggruppa 3473",
    transform: "translate(11.416 92.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3472",
    "data-name": "Raggruppa 3472",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1368",
    "data-name": "Rettangolo 1368",
    width: 4,
    height: 4,
    transform: "translate(-0.109 0.152)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3475",
    "data-name": "Raggruppa 3475",
    transform: "translate(19.285 92.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3474",
    "data-name": "Raggruppa 3474",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1369",
    "data-name": "Rettangolo 1369",
    width: 4,
    height: 4,
    transform: "translate(0.023 0.152)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3477",
    "data-name": "Raggruppa 3477",
    transform: "translate(23.219 92.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3476",
    "data-name": "Raggruppa 3476",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1370",
    "data-name": "Rettangolo 1370",
    width: 4,
    height: 4,
    transform: "translate(0.088 0.152)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3479",
    "data-name": "Raggruppa 3479",
    transform: "translate(27.153 92.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3478",
    "data-name": "Raggruppa 3478",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1371",
    "data-name": "Rettangolo 1371",
    width: 3,
    height: 4,
    transform: "translate(0.154 0.152)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3481",
    "data-name": "Raggruppa 3481",
    transform: "translate(30.525 92.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3480",
    "data-name": "Raggruppa 3480",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1372",
    "data-name": "Rettangolo 1372",
    width: 4,
    height: 4,
    transform: "translate(-0.218 0.152)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3483",
    "data-name": "Raggruppa 3483",
    transform: "translate(38.394 92.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3482",
    "data-name": "Raggruppa 3482",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1373",
    "data-name": "Rettangolo 1373",
    width: 4,
    height: 4,
    transform: "translate(-0.086 0.152)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3485",
    "data-name": "Raggruppa 3485",
    transform: "translate(53.569 92.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3484",
    "data-name": "Raggruppa 3484",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1374",
    "data-name": "Rettangolo 1374",
    width: 4,
    height: 4,
    transform: "translate(-0.261 0.152)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3487",
    "data-name": "Raggruppa 3487",
    transform: "translate(57.503 92.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3486",
    "data-name": "Raggruppa 3486",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1375",
    "data-name": "Rettangolo 1375",
    width: 4,
    height: 4,
    transform: "translate(-0.195 0.152)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3489",
    "data-name": "Raggruppa 3489",
    transform: "translate(61.437 92.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3488",
    "data-name": "Raggruppa 3488",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1376",
    "data-name": "Rettangolo 1376",
    width: 4,
    height: 4,
    transform: "translate(-0.129 0.152)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3491",
    "data-name": "Raggruppa 3491",
    transform: "translate(65.371 92.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3490",
    "data-name": "Raggruppa 3490",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1377",
    "data-name": "Rettangolo 1377",
    width: 4,
    height: 4,
    transform: "translate(-0.064 0.152)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3493",
    "data-name": "Raggruppa 3493",
    transform: "translate(73.239 92.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3492",
    "data-name": "Raggruppa 3492",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1378",
    "data-name": "Rettangolo 1378",
    width: 3,
    height: 4,
    transform: "translate(0.068 0.152)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3495",
    "data-name": "Raggruppa 3495",
    transform: "translate(80.546 92.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3494",
    "data-name": "Raggruppa 3494",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1379",
    "data-name": "Rettangolo 1379",
    width: 4,
    height: 4,
    transform: "translate(-0.239 0.152)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3497",
    "data-name": "Raggruppa 3497",
    transform: "translate(88.414 92.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3496",
    "data-name": "Raggruppa 3496",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1380",
    "data-name": "Rettangolo 1380",
    width: 4,
    height: 4,
    transform: "translate(-0.107 0.152)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3499",
    "data-name": "Raggruppa 3499",
    transform: "translate(92.349 92.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3498",
    "data-name": "Raggruppa 3498",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1381",
    "data-name": "Rettangolo 1381",
    width: 4,
    height: 4,
    transform: "translate(-0.041 0.152)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3501",
    "data-name": "Raggruppa 3501",
    transform: "translate(96.283 92.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3500",
    "data-name": "Raggruppa 3500",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1382",
    "data-name": "Rettangolo 1382",
    width: 3,
    height: 4,
    transform: "translate(0.025 0.152)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3503",
    "data-name": "Raggruppa 3503",
    transform: "translate(99.655 92.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3502",
    "data-name": "Raggruppa 3502",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1383",
    "data-name": "Rettangolo 1383",
    width: 4,
    height: 4,
    transform: "translate(-0.347 0.152)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3505",
    "data-name": "Raggruppa 3505",
    transform: "translate(103.589 92.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3504",
    "data-name": "Raggruppa 3504",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1384",
    "data-name": "Rettangolo 1384",
    width: 4,
    height: 4,
    transform: "translate(-0.282 0.152)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3507",
    "data-name": "Raggruppa 3507",
    transform: "translate(107.523 92.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3506",
    "data-name": "Raggruppa 3506",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1385",
    "data-name": "Rettangolo 1385",
    width: 4,
    height: 4,
    transform: "translate(-0.216 0.152)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3509",
    "data-name": "Raggruppa 3509",
    transform: "translate(122.698 92.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3508",
    "data-name": "Raggruppa 3508",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1386",
    "data-name": "Rettangolo 1386",
    width: 4,
    height: 4,
    transform: "translate(-0.391 0.152)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3511",
    "data-name": "Raggruppa 3511",
    transform: "translate(30.525 96.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3510",
    "data-name": "Raggruppa 3510",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1387",
    "data-name": "Rettangolo 1387",
    width: 4,
    height: 3,
    transform: "translate(-0.218 0.219)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3513",
    "data-name": "Raggruppa 3513",
    transform: "translate(42.328 96.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3512",
    "data-name": "Raggruppa 3512",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1388",
    "data-name": "Rettangolo 1388",
    width: 4,
    height: 3,
    transform: "translate(-0.021 0.219)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3515",
    "data-name": "Raggruppa 3515",
    transform: "translate(46.262 96.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3514",
    "data-name": "Raggruppa 3514",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1389",
    "data-name": "Rettangolo 1389",
    width: 4,
    height: 3,
    transform: "translate(0.045 0.219)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3517",
    "data-name": "Raggruppa 3517",
    transform: "translate(50.197 96.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3516",
    "data-name": "Raggruppa 3516",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1390",
    "data-name": "Rettangolo 1390",
    width: 3,
    height: 3,
    transform: "translate(0.111 0.219)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3519",
    "data-name": "Raggruppa 3519",
    transform: "translate(69.305 96.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3518",
    "data-name": "Raggruppa 3518",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1391",
    "data-name": "Rettangolo 1391",
    width: 4,
    height: 3,
    transform: "translate(0.002 0.219)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3521",
    "data-name": "Raggruppa 3521",
    transform: "translate(73.239 96.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3520",
    "data-name": "Raggruppa 3520",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1392",
    "data-name": "Rettangolo 1392",
    width: 3,
    height: 3,
    transform: "translate(0.068 0.219)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3523",
    "data-name": "Raggruppa 3523",
    transform: "translate(80.546 96.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3522",
    "data-name": "Raggruppa 3522",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1393",
    "data-name": "Rettangolo 1393",
    width: 4,
    height: 3,
    transform: "translate(-0.239 0.219)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3525",
    "data-name": "Raggruppa 3525",
    transform: "translate(88.414 96.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3524",
    "data-name": "Raggruppa 3524",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1394",
    "data-name": "Rettangolo 1394",
    width: 4,
    height: 3,
    transform: "translate(-0.107 0.219)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3527",
    "data-name": "Raggruppa 3527",
    transform: "translate(92.349 96.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3526",
    "data-name": "Raggruppa 3526",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1395",
    "data-name": "Rettangolo 1395",
    width: 4,
    height: 3,
    transform: "translate(-0.041 0.219)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3529",
    "data-name": "Raggruppa 3529",
    transform: "translate(107.523 96.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3528",
    "data-name": "Raggruppa 3528",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1396",
    "data-name": "Rettangolo 1396",
    width: 4,
    height: 3,
    transform: "translate(-0.216 0.219)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3531",
    "data-name": "Raggruppa 3531",
    transform: "translate(111.458 96.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3530",
    "data-name": "Raggruppa 3530",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1397",
    "data-name": "Rettangolo 1397",
    width: 4,
    height: 3,
    transform: "translate(-0.15 0.219)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3533",
    "data-name": "Raggruppa 3533",
    transform: "translate(122.698 96.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3532",
    "data-name": "Raggruppa 3532",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1398",
    "data-name": "Rettangolo 1398",
    width: 4,
    height: 3,
    transform: "translate(-0.391 0.219)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3535",
    "data-name": "Raggruppa 3535",
    transform: "translate(38.394 99.655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3534",
    "data-name": "Raggruppa 3534",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1399",
    "data-name": "Rettangolo 1399",
    width: 4,
    height: 4,
    transform: "translate(-0.086 -0.155)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3537",
    "data-name": "Raggruppa 3537",
    transform: "translate(46.262 99.655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3536",
    "data-name": "Raggruppa 3536",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1400",
    "data-name": "Rettangolo 1400",
    width: 4,
    height: 4,
    transform: "translate(0.045 -0.155)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3539",
    "data-name": "Raggruppa 3539",
    transform: "translate(50.197 99.655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3538",
    "data-name": "Raggruppa 3538",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1401",
    "data-name": "Rettangolo 1401",
    width: 3,
    height: 4,
    transform: "translate(0.111 -0.155)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3541",
    "data-name": "Raggruppa 3541",
    transform: "translate(61.437 99.655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3540",
    "data-name": "Raggruppa 3540",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1402",
    "data-name": "Rettangolo 1402",
    width: 4,
    height: 4,
    transform: "translate(-0.129 -0.155)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3543",
    "data-name": "Raggruppa 3543",
    transform: "translate(80.546 99.655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3542",
    "data-name": "Raggruppa 3542",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1403",
    "data-name": "Rettangolo 1403",
    width: 4,
    height: 4,
    transform: "translate(-0.239 -0.155)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3545",
    "data-name": "Raggruppa 3545",
    transform: "translate(84.48 99.655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3544",
    "data-name": "Raggruppa 3544",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1404",
    "data-name": "Rettangolo 1404",
    width: 4,
    height: 4,
    transform: "translate(-0.173 -0.155)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3547",
    "data-name": "Raggruppa 3547",
    transform: "translate(92.349 99.655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3546",
    "data-name": "Raggruppa 3546",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1405",
    "data-name": "Rettangolo 1405",
    width: 4,
    height: 4,
    transform: "translate(-0.041 -0.155)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3549",
    "data-name": "Raggruppa 3549",
    transform: "translate(99.655 99.655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3548",
    "data-name": "Raggruppa 3548",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1406",
    "data-name": "Rettangolo 1406",
    width: 4,
    height: 4,
    transform: "translate(-0.347 -0.155)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3551",
    "data-name": "Raggruppa 3551",
    transform: "translate(107.523 99.655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3550",
    "data-name": "Raggruppa 3550",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1407",
    "data-name": "Rettangolo 1407",
    width: 4,
    height: 4,
    transform: "translate(-0.216 -0.155)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3553",
    "data-name": "Raggruppa 3553",
    transform: "translate(111.458 99.655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3552",
    "data-name": "Raggruppa 3552",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1408",
    "data-name": "Rettangolo 1408",
    width: 4,
    height: 4,
    transform: "translate(-0.15 -0.155)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3555",
    "data-name": "Raggruppa 3555",
    transform: "translate(115.392 99.655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3554",
    "data-name": "Raggruppa 3554",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1409",
    "data-name": "Rettangolo 1409",
    width: 4,
    height: 4,
    transform: "translate(-0.084 -0.155)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3557",
    "data-name": "Raggruppa 3557",
    transform: "translate(119.326 99.655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3556",
    "data-name": "Raggruppa 3556",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1410",
    "data-name": "Rettangolo 1410",
    width: 3,
    height: 4,
    transform: "translate(-0.018 -0.155)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3559",
    "data-name": "Raggruppa 3559",
    transform: "translate(30.525 103.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3558",
    "data-name": "Raggruppa 3558",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1411",
    "data-name": "Rettangolo 1411",
    width: 4,
    height: 4,
    transform: "translate(-0.218 -0.088)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3561",
    "data-name": "Raggruppa 3561",
    transform: "translate(38.394 103.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3560",
    "data-name": "Raggruppa 3560",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1412",
    "data-name": "Rettangolo 1412",
    width: 4,
    height: 4,
    transform: "translate(-0.086 -0.088)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3563",
    "data-name": "Raggruppa 3563",
    transform: "translate(50.197 103.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3562",
    "data-name": "Raggruppa 3562",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1413",
    "data-name": "Rettangolo 1413",
    width: 3,
    height: 4,
    transform: "translate(0.111 -0.088)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3565",
    "data-name": "Raggruppa 3565",
    transform: "translate(80.546 103.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3564",
    "data-name": "Raggruppa 3564",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1414",
    "data-name": "Rettangolo 1414",
    width: 4,
    height: 4,
    transform: "translate(-0.239 -0.088)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3567",
    "data-name": "Raggruppa 3567",
    transform: "translate(84.48 103.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3566",
    "data-name": "Raggruppa 3566",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1415",
    "data-name": "Rettangolo 1415",
    width: 4,
    height: 4,
    transform: "translate(-0.173 -0.088)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3569",
    "data-name": "Raggruppa 3569",
    transform: "translate(92.349 103.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3568",
    "data-name": "Raggruppa 3568",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1416",
    "data-name": "Rettangolo 1416",
    width: 4,
    height: 4,
    transform: "translate(-0.041 -0.088)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3571",
    "data-name": "Raggruppa 3571",
    transform: "translate(107.523 103.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3570",
    "data-name": "Raggruppa 3570",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1417",
    "data-name": "Rettangolo 1417",
    width: 4,
    height: 4,
    transform: "translate(-0.216 -0.088)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3573",
    "data-name": "Raggruppa 3573",
    transform: "translate(38.394 107.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3572",
    "data-name": "Raggruppa 3572",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1418",
    "data-name": "Rettangolo 1418",
    width: 4,
    height: 4,
    transform: "translate(-0.086 -0.023)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3575",
    "data-name": "Raggruppa 3575",
    transform: "translate(42.328 107.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3574",
    "data-name": "Raggruppa 3574",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1419",
    "data-name": "Rettangolo 1419",
    width: 4,
    height: 4,
    transform: "translate(-0.021 -0.023)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3577",
    "data-name": "Raggruppa 3577",
    transform: "translate(50.197 107.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3576",
    "data-name": "Raggruppa 3576",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1420",
    "data-name": "Rettangolo 1420",
    width: 3,
    height: 4,
    transform: "translate(0.111 -0.023)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3579",
    "data-name": "Raggruppa 3579",
    transform: "translate(53.569 107.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3578",
    "data-name": "Raggruppa 3578",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1421",
    "data-name": "Rettangolo 1421",
    width: 4,
    height: 4,
    transform: "translate(-0.261 -0.023)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3581",
    "data-name": "Raggruppa 3581",
    transform: "translate(61.437 107.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3580",
    "data-name": "Raggruppa 3580",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1422",
    "data-name": "Rettangolo 1422",
    width: 4,
    height: 4,
    transform: "translate(-0.129 -0.023)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3583",
    "data-name": "Raggruppa 3583",
    transform: "translate(73.239 107.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3582",
    "data-name": "Raggruppa 3582",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1423",
    "data-name": "Rettangolo 1423",
    width: 3,
    height: 4,
    transform: "translate(0.068 -0.023)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3585",
    "data-name": "Raggruppa 3585",
    transform: "translate(76.612 107.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3584",
    "data-name": "Raggruppa 3584",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1424",
    "data-name": "Rettangolo 1424",
    width: 4,
    height: 4,
    transform: "translate(-0.304 -0.023)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3587",
    "data-name": "Raggruppa 3587",
    transform: "translate(80.546 107.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3586",
    "data-name": "Raggruppa 3586",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1425",
    "data-name": "Rettangolo 1425",
    width: 4,
    height: 4,
    transform: "translate(-0.239 -0.023)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3589",
    "data-name": "Raggruppa 3589",
    transform: "translate(84.48 107.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3588",
    "data-name": "Raggruppa 3588",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1426",
    "data-name": "Rettangolo 1426",
    width: 4,
    height: 4,
    transform: "translate(-0.173 -0.023)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3591",
    "data-name": "Raggruppa 3591",
    transform: "translate(92.349 107.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3590",
    "data-name": "Raggruppa 3590",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1427",
    "data-name": "Rettangolo 1427",
    width: 4,
    height: 4,
    transform: "translate(-0.041 -0.023)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3593",
    "data-name": "Raggruppa 3593",
    transform: "translate(96.283 107.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3592",
    "data-name": "Raggruppa 3592",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1428",
    "data-name": "Rettangolo 1428",
    width: 3,
    height: 4,
    transform: "translate(0.025 -0.023)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3595",
    "data-name": "Raggruppa 3595",
    transform: "translate(99.655 107.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3594",
    "data-name": "Raggruppa 3594",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1429",
    "data-name": "Rettangolo 1429",
    width: 4,
    height: 4,
    transform: "translate(-0.347 -0.023)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3597",
    "data-name": "Raggruppa 3597",
    transform: "translate(103.589 107.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3596",
    "data-name": "Raggruppa 3596",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1430",
    "data-name": "Rettangolo 1430",
    width: 4,
    height: 4,
    transform: "translate(-0.282 -0.023)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3599",
    "data-name": "Raggruppa 3599",
    transform: "translate(107.523 107.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3598",
    "data-name": "Raggruppa 3598",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1431",
    "data-name": "Rettangolo 1431",
    width: 4,
    height: 4,
    transform: "translate(-0.216 -0.023)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3601",
    "data-name": "Raggruppa 3601",
    transform: "translate(111.458 107.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3600",
    "data-name": "Raggruppa 3600",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1432",
    "data-name": "Rettangolo 1432",
    width: 4,
    height: 4,
    transform: "translate(-0.15 -0.023)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3603",
    "data-name": "Raggruppa 3603",
    transform: "translate(119.326 107.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3602",
    "data-name": "Raggruppa 3602",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1433",
    "data-name": "Rettangolo 1433",
    width: 3,
    height: 4,
    transform: "translate(-0.018 -0.023)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3605",
    "data-name": "Raggruppa 3605",
    transform: "translate(122.698 107.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3604",
    "data-name": "Raggruppa 3604",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1434",
    "data-name": "Rettangolo 1434",
    width: 4,
    height: 4,
    transform: "translate(-0.391 -0.023)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3607",
    "data-name": "Raggruppa 3607",
    transform: "translate(30.525 111.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3606",
    "data-name": "Raggruppa 3606",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1435",
    "data-name": "Rettangolo 1435",
    width: 4,
    height: 4,
    transform: "translate(-0.218 0.044)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3609",
    "data-name": "Raggruppa 3609",
    transform: "translate(38.394 111.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3608",
    "data-name": "Raggruppa 3608",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1436",
    "data-name": "Rettangolo 1436",
    width: 4,
    height: 4,
    transform: "translate(-0.086 0.044)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3611",
    "data-name": "Raggruppa 3611",
    transform: "translate(46.262 111.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3610",
    "data-name": "Raggruppa 3610",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1437",
    "data-name": "Rettangolo 1437",
    width: 4,
    height: 4,
    transform: "translate(0.045 0.044)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3613",
    "data-name": "Raggruppa 3613",
    transform: "translate(50.197 111.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3612",
    "data-name": "Raggruppa 3612",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1438",
    "data-name": "Rettangolo 1438",
    width: 3,
    height: 4,
    transform: "translate(0.111 0.044)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3615",
    "data-name": "Raggruppa 3615",
    transform: "translate(53.569 111.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3614",
    "data-name": "Raggruppa 3614",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1439",
    "data-name": "Rettangolo 1439",
    width: 4,
    height: 4,
    transform: "translate(-0.261 0.044)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3617",
    "data-name": "Raggruppa 3617",
    transform: "translate(57.503 111.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3616",
    "data-name": "Raggruppa 3616",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1440",
    "data-name": "Rettangolo 1440",
    width: 4,
    height: 4,
    transform: "translate(-0.195 0.044)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3619",
    "data-name": "Raggruppa 3619",
    transform: "translate(73.239 111.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3618",
    "data-name": "Raggruppa 3618",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1441",
    "data-name": "Rettangolo 1441",
    width: 3,
    height: 4,
    transform: "translate(0.068 0.044)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3621",
    "data-name": "Raggruppa 3621",
    transform: "translate(76.612 111.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3620",
    "data-name": "Raggruppa 3620",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1442",
    "data-name": "Rettangolo 1442",
    width: 4,
    height: 4,
    transform: "translate(-0.304 0.044)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3623",
    "data-name": "Raggruppa 3623",
    transform: "translate(80.546 111.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3622",
    "data-name": "Raggruppa 3622",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1443",
    "data-name": "Rettangolo 1443",
    width: 4,
    height: 4,
    transform: "translate(-0.239 0.044)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3625",
    "data-name": "Raggruppa 3625",
    transform: "translate(84.48 111.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3624",
    "data-name": "Raggruppa 3624",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1444",
    "data-name": "Rettangolo 1444",
    width: 4,
    height: 4,
    transform: "translate(-0.173 0.044)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3627",
    "data-name": "Raggruppa 3627",
    transform: "translate(88.414 111.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3626",
    "data-name": "Raggruppa 3626",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1445",
    "data-name": "Rettangolo 1445",
    width: 4,
    height: 4,
    transform: "translate(-0.107 0.044)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3629",
    "data-name": "Raggruppa 3629",
    transform: "translate(99.655 111.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3628",
    "data-name": "Raggruppa 3628",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1446",
    "data-name": "Rettangolo 1446",
    width: 4,
    height: 4,
    transform: "translate(-0.347 0.044)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3631",
    "data-name": "Raggruppa 3631",
    transform: "translate(107.523 111.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3630",
    "data-name": "Raggruppa 3630",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1447",
    "data-name": "Rettangolo 1447",
    width: 4,
    height: 4,
    transform: "translate(-0.216 0.044)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3633",
    "data-name": "Raggruppa 3633",
    transform: "translate(111.458 111.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3632",
    "data-name": "Raggruppa 3632",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1448",
    "data-name": "Rettangolo 1448",
    width: 4,
    height: 4,
    transform: "translate(-0.15 0.044)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3635",
    "data-name": "Raggruppa 3635",
    transform: "translate(115.392 111.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3634",
    "data-name": "Raggruppa 3634",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1449",
    "data-name": "Rettangolo 1449",
    width: 4,
    height: 4,
    transform: "translate(-0.084 0.044)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3637",
    "data-name": "Raggruppa 3637",
    transform: "translate(38.394 115.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3636",
    "data-name": "Raggruppa 3636",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1450",
    "data-name": "Rettangolo 1450",
    width: 4,
    height: 4,
    transform: "translate(-0.086 0.109)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3639",
    "data-name": "Raggruppa 3639",
    transform: "translate(53.569 115.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3638",
    "data-name": "Raggruppa 3638",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1451",
    "data-name": "Rettangolo 1451",
    width: 4,
    height: 4,
    transform: "translate(-0.261 0.109)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3641",
    "data-name": "Raggruppa 3641",
    transform: "translate(69.305 115.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3640",
    "data-name": "Raggruppa 3640",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1452",
    "data-name": "Rettangolo 1452",
    width: 4,
    height: 4,
    transform: "translate(0.002 0.109)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3643",
    "data-name": "Raggruppa 3643",
    transform: "translate(76.612 115.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3642",
    "data-name": "Raggruppa 3642",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1453",
    "data-name": "Rettangolo 1453",
    width: 4,
    height: 4,
    transform: "translate(-0.304 0.109)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3645",
    "data-name": "Raggruppa 3645",
    transform: "translate(84.48 115.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3644",
    "data-name": "Raggruppa 3644",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1454",
    "data-name": "Rettangolo 1454",
    width: 4,
    height: 4,
    transform: "translate(-0.173 0.109)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3647",
    "data-name": "Raggruppa 3647",
    transform: "translate(92.349 115.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3646",
    "data-name": "Raggruppa 3646",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1455",
    "data-name": "Rettangolo 1455",
    width: 4,
    height: 4,
    transform: "translate(-0.041 0.109)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3649",
    "data-name": "Raggruppa 3649",
    transform: "translate(107.523 115.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3648",
    "data-name": "Raggruppa 3648",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1456",
    "data-name": "Rettangolo 1456",
    width: 4,
    height: 4,
    transform: "translate(-0.216 0.109)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3651",
    "data-name": "Raggruppa 3651",
    transform: "translate(111.458 115.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3650",
    "data-name": "Raggruppa 3650",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1457",
    "data-name": "Rettangolo 1457",
    width: 4,
    height: 4,
    transform: "translate(-0.15 0.109)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3653",
    "data-name": "Raggruppa 3653",
    transform: "translate(122.698 115.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3652",
    "data-name": "Raggruppa 3652",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1458",
    "data-name": "Rettangolo 1458",
    width: 4,
    height: 4,
    transform: "translate(-0.391 0.109)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3655",
    "data-name": "Raggruppa 3655",
    transform: "translate(38.394 119.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3654",
    "data-name": "Raggruppa 3654",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1459",
    "data-name": "Rettangolo 1459",
    width: 4,
    height: 3,
    transform: "translate(-0.086 0.175)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3657",
    "data-name": "Raggruppa 3657",
    transform: "translate(46.262 119.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3656",
    "data-name": "Raggruppa 3656",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1460",
    "data-name": "Rettangolo 1460",
    width: 4,
    height: 3,
    transform: "translate(0.045 0.175)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3659",
    "data-name": "Raggruppa 3659",
    transform: "translate(50.197 119.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3658",
    "data-name": "Raggruppa 3658",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1461",
    "data-name": "Rettangolo 1461",
    width: 3,
    height: 3,
    transform: "translate(0.111 0.175)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3661",
    "data-name": "Raggruppa 3661",
    transform: "translate(53.569 119.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3660",
    "data-name": "Raggruppa 3660",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1462",
    "data-name": "Rettangolo 1462",
    width: 4,
    height: 3,
    transform: "translate(-0.261 0.175)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3663",
    "data-name": "Raggruppa 3663",
    transform: "translate(57.503 119.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3662",
    "data-name": "Raggruppa 3662",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1463",
    "data-name": "Rettangolo 1463",
    width: 4,
    height: 3,
    transform: "translate(-0.195 0.175)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3665",
    "data-name": "Raggruppa 3665",
    transform: "translate(61.437 119.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3664",
    "data-name": "Raggruppa 3664",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1464",
    "data-name": "Rettangolo 1464",
    width: 4,
    height: 3,
    transform: "translate(-0.129 0.175)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3667",
    "data-name": "Raggruppa 3667",
    transform: "translate(65.371 119.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3666",
    "data-name": "Raggruppa 3666",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1465",
    "data-name": "Rettangolo 1465",
    width: 4,
    height: 3,
    transform: "translate(-0.064 0.175)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3669",
    "data-name": "Raggruppa 3669",
    transform: "translate(73.239 119.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3668",
    "data-name": "Raggruppa 3668",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1466",
    "data-name": "Rettangolo 1466",
    width: 3,
    height: 3,
    transform: "translate(0.068 0.175)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3671",
    "data-name": "Raggruppa 3671",
    transform: "translate(76.612 119.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3670",
    "data-name": "Raggruppa 3670",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1467",
    "data-name": "Rettangolo 1467",
    width: 4,
    height: 3,
    transform: "translate(-0.304 0.175)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3673",
    "data-name": "Raggruppa 3673",
    transform: "translate(80.546 119.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3672",
    "data-name": "Raggruppa 3672",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1468",
    "data-name": "Rettangolo 1468",
    width: 4,
    height: 3,
    transform: "translate(-0.239 0.175)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3675",
    "data-name": "Raggruppa 3675",
    transform: "translate(84.48 119.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3674",
    "data-name": "Raggruppa 3674",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1469",
    "data-name": "Rettangolo 1469",
    width: 4,
    height: 3,
    transform: "translate(-0.173 0.175)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3677",
    "data-name": "Raggruppa 3677",
    transform: "translate(88.414 119.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3676",
    "data-name": "Raggruppa 3676",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1470",
    "data-name": "Rettangolo 1470",
    width: 4,
    height: 3,
    transform: "translate(-0.107 0.175)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3679",
    "data-name": "Raggruppa 3679",
    transform: "translate(92.349 119.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3678",
    "data-name": "Raggruppa 3678",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1471",
    "data-name": "Rettangolo 1471",
    width: 4,
    height: 3,
    transform: "translate(-0.041 0.175)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3681",
    "data-name": "Raggruppa 3681",
    transform: "translate(96.283 119.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3680",
    "data-name": "Raggruppa 3680",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1472",
    "data-name": "Rettangolo 1472",
    width: 3,
    height: 3,
    transform: "translate(0.025 0.175)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3683",
    "data-name": "Raggruppa 3683",
    transform: "translate(30.525 122.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3682",
    "data-name": "Raggruppa 3682",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1473",
    "data-name": "Rettangolo 1473",
    width: 4,
    height: 4,
    transform: "translate(-0.218 -0.198)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3685",
    "data-name": "Raggruppa 3685",
    transform: "translate(38.394 122.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3684",
    "data-name": "Raggruppa 3684",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1474",
    "data-name": "Rettangolo 1474",
    width: 4,
    height: 4,
    transform: "translate(-0.086 -0.198)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3687",
    "data-name": "Raggruppa 3687",
    transform: "translate(42.328 122.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3686",
    "data-name": "Raggruppa 3686",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1475",
    "data-name": "Rettangolo 1475",
    width: 4,
    height: 4,
    transform: "translate(-0.021 -0.198)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3689",
    "data-name": "Raggruppa 3689",
    transform: "translate(53.569 122.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3688",
    "data-name": "Raggruppa 3688",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1476",
    "data-name": "Rettangolo 1476",
    width: 4,
    height: 4,
    transform: "translate(-0.261 -0.198)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3691",
    "data-name": "Raggruppa 3691",
    transform: "translate(76.612 122.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3690",
    "data-name": "Raggruppa 3690",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1477",
    "data-name": "Rettangolo 1477",
    width: 4,
    height: 4,
    transform: "translate(-0.304 -0.198)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3693",
    "data-name": "Raggruppa 3693",
    transform: "translate(80.546 122.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3692",
    "data-name": "Raggruppa 3692",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1478",
    "data-name": "Rettangolo 1478",
    width: 4,
    height: 4,
    transform: "translate(-0.239 -0.198)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3695",
    "data-name": "Raggruppa 3695",
    transform: "translate(84.48 122.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3694",
    "data-name": "Raggruppa 3694",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1479",
    "data-name": "Rettangolo 1479",
    width: 4,
    height: 4,
    transform: "translate(-0.173 -0.198)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3697",
    "data-name": "Raggruppa 3697",
    transform: "translate(92.349 122.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3696",
    "data-name": "Raggruppa 3696",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1480",
    "data-name": "Rettangolo 1480",
    width: 4,
    height: 4,
    transform: "translate(-0.041 -0.198)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3699",
    "data-name": "Raggruppa 3699",
    transform: "translate(107.523 122.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3698",
    "data-name": "Raggruppa 3698",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1481",
    "data-name": "Rettangolo 1481",
    width: 4,
    height: 4,
    transform: "translate(-0.216 -0.198)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3701",
    "data-name": "Raggruppa 3701",
    transform: "translate(111.458 122.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3700",
    "data-name": "Raggruppa 3700",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1482",
    "data-name": "Rettangolo 1482",
    width: 4,
    height: 4,
    transform: "translate(-0.15 -0.198)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3703",
    "data-name": "Raggruppa 3703",
    transform: "translate(119.326 122.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3702",
    "data-name": "Raggruppa 3702",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1483",
    "data-name": "Rettangolo 1483",
    width: 3,
    height: 4,
    transform: "translate(-0.018 -0.198)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3706",
    "data-name": "Raggruppa 3706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3705",
    "data-name": "Raggruppa 3705"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3704",
    "data-name": "Raggruppa 3704"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1484",
    "data-name": "Rettangolo 1484",
    width: 18.829,
    height: 18.829,
    transform: "translate(4.035 4.035)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4610",
    "data-name": "Tracciato 4610",
    d: "M22.864,0H0V26.9H26.9V0Zm0,22.864H4.035V4.035H22.864Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3709",
    "data-name": "Raggruppa 3709",
    transform: "translate(99.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3708",
    "data-name": "Raggruppa 3708"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3707",
    "data-name": "Raggruppa 3707"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1485",
    "data-name": "Rettangolo 1485",
    width: 18.829,
    height: 18.829,
    transform: "translate(4.035 4.035)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4611",
    "data-name": "Tracciato 4611",
    d: "M22.864,0H0V26.9H26.9V0Zm0,22.864H4.035V4.035H22.864Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3712",
    "data-name": "Raggruppa 3712",
    transform: "translate(0 99.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3711",
    "data-name": "Raggruppa 3711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3710",
    "data-name": "Raggruppa 3710"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1486",
    "data-name": "Rettangolo 1486",
    width: 18.829,
    height: 18.829,
    transform: "translate(4.035 4.035)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4612",
    "data-name": "Tracciato 4612",
    d: "M22.864,0H0V26.9H26.9V0Zm0,22.864H4.035V4.035H22.864Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3714",
    "data-name": "Raggruppa 3714",
    transform: "translate(7.482 7.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3713",
    "data-name": "Raggruppa 3713",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1487",
    "data-name": "Rettangolo 1487",
    width: 12,
    height: 12,
    transform: "translate(-0.175 0.018)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3716",
    "data-name": "Raggruppa 3716",
    transform: "translate(107.523 7.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3715",
    "data-name": "Raggruppa 3715",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1488",
    "data-name": "Rettangolo 1488",
    width: 12,
    height: 12,
    transform: "translate(-0.216 0.018)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3718",
    "data-name": "Raggruppa 3718",
    transform: "translate(7.482 107.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3717",
    "data-name": "Raggruppa 3717",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1489",
    "data-name": "Rettangolo 1489",
    width: 12,
    height: 12,
    transform: "translate(-0.175 -0.023)",
    fill: "#fff"
  })))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4616",
    "data-name": "Tracciato 4616",
    d: "M-77.192-8.875l1.266-4.562H-78.52l-1.219,4.563Zm-8.844,0h3.172l1.234-4.562h-3.187l.7-2.625h3.188l1.7-6.3h3.109l-1.7,6.3h2.594l1.656-6.3h3.109l-1.656,6.3h3.141l-.7,2.625h-3.141l-1.266,4.563h3.188l-.7,2.625h-3.187L-76.457,0h-3.109l1.672-6.25h-2.562L-82.16,0H-85.27l1.7-6.25h-3.172Zm22.182-13.749a3.492,3.492,0,0,0-2.72.832c-.8.8-.864,1.792-.864,3.072V-3.552a3.92,3.92,0,0,0,.9,3.04,2.8,2.8,0,0,0,1.92.7,2.734,2.734,0,0,0,1.888-.7,3.858,3.858,0,0,0,.928-3.04V-8.576c1.5,0,1.952,0,2.368.384.512.448.544,1.12.608,2.432l.1,2.688C-58.67-1.92-58.478.192-55.95.192a2.689,2.689,0,0,0,2.112-.8,3.516,3.516,0,0,0,.672-2.72l-.1-2.272c-.16-2.368-.192-2.912-.672-3.744a3.351,3.351,0,0,0-2.144-1.6,3.652,3.652,0,0,0,2.24-1.888,6.63,6.63,0,0,0,.576-3.136c0-6.08-3.04-6.624-7.136-6.656Zm2.048,4.608c1.728,0,2.3,0,2.72.736a4.218,4.218,0,0,1,.32,1.856,2.284,2.284,0,0,1-.672,1.92c-.48.32-.864.32-2.368.32Zm14.816-4.576a4.085,4.085,0,0,0-2.752.672,3.6,3.6,0,0,0-1.056,3.1V-3.68c0,1.12,0,2.176.8,2.912A4.012,4.012,0,0,0-47.022,0h6.144a3.179,3.179,0,0,0,2.5-.736,2.074,2.074,0,0,0,.608-1.536A2.206,2.206,0,0,0-38.35-3.84a3.021,3.021,0,0,0-2.464-.768h-4.352V-9.472h3.712c.9,0,2.3-.032,2.784-1.44a2.9,2.9,0,0,0,.128-.8,2.282,2.282,0,0,0-.512-1.472,3.243,3.243,0,0,0-2.4-.768h-3.712v-4.032h4.1a3.547,3.547,0,0,0,2.528-.672,2.02,2.02,0,0,0,.672-1.6c0-2.336-2.3-2.336-3.232-2.336Zm20.768,4.576a2.835,2.835,0,0,0,2.464-.864,2.293,2.293,0,0,0,.48-1.44,2.121,2.121,0,0,0-.448-1.376,2.893,2.893,0,0,0-2.56-.9h-7.968a2.782,2.782,0,0,0-2.464.832,1.991,1.991,0,0,0-.512,1.44,2.124,2.124,0,0,0,.576,1.568,2.834,2.834,0,0,0,2.4.736h1.184V-3.584A3.672,3.672,0,0,0-32.046-.448a2.934,2.934,0,0,0,1.856.64c2.72,0,2.752-2.624,2.752-3.936V-18.016ZM-16.11-19.2a3.912,3.912,0,0,0-.832-2.88,2.75,2.75,0,0,0-1.952-.736,2.875,2.875,0,0,0-1.856.608,3.621,3.621,0,0,0-.992,3.008V-3.552c0,1.152.032,2.912,1.792,3.52A3.116,3.116,0,0,0-18.862.16a2.561,2.561,0,0,0,2.048-.9,4.151,4.151,0,0,0,.7-2.848V-9.472h3.68v5.824A3.845,3.845,0,0,0-11.438-.48,2.733,2.733,0,0,0-9.55.16,2.381,2.381,0,0,0-7.6-.64a4.078,4.078,0,0,0,.8-2.976v-15.52c-.032-1.152-.032-2.944-1.824-3.552a3.53,3.53,0,0,0-.992-.128,2.585,2.585,0,0,0-1.856.64,3.693,3.693,0,0,0-.96,3.04v5.024h-3.68ZM-3.758-3.488A3.889,3.889,0,0,0-2.926-.544,2.657,2.657,0,0,0-.974.192,2.561,2.561,0,0,0,1.01-.576a3.823,3.823,0,0,0,.864-2.976V-19.1a3.743,3.743,0,0,0-.992-3.072,2.743,2.743,0,0,0-1.824-.608,2.966,2.966,0,0,0-1.728.512A3.448,3.448,0,0,0-3.758-19.2Zm8.64.192c0,1.12.032,2.816,1.7,3.36a3.874,3.874,0,0,0,.96.128A2.236,2.236,0,0,0,9.81-1.344a5.917,5.917,0,0,0,.224-1.984V-9.216a38.092,38.092,0,0,0-.64-7.456c.7,2.784.9,3.424,1.7,5.856l2.432,7.2C14.418-1.088,14.8,0,17.362,0a4.5,4.5,0,0,0,2.56-.448c1.216-.7,1.28-1.952,1.28-3.328V-19.424c-.032-1.056-.064-2.656-1.7-3.2a2.973,2.973,0,0,0-.928-.16,2.161,2.161,0,0,0-1.568.544,3.327,3.327,0,0,0-.9,2.784v5.024a42.9,42.9,0,0,0,.7,7.968L12.594-18.912c-1.056-3.1-1.376-3.68-4.16-3.68-1.312,0-2.688.064-3.264,1.632a10.035,10.035,0,0,0-.288,3.1ZM29.81-19.232a3.661,3.661,0,0,0-.864-2.816,2.51,2.51,0,0,0-1.92-.768,2.641,2.641,0,0,0-1.952.8,3.7,3.7,0,0,0-.864,2.848v15.68a3.874,3.874,0,0,0,.832,2.88A2.6,2.6,0,0,0,26.994.16c2.3,0,2.816-1.888,2.816-3.84V-10.3l2.912,7.488C33.2-1.568,33.906.16,35.89.16a2.593,2.593,0,0,0,2.784-2.592,5.376,5.376,0,0,0-.7-2.336l-3.3-6.944,3.168-6.656a4.39,4.39,0,0,0,.48-1.76,2.664,2.664,0,0,0-2.752-2.688c-1.7,0-2.272,1.376-2.656,2.368l-3.1,8.032Zm14.016-3.392a3.492,3.492,0,0,0-2.72.832c-.8.8-.864,1.792-.864,3.072V-3.552a3.92,3.92,0,0,0,.9,3.04,2.8,2.8,0,0,0,1.92.7,2.734,2.734,0,0,0,1.888-.7,3.858,3.858,0,0,0,.928-3.04V-8.576c1.5,0,1.952,0,2.368.384.512.448.544,1.12.608,2.432l.1,2.688C49.01-1.92,49.2.192,51.73.192a2.689,2.689,0,0,0,2.112-.8,3.516,3.516,0,0,0,.672-2.72l-.1-2.272c-.16-2.368-.192-2.912-.672-3.744a3.351,3.351,0,0,0-2.144-1.6,3.652,3.652,0,0,0,2.24-1.888,6.63,6.63,0,0,0,.576-3.136c0-6.08-3.04-6.624-7.136-6.656Zm2.048,4.608c1.728,0,2.3,0,2.72.736a4.218,4.218,0,0,1,.32,1.856,2.284,2.284,0,0,1-.672,1.92c-.48.32-.864.32-2.368.32Zm21.6,2.752a2.514,2.514,0,0,0,2.56-2.816,4.33,4.33,0,0,0-.9-2.688c-1.472-1.952-4.064-2.144-5.408-2.144-4.416,0-7.168,2.5-7.168,6.688,0,3.616,2.368,5.12,4.48,6.5.544.352,1.056.7,1.6,1.056,1.5.928,2.432,1.536,2.432,2.784A1.884,1.884,0,0,1,63.122-4a1.759,1.759,0,0,1-1.76-1.312,5.264,5.264,0,0,1-.16-1.024A2.356,2.356,0,0,0,60.53-7.9,2.339,2.339,0,0,0,58.8-8.576c-1.856,0-2.752,1.5-2.752,3.232A5.223,5.223,0,0,0,59.186-.48,9.975,9.975,0,0,0,63.25.288c4.864,0,7.552-2.88,7.552-6.848,0-3.456-1.952-4.9-3.52-5.952-.864-.608-2.3-1.536-3.2-2.144-1.184-.8-2.048-1.408-2.048-2.464a1.423,1.423,0,0,1,1.5-1.408,1.4,1.4,0,0,1,1.44.96c.064.224.128.48.192.736A2.266,2.266,0,0,0,67.474-15.264Zm8,12.416C75.986-.768,76.53,0,78.994,0c2.4,0,3.168-.352,3.744-2.752L86.45-18.528a6.947,6.947,0,0,0,.256-1.6,2.551,2.551,0,0,0-2.656-2.656c-2.4,0-2.816,2.208-3.04,3.328C80.178-15.072,79.6-10.3,79.122-6.4c-.544-4.32-1.152-8.672-2.08-12.96-.384-1.76-.832-3.424-2.848-3.424A2.651,2.651,0,0,0,71.41-20a6.6,6.6,0,0,0,.224,1.536Z",
    transform: "translate(671 456)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.cd49badcccdd669a63af9ef70e79bdb5.svg";
export { ForwardRef as ReactComponent };